(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["weston-carry-message-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCarry = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const tabs = [...root.querySelectorAll('[data-carry-tab]')];
      const panels = [...root.querySelectorAll('[data-carry-panel]')];

      const activate = (tab, focus = false) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
        if (focus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next], true);
        });
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-carry]')) initCarry(scope);
      scope.querySelectorAll('[data-weston-carry]').forEach(initCarry);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-collection-compass-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll?.('[data-wcc-root]').forEach((root) => {
        if (root.dataset.wccReady === 'true') return;
        root.dataset.wccReady = 'true';
        root.querySelector('[data-wcc-open-command]')?.addEventListener('click', () => {
          if (window.__westonExperienceCommandCenter2026?.open) window.__westonExperienceCommandCenter2026.open();
          else document.querySelector('[data-wxc-open]')?.click();
        });
        root.querySelector('[data-wcc-open-constellation]')?.addEventListener('click', (event) => {
          document.dispatchEvent(new CustomEvent('weston:surface-request', { detail: { surface: 'constellation', returnFocusTarget: event.currentTarget } }));
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-constellation-2026"] && !Shopify.designMode) return;
  try {
    
  const initializeWestonConstellations = (scope = document) => {
    scope.querySelectorAll('[data-wg-constellation]').forEach((root) => {
      if (root.dataset.wgReady === 'true') return;
      root.dataset.wgReady = 'true';

      const launcher = root.querySelector('[data-wg-constellation-open]');
      const launcherLabel = root.querySelector('[data-wg-launcher-label]');
      const panel = root.querySelector('[data-wg-constellation-panel]');
      const closeButton = root.querySelector('[data-wg-constellation-close]');
      const form = root.querySelector('[data-wg-constellation-form]');
      const steps = Array.from(root.querySelectorAll('[data-wg-step]'));
      const nextButton = root.querySelector('[data-wg-next]');
      const backButton = root.querySelector('[data-wg-back]');
      const progressLabel = root.querySelector('[data-wg-step-label]');
      const progressBar = root.querySelector('[data-wg-progress-bar]');
      const results = root.querySelector('[data-wg-results]');
      const worlds = Array.from(root.querySelectorAll('[data-wg-world]'));
      const restartButton = root.querySelector('[data-wg-restart]');
      const storageKey = 'weston-constellation-profile-v1';
      const defaultLauncherLabel = launcherLabel.textContent;
      let currentStep = 0;
      let savedWorldKey = '';
      let returnFocusTarget = launcher;

      const readProfile = () => {
        try {
          return JSON.parse(window.localStorage.getItem(storageKey) || 'null');
        } catch (error) {
          return null;
        }
      };

      const writeProfile = (profile) => {
        try {
          window.localStorage.setItem(storageKey, JSON.stringify(profile));
        } catch (error) {
          return;
        }
      };

      const selectedValue = (name) => form.querySelector(`input[name="${name}"]:checked`)?.value || '';

      const updateStep = () => {
        steps.forEach((step, index) => {
          step.hidden = index !== currentStep;
        });
        backButton.hidden = currentStep === 0;
        const activeName = ['audience', 'mood', 'moment'][currentStep];
        nextButton.disabled = selectedValue(activeName) === '';
        nextButton.textContent = currentStep === steps.length - 1 ? nextButton.dataset.findLabel : nextButton.dataset.nextLabel;
        progressLabel.textContent = progressLabel.dataset.stepTemplate
          .replace('[current]', currentStep + 1)
          .replace('[total]', steps.length);
        progressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;
      };

      const scoreWorld = (world, profile) => {
        let score = 0;
        if (world.dataset.audience === profile.audience) score += 6;
        if (world.dataset.audience === 'all') score += 1;
        if (world.dataset.mood === profile.mood) score += 3;
        if (world.dataset.mood === 'any') score += 0.5;
        if (world.dataset.moment === profile.moment) score += 4;
        if (world.dataset.moment === 'any') score += 0.5;
        return score;
      };

      const showWorld = (world, profile, shouldSave = true) => {
        if (!world) return;
        worlds.forEach((item) => {
          item.hidden = item !== world;
        });
        form.hidden = true;
        results.hidden = false;
        savedWorldKey = world.dataset.worldKey;
        launcherLabel.textContent = world.dataset.worldTitle || launcherLabel.textContent;
        if (shouldSave) {
          writeProfile({ ...profile, worldKey: savedWorldKey });
          window.dispatchEvent(new CustomEvent('weston:constellation-complete', { detail: profile }));
        }
        world.querySelector('a, button')?.focus({ preventScroll: true });
      };

      const completeProfile = () => {
        const profile = {
          audience: selectedValue('audience'),
          mood: selectedValue('mood'),
          moment: selectedValue('moment')
        };
        const bestWorld = worlds.reduce((best, world) => {
          if (!best) return world;
          return scoreWorld(world, profile) > scoreWorld(best, profile) ? world : best;
        }, null);
        showWorld(bestWorld, profile);
      };

      const resetExperience = () => {
        try {
          window.localStorage.removeItem(storageKey);
        } catch (error) {
          savedWorldKey = '';
        }
        launcherLabel.textContent = defaultLauncherLabel;
        form.reset();
        form.hidden = false;
        results.hidden = true;
        worlds.forEach((world) => {
          world.hidden = true;
        });
        currentStep = 0;
        updateStep();
        steps[0]?.querySelector('input')?.focus({ preventScroll: true });
      };

      const openPanel = (trigger = launcher) => {
        if (panel.open) return;
        returnFocusTarget = trigger instanceof HTMLElement && trigger.isConnected ? trigger : launcher;
        document.dispatchEvent(new CustomEvent('weston:surface-open', {
          detail: { surface: 'constellation' }
        }));
        if (typeof panel.showModal === 'function') panel.showModal();
        else if (typeof panel.show === 'function') panel.show();
        else panel.setAttribute('open', '');
        root.classList.add('is-open');
        launcher.setAttribute('aria-expanded', 'true');
        const profile = readProfile();
        const savedWorld = profile?.worldKey ? worlds.find((world) => world.dataset.worldKey === profile.worldKey) : null;
        if (savedWorld) {
          showWorld(savedWorld, profile, false);
        } else {
          updateStep();
          steps[currentStep]?.querySelector('input')?.focus({ preventScroll: true });
        }
      };

      const closePanel = (restoreFocus = true) => {
        if (panel.open) {
          if (typeof panel.close === 'function') panel.close();
          else panel.removeAttribute('open');
        }
        root.classList.remove('is-open');
        launcher.setAttribute('aria-expanded', 'false');
        const focusTarget = returnFocusTarget;
        returnFocusTarget = launcher;
        if (restoreFocus && focusTarget?.isConnected) focusTarget.focus({ preventScroll: true });
      };

      form.addEventListener('change', updateStep);
      nextButton.addEventListener('click', () => {
        if (nextButton.disabled) return;
        if (currentStep < steps.length - 1) {
          currentStep += 1;
          updateStep();
          steps[currentStep]?.querySelector('input')?.focus({ preventScroll: true });
        } else {
          completeProfile();
        }
      });
      backButton.addEventListener('click', () => {
        currentStep = Math.max(0, currentStep - 1);
        updateStep();
        steps[currentStep]?.querySelector('input:checked, input')?.focus({ preventScroll: true });
      });
      launcher.addEventListener('click', () => openPanel(launcher));
      closeButton.addEventListener('click', closePanel);
      restartButton.addEventListener('click', resetExperience);
      panel.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePanel();
      });
      panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePanel();
      });
      document.addEventListener('weston:surface-open', (event) => {
        if (event.detail?.surface !== 'constellation') closePanel(false);
      });
      document.addEventListener('weston:surface-request', (event) => {
        if (event.detail?.surface !== 'constellation') return;
        openPanel(event.detail.returnFocusTarget);
      });

      const savedProfile = readProfile();
      const savedWorld = savedProfile?.worldKey ? worlds.find((world) => world.dataset.worldKey === savedProfile.worldKey) : null;
      if (savedWorld?.dataset.worldTitle) launcherLabel.textContent = savedWorld.dataset.worldTitle;
      updateStep();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWestonConstellations());
  } else {
    initializeWestonConstellations();
  }
  document.addEventListener('shopify:section:load', (event) => initializeWestonConstellations(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-cover"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseCover = (root) => {
      if (!root || root.dataset.westonReady === 'true') return;
      root.dataset.westonReady = 'true';

      const heading = root.querySelector('[data-weston-cover-heading]');
      const copy = root.querySelector('[data-weston-cover-copy]');
      const primary = root.querySelector('[data-weston-cover-primary]');
      const links = root.querySelectorAll('[data-weston-lens-link]');

      const applyLens = (requestedLens) => {
        const lens = requestedLens === 'women' || requestedLens === 'men' ? requestedLens : 'all';
        const lensHeading = root.dataset[`weston${lens.charAt(0).toUpperCase()}${lens.slice(1)}Heading`];
        const lensCopy = root.dataset[`weston${lens.charAt(0).toUpperCase()}${lens.slice(1)}Copy`];
        const lensUrl = lens === 'all'
          ? root.dataset.westonPrimaryUrl
          : root.dataset[`weston${lens.charAt(0).toUpperCase()}${lens.slice(1)}Url`];

        root.dataset.westonActiveLens = lens;
        if (heading && lensHeading) heading.textContent = lensHeading;
        if (copy && lensCopy) copy.textContent = lensCopy;
        if (primary && lensUrl) primary.href = lensUrl;
        links.forEach((link) => link.classList.toggle('is-active', link.dataset.westonLens === lens));
      };

      let savedLens = 'all';
      try {
        savedLens = localStorage.getItem('weston-lens') || 'all';
      } catch (error) {
        savedLens = 'all';
      }
      applyLens(savedLens);

      links.forEach((link) => {
        link.addEventListener('click', () => {
          const lens = link.dataset.westonLens || 'all';
          try {
            localStorage.setItem('weston-lens', lens);
          } catch (error) {
            return;
          }
          applyLens(lens);
        });
      });

      window.addEventListener('weston:lens-change', (event) => applyLens(event.detail?.lens));
    };

    document.querySelectorAll('[data-weston-cover]').forEach(initialiseCover);
    document.addEventListener('shopify:section:load', (event) => {
      initialiseCover(event.target.querySelector('[data-weston-cover]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-decision-edit-2026"]) return;
  try {
    
  document.querySelectorAll('[data-decision-edit]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const storageKey = 'weston-personal-edit-v2';
    const legacyStorageKey = 'weston-decision-edit-v1';
    const maxSelections = 12;
    const openButton = root.querySelector('[data-decision-open]');
    const dialog = root.querySelector('[data-decision-dialog]');
    const cards = root.querySelector('[data-decision-cards]');
    const count = root.querySelector('[data-decision-count]');
    const summary = root.querySelector('[data-decision-summary]');
    const status = root.querySelector('[data-decision-status]');
    const totalWrap = root.querySelector('[data-decision-total-wrap]');
    const totalValue = root.querySelector('[data-decision-total]');
    const addLookButton = root.querySelector('[data-decision-add-look]');
    const publishButton = root.querySelector('[data-decision-publish]');
    const publisher = root.querySelector('[data-decision-publisher]');
    const publisherStatus = root.querySelector('[data-decision-publisher-status]');
    const issueTitleInput = root.querySelector('[data-decision-issue-title]');
    const issueMoodSelect = root.querySelector('[data-decision-issue-mood]');
    const issuePieces = root.querySelector('[data-decision-issue-pieces]');
    const issueCanvas = root.querySelector('[data-decision-issue-canvas]');
    const issueDownloadButton = root.querySelector('[data-decision-issue-download]');
    const issueShareButton = root.querySelector('[data-decision-issue-share]');
    const issueCopyButton = root.querySelector('[data-decision-issue-copy]');
    const issueActionButtons = [issueDownloadButton, issueShareButton, issueCopyButton];
    const labels = {
      add: root.dataset.decisionAddLabel,
      saved: root.dataset.decisionSavedLabel,
      current: root.dataset.decisionCurrentLabel,
      countOne: root.dataset.decisionCountOne,
      countReady: root.dataset.decisionCountReady,
      limit: root.dataset.decisionLimit,
      added: root.dataset.decisionAdded,
      removed: root.dataset.decisionRemoved,
      loadError: root.dataset.decisionLoadError,
      price: root.dataset.decisionPriceLabel,
      options: root.dataset.decisionOptionsLabel,
      optionsEmpty: root.dataset.decisionOptionsEmpty,
      view: root.dataset.decisionViewLabel,
      remove: root.dataset.decisionRemoveLabel,
      slotTitle: root.dataset.decisionSlotTitle,
      slotCopy: root.dataset.decisionSlotCopy,
      empty: root.dataset.decisionEmpty,
      variant: root.dataset.decisionVariantLabel,
      total: root.dataset.decisionTotalLabel,
      addLook: root.dataset.decisionAddLookLabel,
      adding: root.dataset.decisionAddingLabel,
      addLookError: root.dataset.decisionAddLookError,
      publish: root.dataset.decisionPublishLabel,
      publishEyebrow: root.dataset.decisionPublishEyebrow,
      coverEdit: root.dataset.decisionCoverEditLabel,
      publishNeedsTwo: root.dataset.decisionPublishNeedsTwo,
      publishPieceLimit: root.dataset.decisionPublishPieceLimit,
      publishRendering: root.dataset.decisionPublishRendering,
      publishReady: root.dataset.decisionPublishReady,
      copySuccess: root.dataset.decisionCopySuccess,
      copyError: root.dataset.decisionCopyError,
      exportError: root.dataset.decisionExportError,
      shareText: root.dataset.decisionShareText,
      defaultIssueTitle: root.dataset.decisionDefaultIssueTitle
    };
    let toastTimeout;
    let issueRenderTimeout;
    let issueRenderToken = 0;
    let isAddingLook = false;
    let issueReady = false;
    let issueUrls = [];
    let selections = [];
    const issueStorageKey = 'weston-publish-my-weston-v1';
    const imageCache = new Map();

    const normalizeUrl = (value) => {
      const url = new URL(value, window.location.origin);
      url.search = '';
      url.hash = '';
      return url.pathname.replace(/\/$/, '');
    };

    const readStorage = (key) => {
      try {
        const saved = JSON.parse(window.localStorage.getItem(key) || '[]');
        return Array.isArray(saved) ? saved.filter((item) => item && item.url) : [];
      } catch (error) {
        return [];
      }
    };

    const readSelections = () => {
      const current = readStorage(storageKey);
      return current.length ? current : readStorage(legacyStorageKey);
    };

    const saveSelections = () => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(selections));
        window.localStorage.removeItem(legacyStorageKey);
      } catch (error) {
      }
    };

    const readIssuePreferences = () => {
      try {
        const saved = JSON.parse(window.localStorage.getItem(issueStorageKey) || '{}');
        return saved && typeof saved === 'object' ? saved : {};
      } catch (error) {
        return {};
      }
    };

    const saveIssuePreferences = () => {
      try {
        window.localStorage.setItem(issueStorageKey, JSON.stringify({
          title: issueTitleInput.value.trim(),
          mood: issueMoodSelect.value,
          urls: issueUrls
        }));
      } catch (error) {
      }
    };

    const formatPrice = (amount) => {
      if (typeof amount !== 'number') return '';
      try {
        return new Intl.NumberFormat(root.dataset.decisionLocale || 'en-US', {
          style: 'currency',
          currency: root.dataset.decisionCurrency || 'USD'
        }).format(amount / 100);
      } catch (error) {
        return String(amount / 100);
      }
    };

    const optionSummary = (product) => {
      const optionNames = Array.isArray(product.options) ? product.options : [];
      const variantPool = Array.isArray(product.variants) ? product.variants.filter((variant) => variant.available !== false) : [];
      return optionNames.map((name, index) => {
        const optionKey = 'option' + (index + 1);
        const values = [...new Set(variantPool.map((variant) => variant[optionKey]).filter(Boolean))];
        return { name, values };
      }).filter((option) => option.values.length);
    };

    const variantImage = (variant) => {
      if (!variant || !variant.featured_image) return '';
      return typeof variant.featured_image === 'string'
        ? variant.featured_image
        : variant.featured_image.src || '';
    };

    const selectedVariant = (item) => {
      const variants = Array.isArray(item.variants) ? item.variants : [];
      return variants.find((variant) => String(variant.id) === String(item.selectedVariantId)) || variants[0] || null;
    };

    const currentIssueItems = () => issueUrls.map((url) => selections.find((item) => item.url === url)).filter(Boolean).slice(0, 4);

    const ensureIssueUrls = (fill = false) => {
      const availableUrls = selections.map((item) => item.url);
      issueUrls = issueUrls.filter((url, index) => availableUrls.includes(url) && issueUrls.indexOf(url) === index).slice(0, 4);
      if (fill) {
        availableUrls.forEach((url) => {
          if (issueUrls.length < Math.min(4, availableUrls.length) && !issueUrls.includes(url)) issueUrls.push(url);
        });
      }
    };

    const fetchProduct = async (value) => {
      const url = normalizeUrl(value);
      const response = await fetch(url + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('product-fetch-failed');
      const product = await response.json();
      const variants = Array.isArray(product.variants)
        ? product.variants.filter((variant) => variant.available !== false).map((variant) => ({
            id: variant.id,
            title: variant.title || '',
            price: variant.price,
            compareAt: variant.compare_at_price,
            image: variantImage(variant)
          }))
        : [];
      const firstVariant = variants[0] || null;
      return {
        url,
        title: product.title || '',
        image: product.featured_image || (Array.isArray(product.images) ? product.images[0] : ''),
        price: firstVariant?.price ?? product.price,
        compareAt: firstVariant?.compareAt ?? product.compare_at_price,
        options: optionSummary(product),
        variants,
        selectedVariantId: firstVariant?.id || null
      };
    };

    const hydrateSelections = async () => {
      if (!selections.length) return;
      const refreshed = await Promise.all(selections.map(async (savedItem) => {
        try {
          const product = await fetchProduct(savedItem.url);
          const savedVariant = product.variants.find((variant) => String(variant.id) === String(savedItem.selectedVariantId));
          if (savedVariant) product.selectedVariantId = savedVariant.id;
          return product;
        } catch (error) {
          return savedItem;
        }
      }));
      selections = refreshed;
      saveSelections();
      render();
    };

    const announce = (message) => {
      window.clearTimeout(toastTimeout);
      status.textContent = message;
      status.classList.add('is-visible');
      toastTimeout = window.setTimeout(() => {
        status.classList.remove('is-visible');
      }, 3200);
    };

    const createText = (tag, text, className) => {
      const element = document.createElement(tag);
      element.textContent = text;
      if (className) element.className = className;
      return element;
    };

    const writePrice = (element, item) => {
      const variant = selectedVariant(item);
      const priceAmount = variant?.price ?? item.price;
      const compareAmount = variant?.compareAt ?? item.compareAt;
      element.replaceChildren(document.createTextNode(formatPrice(priceAmount)));
      if (typeof compareAmount === 'number' && compareAmount > priceAmount) {
        element.append(createText('span', formatPrice(compareAmount), 'weston-decision-edit__compare-at'));
      }
    };

    const createProductCard = (item) => {
      const card = document.createElement('article');
      card.className = 'weston-decision-edit__card';

      if (item.image) {
        const image = document.createElement('img');
        image.className = 'weston-decision-edit__image';
        image.src = item.image;
        image.alt = item.title;
        image.loading = 'lazy';
        card.append(image);
      } else {
        const imagePlaceholder = document.createElement('div');
        imagePlaceholder.className = 'weston-decision-edit__image-placeholder';
        card.append(imagePlaceholder);
      }

      const content = document.createElement('div');
      content.className = 'weston-decision-edit__card-content';
      content.append(createText('h3', item.title));

      const price = document.createElement('p');
      price.className = 'weston-decision-edit__price';
      price.dataset.decisionCardPrice = '';
      writePrice(price, item);
      content.append(price);

      const metadata = document.createElement('dl');
      metadata.className = 'weston-decision-edit__meta';
      metadata.append(createText('dt', labels.options));
      const values = item.options && item.options.length
        ? item.options.map((option) => option.name + ': ' + option.values.join(' · ')).join(' / ')
        : labels.optionsEmpty;
      metadata.append(createText('dd', values));
      content.append(metadata);

      const variants = Array.isArray(item.variants) ? item.variants : [];
      const hasNamedVariant = variants.length > 1 || (variants[0] && variants[0].title !== 'Default Title');
      if (hasNamedVariant) {
        const variantField = document.createElement('label');
        variantField.className = 'weston-decision-edit__variant';
        variantField.append(createText('span', labels.variant));
        const select = document.createElement('select');
        select.dataset.decisionVariant = item.url;
        select.setAttribute('aria-label', labels.variant + ': ' + item.title);
        variants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.title + ' — ' + formatPrice(variant.price);
          option.selected = String(variant.id) === String(item.selectedVariantId);
          select.append(option);
        });
        variantField.append(select);
        content.append(variantField);
      }

      const actions = document.createElement('div');
      actions.className = 'weston-decision-edit__actions';
      const view = document.createElement('a');
      view.className = 'weston-decision-edit__view';
      view.href = item.url;
      view.textContent = labels.view;
      actions.append(view);

      const remove = document.createElement('button');
      remove.className = 'weston-decision-edit__remove';
      remove.type = 'button';
      remove.dataset.decisionRemove = item.url;
      remove.textContent = labels.remove;
      actions.append(remove);
      content.append(actions);

      card.append(content);
      return card;
    };

    const createSlot = () => {
      const slot = document.createElement('article');
      slot.className = 'weston-decision-edit__slot';
      const copy = document.createElement('div');
      copy.append(createText('strong', labels.slotTitle));
      copy.append(createText('p', labels.slotCopy));
      slot.append(copy);
      return slot;
    };

    const createEmpty = () => {
      const empty = document.createElement('article');
      empty.className = 'weston-decision-edit__empty';
      const copy = document.createElement('div');
      copy.append(createText('strong', labels.slotTitle));
      copy.append(createText('p', labels.empty));
      empty.append(copy);
      return empty;
    };

    const issueTitle = () => issueTitleInput.value.trim() || labels.defaultIssueTitle;

    const issueMood = () => issueMoodSelect.options[issueMoodSelect.selectedIndex]?.textContent || '';

    const setPublisherStatus = (message) => {
      publisherStatus.textContent = message;
    };

    const setIssueActionsState = (ready, busy = false) => {
      issueReady = ready;
      issueActionButtons.forEach((button) => {
        button.disabled = busy || !ready;
        button.setAttribute('aria-busy', String(busy));
      });
    };

    const renderIssuePieces = () => {
      issuePieces.replaceChildren();
      selections.forEach((item) => {
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.value = item.url;
        input.checked = issueUrls.includes(item.url);
        input.dataset.decisionIssuePiece = '';
        const text = document.createElement('span');
        text.textContent = item.title;
        label.append(input, text);
        issuePieces.append(label);
      });
    };

    const trackedText = (context, text, x, y, tracking) => {
      let cursor = x;
      [...text].forEach((character) => {
        context.fillText(character, cursor, y);
        cursor += context.measureText(character).width + tracking;
      });
    };

    const wrappedLines = (context, text, maxWidth, maxLines = 2) => {
      const words = String(text || '').trim().split(/\s+/).filter(Boolean);
      const lines = [];
      let current = '';
      words.forEach((word) => {
        const candidate = current ? current + ' ' + word : word;
        if (context.measureText(candidate).width <= maxWidth || !current) {
          current = candidate;
        } else if (lines.length < maxLines - 1) {
          lines.push(current);
          current = word;
        } else {
          current += ' ' + word;
        }
      });
      if (current) lines.push(current);
      if (lines.length > maxLines) lines.length = maxLines;
      if (lines.length === maxLines && context.measureText(lines[maxLines - 1]).width > maxWidth) {
        let last = lines[maxLines - 1];
        while (last.length > 1 && context.measureText(last + '…').width > maxWidth) last = last.slice(0, -1);
        lines[maxLines - 1] = last.trim() + '…';
      }
      return lines;
    };

    const drawImageCover = (context, image, x, y, width, height, index) => {
      context.save();
      context.beginPath();
      context.rect(x, y, width, height);
      context.clip();
      if (image) {
        const imageRatio = image.naturalWidth / image.naturalHeight;
        const boxRatio = width / height;
        let sourceWidth = image.naturalWidth;
        let sourceHeight = image.naturalHeight;
        let sourceX = 0;
        let sourceY = 0;
        if (imageRatio > boxRatio) {
          sourceWidth = image.naturalHeight * boxRatio;
          sourceX = (image.naturalWidth - sourceWidth) / 2;
        } else {
          sourceHeight = image.naturalWidth / boxRatio;
          sourceY = (image.naturalHeight - sourceHeight) / 2;
        }
        context.drawImage(image, sourceX, sourceY, sourceWidth, sourceHeight, x, y, width, height);
      } else {
        const fallback = context.createLinearGradient(x, y, x + width, y + height);
        fallback.addColorStop(0, '#eadfe0');
        fallback.addColorStop(0.55, '#d8afba');
        fallback.addColorStop(1, '#7c1732');
        context.fillStyle = fallback;
        context.fillRect(x, y, width, height);
        context.fillStyle = 'rgba(255, 253, 249, 0.84)';
        context.font = '700 72px Arial, sans-serif';
        context.textAlign = 'center';
        context.fillText('✦', x + width / 2, y + height / 2 + 24);
        context.textAlign = 'left';
      }
      const shade = context.createLinearGradient(x, y + height * 0.55, x, y + height);
      shade.addColorStop(0, 'rgba(23, 19, 18, 0)');
      shade.addColorStop(1, 'rgba(23, 19, 18, 0.38)');
      context.fillStyle = shade;
      context.fillRect(x, y, width, height);
      context.restore();

      context.fillStyle = '#fffdf9';
      context.fillRect(x + 18, y + 18, 58, 58);
      context.fillStyle = '#7c1732';
      context.font = '800 24px Arial, sans-serif';
      context.fillText(String(index + 1).padStart(2, '0'), x + 31, y + 56);
    };

    const loadIssueImage = (item) => {
      const variant = selectedVariant(item);
      const source = variant?.image || item.image || '';
      if (!source) return Promise.resolve(null);
      const absoluteSource = new URL(source, window.location.href).href;
      if (imageCache.has(absoluteSource)) return imageCache.get(absoluteSource);
      const request = new Promise((resolve) => {
        const image = new Image();
        const timeout = window.setTimeout(() => resolve(null), 7000);
        image.crossOrigin = 'anonymous';
        image.onload = () => {
          window.clearTimeout(timeout);
          resolve(image);
        };
        image.onerror = () => {
          window.clearTimeout(timeout);
          resolve(null);
        };
        image.src = absoluteSource;
      });
      imageCache.set(absoluteSource, request);
      return request;
    };

    const drawIssueCover = (items, images) => {
      const context = issueCanvas.getContext('2d');
      const width = issueCanvas.width;
      const height = issueCanvas.height;
      context.clearRect(0, 0, width, height);
      context.fillStyle = '#f7f3ee';
      context.fillRect(0, 0, width, height);

      context.fillStyle = '#171312';
      context.fillRect(0, 0, width, 244);
      context.fillStyle = '#fffdf9';
      context.font = '800 36px Arial, sans-serif';
      trackedText(context, (root.dataset.decisionBrand || 'WESTON GOODS').toUpperCase(), 70, 104, 7);
      context.fillStyle = '#d8afba';
      context.font = '800 21px Arial, sans-serif';
      trackedText(context, labels.publishEyebrow.toUpperCase(), 72, 168, 6);
      context.fillStyle = '#fffdf9';
      context.font = '500 54px Georgia, serif';
      context.fillText('✦', 948, 122);

      context.fillStyle = '#7c1732';
      context.font = '800 20px Arial, sans-serif';
      trackedText(context, issueMood().toUpperCase(), 72, 305, 5);
      context.fillStyle = '#171312';
      context.font = '500 94px Georgia, serif';
      const titleLines = wrappedLines(context, issueTitle(), 930, 2);
      titleLines.forEach((line, index) => context.fillText(line, 70, 405 + index * 96));

      const cells = items.length === 2
        ? [[70, 570, 455, 980], [555, 570, 455, 980]]
        : items.length === 3
          ? [[70, 570, 580, 980], [680, 570, 330, 474], [680, 1076, 330, 474]]
          : [[70, 570, 455, 474], [555, 570, 455, 474], [70, 1076, 455, 474], [555, 1076, 455, 474]];
      cells.forEach((cell, index) => drawImageCover(context, images[index], ...cell, index));

      context.fillStyle = '#fffdf9';
      context.fillRect(0, 1585, width, 335);
      context.fillStyle = '#7c1732';
      context.fillRect(70, 1636, 940, 3);
      context.fillStyle = '#746a65';
      context.font = '800 18px Arial, sans-serif';
      trackedText(context, labels.coverEdit.toUpperCase(), 70, 1695, 5);

      context.fillStyle = '#171312';
      context.font = '700 27px Arial, sans-serif';
      items.forEach((item, index) => {
        const column = index % 2;
        const row = Math.floor(index / 2);
        const x = 70 + column * 490;
        const y = 1755 + row * 58;
        context.fillStyle = '#7c1732';
        context.fillText(String(index + 1).padStart(2, '0'), x, y);
        context.fillStyle = '#171312';
        const title = wrappedLines(context, item.title, 385, 1)[0] || '';
        context.fillText(title, x + 48, y);
      });

      const totalAmount = items.reduce((sum, item) => {
        const amount = selectedVariant(item)?.price ?? item.price;
        return sum + (typeof amount === 'number' ? amount : 0);
      }, 0);
      context.fillStyle = '#746a65';
      context.font = '700 18px Arial, sans-serif';
      trackedText(context, labels.total.toUpperCase(), 70, 1882, 4);
      context.fillStyle = '#7c1732';
      context.font = '700 32px Georgia, serif';
      context.fillText(formatPrice(totalAmount), 260, 1884);
      context.fillStyle = '#746a65';
      context.font = '700 18px Arial, sans-serif';
      context.textAlign = 'right';
      context.fillText(window.location.host.toUpperCase(), 1010, 1882);
      context.textAlign = 'left';
    };

    const renderIssue = async () => {
      const items = currentIssueItems();
      const variantsReady = items.every((item) => selectedVariant(item));
      if (items.length < 2 || items.length > 4 || !variantsReady) {
        setIssueActionsState(false);
        setPublisherStatus(labels.publishNeedsTwo);
        return;
      }

      const token = ++issueRenderToken;
      setIssueActionsState(false, true);
      setPublisherStatus(labels.publishRendering);
      const images = await Promise.all(items.map(loadIssueImage));
      if (token !== issueRenderToken) return;
      drawIssueCover(items, images);
      saveIssuePreferences();
      setIssueActionsState(true);
      setPublisherStatus(labels.publishReady);
    };

    const scheduleIssueRender = () => {
      window.clearTimeout(issueRenderTimeout);
      setIssueActionsState(false, true);
      setPublisherStatus(labels.publishRendering);
      issueRenderTimeout = window.setTimeout(renderIssue, 140);
    };

    const buildIssueShopUrl = () => {
      const items = currentIssueItems();
      const variants = items.map((item) => selectedVariant(item)).filter(Boolean);
      if (items.length < 2 || variants.length !== items.length) throw new Error('variants-not-ready');
      const shopRoot = window.Shopify?.routes?.root || '/';
      const path = shopRoot + 'cart/' + variants.map((variant) => String(variant.id) + ':1').join(',');
      return new URL(path, window.location.origin).href;
    };

    const copyText = async (value) => {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        return;
      }
      const helper = document.createElement('textarea');
      helper.value = value;
      helper.setAttribute('readonly', '');
      helper.style.position = 'fixed';
      helper.style.opacity = '0';
      document.body.append(helper);
      helper.select();
      const copied = document.execCommand('copy');
      helper.remove();
      if (!copied) throw new Error('copy-failed');
    };

    const issueBlob = () => new Promise((resolve, reject) => {
      try {
        issueCanvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('export-failed')), 'image/png');
      } catch (error) {
        reject(error);
      }
    });

    const issueFilename = () => {
      const slug = issueTitle().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'my-weston';
      return 'weston-' + slug + '-issue.png';
    };

    const downloadIssue = async () => {
      if (!issueReady) return;
      try {
        const blob = await issueBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = issueFilename();
        document.body.append(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      } catch (error) {
        setPublisherStatus(labels.exportError);
        announce(labels.exportError);
      }
    };

    const copyIssueLink = async () => {
      if (!issueReady) return;
      try {
        await copyText(buildIssueShopUrl());
        setPublisherStatus(labels.copySuccess);
        announce(labels.copySuccess);
      } catch (error) {
        setPublisherStatus(labels.copyError);
        announce(labels.copyError);
      }
    };

    const shareIssue = async () => {
      if (!issueReady) return;
      try {
        const shareData = {
          title: issueTitle() + ' — ' + (root.dataset.decisionBrand || 'Weston Goods'),
          text: labels.shareText,
          url: buildIssueShopUrl()
        };
        if (navigator.share) {
          const blob = await issueBlob();
          if (typeof File === 'function') {
            const file = new File([blob], issueFilename(), { type: 'image/png' });
            if (navigator.canShare?.({ files: [file] })) shareData.files = [file];
          }
          await navigator.share(shareData);
        } else {
          await copyIssueLink();
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          setPublisherStatus(labels.copyError);
          announce(labels.copyError);
        }
      }
    };

    const openPublisher = () => {
      if (selections.length < 2) {
        announce(labels.publishNeedsTwo);
        return;
      }
      ensureIssueUrls(issueUrls.length < 2);
      renderIssuePieces();
      publisher.hidden = false;
      publishButton.setAttribute('aria-expanded', 'true');
      scheduleIssueRender();
      window.requestAnimationFrame(() => publisher.scrollIntoView({ behavior: 'smooth', block: 'nearest' }));
    };

    const closePublisher = () => {
      publisher.hidden = true;
      publishButton.setAttribute('aria-expanded', 'false');
      publishButton.focus({ preventScroll: true });
    };

    const updateLookSummary = () => {
      const hasSelections = selections.length > 0;
      const variantsReady = hasSelections && selections.every((item) => selectedVariant(item));
      const totalAmount = selections.reduce((sum, item) => {
        const variant = selectedVariant(item);
        const amount = variant?.price ?? item.price;
        return sum + (typeof amount === 'number' ? amount : 0);
      }, 0);

      totalWrap.hidden = !hasSelections;
      addLookButton.hidden = !hasSelections;
      publishButton.hidden = !hasSelections;
      totalValue.textContent = formatPrice(totalAmount);
      addLookButton.disabled = isAddingLook || !variantsReady;
      addLookButton.textContent = isAddingLook ? labels.adding : labels.addLook;
      publishButton.disabled = selections.length < 2;
      publishButton.title = selections.length < 2 ? labels.publishNeedsTwo : labels.publish;

      if (selections.length < 2 && !publisher.hidden) {
        publisher.hidden = true;
        publishButton.setAttribute('aria-expanded', 'false');
      } else if (!publisher.hidden) {
        ensureIssueUrls(issueUrls.length < 2);
        renderIssuePieces();
        scheduleIssueRender();
      }
    };

    const syncSavedButtons = () => {
      document.querySelectorAll('[data-decision-edit-add]').forEach((button) => {
        const saved = selections.some((item) => item.url === normalizeUrl(button.dataset.decisionProductUrl || ''));
        button.textContent = saved ? labels.saved : button.dataset.decisionCurrent === 'true' ? labels.current : labels.add;
        button.setAttribute('aria-pressed', String(saved));
      });
    };

    const render = () => {
      const total = selections.length;
      openButton.hidden = total === 0;
      count.textContent = String(total);
      summary.textContent = total === 1
        ? labels.countOne
        : labels.countReady.replace('[count]', String(total));
      openButton.setAttribute('aria-label', summary.textContent);
      openButton.title = summary.textContent;

      cards.replaceChildren();
      if (!total) {
        cards.append(createEmpty());
      } else {
        selections.forEach((item) => cards.append(createProductCard(item)));
      }

      syncSavedButtons();
      updateLookSummary();
    };

    const openDialog = () => {
      document.dispatchEvent(new CustomEvent('weston:surface-open', {
        detail: { surface: 'dressing-room' }
      }));
      openButton.setAttribute('aria-expanded', 'true');
      if (typeof dialog.show === 'function') {
        if (!dialog.open) dialog.show();
      } else {
        dialog.setAttribute('open', '');
      }
      window.requestAnimationFrame(() => root.querySelector('[data-decision-close]')?.focus({ preventScroll: true }));
    };

    const closeDialog = (restoreFocus = true) => {
      openButton.setAttribute('aria-expanded', 'false');
      if (typeof dialog.close === 'function') {
        if (dialog.open) dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      if (restoreFocus && !openButton.hidden) openButton.focus({ preventScroll: true });
    };

    const toggleSelection = async (value) => {
      const url = normalizeUrl(value);
      const existingIndex = selections.findIndex((item) => item.url === url);

      if (existingIndex >= 0) {
        selections.splice(existingIndex, 1);
        saveSelections();
        render();
        announce(labels.removed);
        return;
      }

      if (selections.length >= maxSelections) {
        announce(labels.limit);
        openDialog();
        return;
      }

      try {
        const product = await fetchProduct(url);
        selections.push(product);
        saveSelections();
        render();
        announce(labels.added);
      } catch (error) {
        announce(labels.loadError);
      }
    };

    const addCompleteLook = async () => {
      const items = selections.map((item) => selectedVariant(item)).filter(Boolean).map((variant) => ({
        id: variant.id,
        quantity: 1,
        properties: { '_Weston edit': 'Dressing Room' }
      }));
      if (!items.length || items.length !== selections.length) {
        announce(labels.addLookError);
        return;
      }

      isAddingLook = true;
      updateLookSummary();
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.description || labels.addLookError);
        window.location.assign(shopRoot + 'cart');
      } catch (error) {
        announce(error.message || labels.addLookError);
        isAddingLook = false;
        updateLookSummary();
      }
    };

    const createActionButton = (url, current) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = current
        ? 'weston-decision-edit__product-button'
        : 'weston-decision-edit__card-button';
      button.dataset.decisionEditAdd = '';
      button.dataset.decisionProductUrl = normalizeUrl(url);
      if (current) button.dataset.decisionCurrent = 'true';
      return button;
    };

    const attachCardButtons = () => {
      let attached = false;
      document.querySelectorAll("xo-product .xo-product-card, .wg-product-card, .wg-cart-edit__card").forEach((card) => {
        if (card.querySelector('[data-decision-edit-add]')) return;
        const productLink = card.querySelector(".xo-product-card__title a[href*='/products/']") || card.querySelector("a[href*='/products/']");
        const content = card.querySelector('.xo-product-card__information, .wg-product-card__info, .wg-cart-edit__content, .wg-cart-edit__meta');
        if (!productLink || !content) return;
        content.append(createActionButton(productLink.href, false));
        attached = true;
      });
      return attached;
    };

    const attachCurrentProductButton = () => {
      const currentProduct = root.querySelector('[data-decision-current-product]');
      if (!currentProduct) return false;
      const form = document.querySelector("form[action*='/cart/add']");
      if (!form || form.parentElement.querySelector('[data-decision-current-product-button]')) return false;
      const button = createActionButton(currentProduct.dataset.decisionProductUrl, true);
      button.dataset.decisionCurrentProductButton = 'true';
      form.insertAdjacentElement('afterend', button);
      return true;
    };

    let queued = false;
    const scheduleAttachments = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        const cardsAttached = attachCardButtons();
        const productAttached = attachCurrentProductButton();
        if (cardsAttached || productAttached) syncSavedButtons();
      });
    };

    document.addEventListener('click', (event) => {
      const addButton = event.target.closest('[data-decision-edit-add]');
      if (addButton) {
        event.preventDefault();
        toggleSelection(addButton.dataset.decisionProductUrl);
        return;
      }

      const removeButton = event.target.closest('[data-decision-remove]');
      if (removeButton) {
        event.preventDefault();
        selections = selections.filter((item) => item.url !== removeButton.dataset.decisionRemove);
        saveSelections();
        render();
        announce(labels.removed);
      }
    });

    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-decision-variant]');
      if (!select || !root.contains(select)) return;
      const item = selections.find((selection) => selection.url === normalizeUrl(select.dataset.decisionVariant));
      if (!item) return;
      item.selectedVariantId = select.value;
      const variant = selectedVariant(item);
      if (variant) {
        item.price = variant.price;
        item.compareAt = variant.compareAt;
        const card = select.closest('.weston-decision-edit__card');
        const price = card?.querySelector('[data-decision-card-price]');
        if (price) writePrice(price, item);
        const image = card?.querySelector('.weston-decision-edit__image');
        if (image && variant.image) image.src = variant.image;
      }
      saveSelections();
      updateLookSummary();
    });

    issuePieces.addEventListener('change', (event) => {
      const piece = event.target.closest('[data-decision-issue-piece]');
      if (!piece) return;
      if (piece.checked) {
        if (issueUrls.length >= 4) {
          piece.checked = false;
          setPublisherStatus(labels.publishPieceLimit);
          announce(labels.publishPieceLimit);
          return;
        }
        if (!issueUrls.includes(piece.value)) issueUrls.push(piece.value);
      } else {
        issueUrls = issueUrls.filter((url) => url !== piece.value);
      }
      saveIssuePreferences();
      scheduleIssueRender();
    });

    issueTitleInput.addEventListener('input', () => {
      saveIssuePreferences();
      scheduleIssueRender();
    });
    issueMoodSelect.addEventListener('change', () => {
      saveIssuePreferences();
      scheduleIssueRender();
    });

    openButton.addEventListener('click', openDialog);
    root.querySelector('[data-decision-close]').addEventListener('click', closeDialog);
    addLookButton.addEventListener('click', addCompleteLook);
    publishButton.addEventListener('click', () => publisher.hidden ? openPublisher() : closePublisher());
    root.querySelector('[data-decision-publish-close]').addEventListener('click', closePublisher);
    issueDownloadButton.addEventListener('click', downloadIssue);
    issueShareButton.addEventListener('click', shareIssue);
    issueCopyButton.addEventListener('click', copyIssueLink);
    root.querySelector('[data-decision-clear]').addEventListener('click', () => {
      selections = [];
      saveSelections();
      render();
      closeDialog();
      announce(labels.removed);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', () => openButton.setAttribute('aria-expanded', 'false'));
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
      }
    });
    document.addEventListener('weston:surface-open', (event) => {
      if (event.detail?.surface !== 'dressing-room') closeDialog(false);
    });
    window.addEventListener('storage', (event) => {
      if (event.key !== storageKey) return;
      selections = readSelections().slice(0, maxSelections);
      render();
    });

    const observer = new MutationObserver(scheduleAttachments);
    observer.observe(document.body, { childList: true, subtree: true });

    const issuePreferences = readIssuePreferences();
    issueTitleInput.value = typeof issuePreferences.title === 'string' && issuePreferences.title.trim()
      ? issuePreferences.title.slice(0, 42)
      : labels.defaultIssueTitle;
    if ([...issueMoodSelect.options].some((option) => option.value === issuePreferences.mood)) {
      issueMoodSelect.value = issuePreferences.mood;
    }
    issueUrls = Array.isArray(issuePreferences.urls) ? issuePreferences.urls : [];
    selections = readSelections().slice(0, maxSelections);
    ensureIssueUrls(issueUrls.length < 2);
    saveSelections();
    render();
    scheduleAttachments();
    hydrateSelections();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-design-system-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const designSystem = document.querySelector('.wg-design-system[data-shop-all-url]');
    if (!designSystem || designSystem.dataset.linkFixReady === 'true') return;

    designSystem.dataset.linkFixReady = 'true';
    const shopAllUrl = designSystem.dataset.shopAllUrl;
    const internalArchiveUrl = designSystem.dataset.internalArchiveUrl;
    const shippingPageUrl = designSystem.dataset.shippingPageUrl;
    const returnsPageUrl = designSystem.dataset.returnsPageUrl;

    const replacementFor = (anchor) => {
      const href = anchor.getAttribute('href');
      if (!href || href.startsWith('#')) return null;

      try {
        const url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return null;
        if (url.pathname.endsWith('/collections/all') || url.pathname.endsWith('/collections')) return shopAllUrl;
        if (internalArchiveUrl && url.pathname === new URL(internalArchiveUrl, window.location.origin).pathname) return shopAllUrl;
        if (url.pathname.endsWith('/policies/shipping-policy')) return shippingPageUrl;
        if (url.pathname.endsWith('/policies/refund-policy')) return returnsPageUrl;
        return null;
      } catch (error) {
        return null;
      }
    };

    const updateLinks = (root) => {
      if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
      const anchors = root.matches?.('a[href]') ? [root] : root.querySelectorAll?.('a[href]') || [];
      anchors.forEach((anchor) => {
        const replacement = replacementFor(anchor);
        if (replacement) anchor.setAttribute('href', replacement);
      });
    };

    updateLinks(document);

    if (internalArchiveUrl) {
      const archivePath = new URL(internalArchiveUrl, window.location.origin).pathname;
      if (window.location.pathname === archivePath) {
        window.location.replace(shopAllUrl);
        return;
      }
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach(updateLinks));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-edit-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-weston-edit-popup]';

    const storage = {
      get(key) {
        try {
          return window.localStorage.getItem(key);
        } catch (error) {
          return null;
        }
      },
      set(key, value) {
        try {
          window.localStorage.setItem(key, value);
        } catch (error) {
          return;
        }
      }
    };

    const init = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const dialog = root.querySelector('[data-weston-edit-dialog]');
      const title = root.querySelector('[data-weston-edit-title]');
      const closeButtons = root.querySelectorAll('[data-weston-edit-close]');
      const giftButton = root.querySelector('[data-weston-edit-gift]');
      const choiceButtons = root.querySelectorAll('[data-weston-edit-choice]');
      if (!dialog || !title) return;

      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      const delay = Number(root.dataset.delayMs) || 10000;
      const threshold = Number(root.dataset.scrollThreshold) || 30;
      const dismissDays = Number(root.dataset.dismissDays) || 14;
      const storageKey = root.dataset.storageKey || 'weston-edit-popup-v1-dismissed';
      const dismissWindow = dismissDays * 24 * 60 * 60 * 1000;
      let opened = false;
      let lastFocus = null;
      let timer = null;
      let scrollY = 0;
      let bodyStyles = null;

      const dismissedRecently = () => {
        const dismissedAt = Number(storage.get(storageKey));
        return dismissedAt > 0 && Date.now() - dismissedAt < dismissWindow;
      };

      const rememberDismissal = () => {
        if (!designMode) storage.set(storageKey, String(Date.now()));
      };

      const lockScroll = () => {
        scrollY = window.scrollY;
        bodyStyles = {
          position: document.body.style.position,
          top: document.body.style.top,
          width: document.body.style.width,
          overflow: document.body.style.overflow
        };
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + scrollY + 'px';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      };

      const unlockScroll = () => {
        if (!bodyStyles) return;
        document.body.style.position = bodyStyles.position;
        document.body.style.top = bodyStyles.top;
        document.body.style.width = bodyStyles.width;
        document.body.style.overflow = bodyStyles.overflow;
        window.scrollTo(0, scrollY);
        bodyStyles = null;
      };

      const otherOverlayIsOpen = () => {
        const overlays = document.querySelectorAll('dialog[open], [role="dialog"]:not([hidden])');
        return Array.from(overlays).some((overlay) => {
          return overlay !== dialog && overlay.getClientRects().length > 0;
        });
      };

      const canOpen = () => {
        const active = document.activeElement;
        const editing = active && active.matches('input, textarea, select, [contenteditable="true"]');
        return !editing && !otherOverlayIsOpen() && !document.hidden;
      };

      const show = () => {
        if (opened || dialog.open || !canOpen()) return false;
        opened = true;
        lastFocus = document.activeElement;
        lockScroll();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        window.requestAnimationFrame(() => title.focus({ preventScroll: true }));
        window.removeEventListener('scroll', onScroll);
        return true;
      };

      const close = (result) => {
        if (!dialog.open) return;
        if (typeof dialog.close === 'function') dialog.close(result || '');
        else {
          dialog.removeAttribute('open');
          unlockScroll();
          if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        }
      };

      const dismiss = () => {
        rememberDismissal();
        close('dismissed');
      };

      const attemptOpen = () => {
        if (opened || !root.isConnected) return;
        if (!show()) timer = window.setTimeout(attemptOpen, 4000);
      };

      const onScroll = () => {
        const height = Math.max(document.documentElement.scrollHeight, 1);
        const progress = ((window.scrollY + window.innerHeight) / height) * 100;
        if (progress >= threshold) attemptOpen();
      };

      dialog.addEventListener('close', () => {
        unlockScroll();
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        dismiss();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        const inside =
          event.clientX >= bounds.left &&
          event.clientX <= bounds.right &&
          event.clientY >= bounds.top &&
          event.clientY <= bounds.bottom;
        if (!inside) dismiss();
      });

      closeButtons.forEach((button) => button.addEventListener('click', dismiss));

      choiceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const lens = button.dataset.westonEditChoice;
          if (!lens) return;
          storage.set('weston-lens', lens);
          close('selected');

          window.setTimeout(() => {
            const lensButton = document.querySelector(
              '[data-weston-lens] [data-lens-choice="' + lens + '"]'
            );
            if (lensButton) {
              lensButton.click();
              return;
            }
            document.documentElement.dataset.westonLens = lens;
            window.dispatchEvent(new CustomEvent('weston:lens-change', {
              detail: { lens: lens }
            }));
          }, 120);
        });
      });

      if (giftButton) {
        giftButton.addEventListener('click', () => {
          rememberDismissal();
          close('gift');
          window.setTimeout(() => {
            const trigger = document.querySelector('[data-weston-lens-trigger]');
            if (!trigger) return;
            trigger.click();
            window.setTimeout(() => {
              document.querySelector('[data-weston-lens] [data-lens-choice="gift"]')?.click();
            }, 80);
          }, 120);
        });
      }

      if (!designMode) {
        if (storage.get('weston-lens') || dismissedRecently()) return;
        timer = window.setTimeout(attemptOpen, delay);
        window.addEventListener('scroll', onScroll, { passive: true });
      } else {
        timer = window.setTimeout(attemptOpen, 500);
      }

      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        window.clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        if (dialog.open) close('unload');
      }, { once: true });
    };

    document.querySelectorAll(selector).forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll(selector).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-experience-compatibility-2026"]) return;
  try {
    
  (() => {
    const retiredKeys = [
      'weston-personal-edit-v2',
      'weston-decision-edit-v1',
      'weston-publish-my-weston-v1'
    ];

    const clearRetiredMemory = () => {
      retiredKeys.forEach((key) => {
        try {
          localStorage.removeItem(key);
        } catch (_) {}
      });
    };

    const connectSaveButtons = (scope = document) => {
      scope.querySelectorAll?.('[data-wsp-save]').forEach((button) => {
        if (button.dataset.westonHubBridge === 'true') return;
        button.dataset.westonHubBridge = 'true';
        button.addEventListener('click', (event) => {
          const hubButton = document.querySelector('[data-wxc-save-current]');
          if (!hubButton) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          hubButton.click();
        }, true);
      });
    };

    const sanctuaryNavRoots = (scope = document) => {
      const roots = [];
      if (scope.matches?.('[data-sanctuary-network-navigation]')) roots.push(scope);
      scope.querySelectorAll?.('[data-sanctuary-network-navigation]').forEach((root) => roots.push(root));
      return [...new Set(roots)];
    };

    const syncSanctuaryPageClass = () => {
      document.documentElement.classList.toggle(
        'weston-sanctuary-dock-integrated',
        Boolean(document.querySelector('[data-sanctuary-network-navigation] [data-weston-command-dock-trigger]'))
      );
    };

    const integrateSanctuaryDock = (scope = document) => {
      sanctuaryNavRoots(scope).forEach((navRoot) => {
        const dock = navRoot.querySelector('.wsnn__dock');
        const hubRoot = document.querySelector('[data-wxc-root]');
        const sourceLauncher = hubRoot?.querySelector('[data-wxc-open]');
        const panel = hubRoot?.querySelector('[data-wxc-panel]');
        let identity = dock?.querySelector('.wsnn__identity');

        if (!dock || !hubRoot || !sourceLauncher || !panel || !identity) return;

        let trigger = identity.matches('[data-weston-command-dock-trigger]') ? identity : null;
        if (!trigger) {
          trigger = document.createElement('button');
          trigger.type = 'button';
          trigger.className = identity.className;
          trigger.setAttribute('data-weston-command-dock-trigger', 'true');
          trigger.setAttribute('aria-label', sourceLauncher.getAttribute('aria-label') || 'Open Explore Weston');
          trigger.setAttribute('title', 'Open Explore Weston');
          if (panel.id) trigger.setAttribute('aria-controls', panel.id);
          while (identity.firstChild) trigger.append(identity.firstChild);
          identity.replaceWith(trigger);
          identity = trigger;
        }

        if (trigger.dataset.westonDockReady === 'true') {
          syncSanctuaryPageClass();
          return;
        }

        trigger.dataset.westonDockReady = 'true';
        let openedFromDock = false;

        const syncPanelState = () => {
          const isOpen = !panel.hidden;
          trigger.setAttribute('aria-expanded', String(isOpen));
          if (!isOpen && openedFromDock) {
            openedFromDock = false;
            requestAnimationFrame(() => {
              if (trigger.isConnected) trigger.focus({ preventScroll: true });
            });
          }
        };

        trigger.addEventListener('click', () => {
          openedFromDock = true;
          const hub = window.__westonExperienceCommandCenter2026;
          if (panel.hidden) {
            if (hub?.open) hub.open();
            else sourceLauncher.click();
          } else if (hub?.close) {
            hub.close(false);
          } else {
            hubRoot.querySelector('[data-wxc-close]')?.click();
          }
        });

        const observer = new MutationObserver(syncPanelState);
        observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
        trigger._westonDockObserver = observer;
        syncPanelState();
        syncSanctuaryPageClass();
      });
    };

    const initialize = (scope = document) => {
      clearRetiredMemory();
      connectSaveButtons(scope);
      integrateSanctuaryDock(scope);
      window.setTimeout(() => integrateSanctuaryDock(document), 0);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.('[data-weston-command-dock-trigger]').forEach((trigger) => {
        trigger._westonDockObserver?.disconnect();
      });
      window.setTimeout(syncSanctuaryPageClass, 0);
    });
    document.addEventListener('weston:experience-cleared', clearRetiredMemory);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-faith-gift-finder-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGiftFinder = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const audienceButtons = [...root.querySelectorAll('[data-gift-audience]')];
      const momentButtons = [...root.querySelectorAll('[data-gift-moment]')];
      const results = [...root.querySelectorAll('[data-gift-result]')];
      const welcome = root.querySelector('[data-gift-welcome]');
      const reset = root.querySelector('[data-gift-reset]');
      let audience = '';
      let moment = '';

      const setGroup = (buttons, selected) => {
        buttons.forEach((button) => {
          const active = button === selected;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      };

      const showResult = () => {
        if (!audience || !moment) return;
        let match = results.find((result) => result.dataset.moment === moment && result.dataset.audience === audience);
        if (!match) match = results.find((result) => result.dataset.moment === moment && result.dataset.audience === 'anyone');
        if (!match) match = results.find((result) => result.dataset.moment === moment);
        if (!match) match = results[0];
        welcome.hidden = true;
        results.forEach((result) => { result.hidden = result !== match; });
        reset.hidden = false;
      };

      audienceButtons.forEach((button) => {
        button.addEventListener('click', () => {
          audience = button.dataset.giftAudience || '';
          setGroup(audienceButtons, button);
          showResult();
        });
      });

      momentButtons.forEach((button) => {
        button.addEventListener('click', () => {
          moment = button.dataset.giftMoment || '';
          setGroup(momentButtons, button);
          showResult();
        });
      });

      reset?.addEventListener('click', () => {
        audience = '';
        moment = '';
        setGroup(audienceButtons, null);
        setGroup(momentButtons, null);
        results.forEach((result) => { result.hidden = true; });
        welcome.hidden = false;
        reset.hidden = true;
        audienceButtons[0]?.focus();
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-gift-finder]')) initGiftFinder(scope);
      scope.querySelectorAll('[data-weston-gift-finder]').forEach(initGiftFinder);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-faith-paths-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPaths = (root) => {
      if (!root || root.dataset.faithPathsReady === 'true') return;
      root.dataset.faithPathsReady = 'true';

      const completeLabel = root.dataset.completeLabel || 'Completed';
      const incompleteLabel = root.dataset.incompleteLabel || 'Mark complete';
      const resetLabel = root.dataset.resetLabel || 'Reset path';
      const resetConfirmLabel = root.dataset.resetConfirmLabel || 'Tap again to reset';
      const timers = [];

      const readSaved = (key) => {
        try {
          const value = JSON.parse(localStorage.getItem(key) || '[]');
          return Array.isArray(value) ? value.filter(Number.isInteger) : [];
        } catch (error) {
          return [];
        }
      };

      const writeSaved = (key, value) => {
        try {
          localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
          return false;
        }
        return true;
      };

      root.querySelectorAll('[data-faith-path]').forEach((path) => {
        const key = `weston-sanctuary-path-${path.dataset.pathId}`;
        const days = [...path.querySelectorAll('[data-path-day]')];
        const completed = new Set(readSaved(key).filter((index) => index >= 0 && index < days.length));
        const progressCopy = path.querySelector('[data-path-progress]');
        const progressBar = path.querySelector('[data-path-progressbar]');
        const progressFill = path.querySelector('[data-path-progress-fill]');
        const resetButton = path.querySelector('[data-reset-path]');
        let resetPending = false;

        const render = () => {
          days.forEach((day, index) => {
            const isComplete = completed.has(index);
            const button = day.querySelector('[data-path-complete]');
            const title = day.querySelector('.wg-faith-path__day-copy strong')?.textContent?.trim() || '';
            day.classList.toggle('is-complete', isComplete);
            button?.setAttribute('aria-pressed', String(isComplete));
            button?.setAttribute('aria-label', `${isComplete ? completeLabel : incompleteLabel}: ${title}`);
          });

          const count = completed.size;
          const fraction = days.length ? count / days.length : 0;
          if (progressCopy) progressCopy.textContent = `${count} / ${days.length}`;
          if (progressBar) progressBar.setAttribute('aria-valuenow', String(count));
          if (progressFill) progressFill.style.transform = `scaleX(${fraction})`;
          writeSaved(key, [...completed].sort((a, b) => a - b));
        };

        path.querySelectorAll('[data-path-complete]').forEach((button) => {
          button.addEventListener('click', () => {
            const index = Number(button.dataset.pathComplete);
            if (completed.has(index)) completed.delete(index);
            else completed.add(index);
            render();
          });
        });

        path.querySelectorAll('[data-open-bible]').forEach((button) => {
          button.addEventListener('click', () => {
            document.dispatchEvent(new CustomEvent('weston:bible:open', {
              detail: {
                book: Number(button.dataset.book),
                chapter: Number(button.dataset.chapter)
              }
            }));
          });
        });

        resetButton?.addEventListener('click', () => {
          if (!resetPending) {
            resetPending = true;
            resetButton.textContent = resetConfirmLabel;
            const timer = window.setTimeout(() => {
              resetPending = false;
              resetButton.textContent = resetLabel;
            }, 5000);
            timers.push(timer);
            return;
          }

          completed.clear();
          resetPending = false;
          resetButton.textContent = resetLabel;
          render();
        });

        render();
      });

      root._faithPathsCleanup = () => timers.forEach(window.clearTimeout);
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-faith-paths]')) initPaths(scope);
      scope.querySelectorAll('[data-faith-paths]').forEach(initPaths);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.('[data-faith-paths]') ? event.target : event.target.querySelector('[data-faith-paths]');
      root?._faithPathsCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-faith-shop-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initShop = (root) => {
      if (!root || root.dataset.faithShopReady === 'true') return;
      root.dataset.faithShopReady = 'true';
      root.querySelector('[data-return-reader]')?.addEventListener('click', () => {
        document.querySelector('[data-living-bible]')?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-faith-shop]')) initShop(scope);
      scope.querySelectorAll('[data-faith-shop]').forEach(initShop);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-flow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-weston-flow]');
    if (!roots.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const savedKey = 'weston-flow-saved-v1';
    const recentKey = 'weston-recent-products';
    const insightsKey = 'weston-flow-insights-v1';
    const profileKey = 'weston-flow-profile-v1';
    const remixDraftKey = 'weston-flow-remix-draft-v1';
    const personalizationKey = 'weston-flow-personalization-v1';
    const fitKey = 'weston-fit-passport';

    const readStorage = (key, fallback) => {
      try {
        const value = JSON.parse(localStorage.getItem(key));
        return value === null ? fallback : value;
      }
      catch (error) { return fallback; }
    };

    const writeStorage = (key, value) => {
      try { localStorage.setItem(key, JSON.stringify(value)); }
      catch (error) { return; }
    };

    const record = (event, detail = {}) => {
      const insights = readStorage(insightsKey, []);
      insights.push({ event, detail, at: Date.now() });
      writeStorage(insightsKey, insights.slice(-100));
      try {
        window.Shopify?.analytics?.publish('weston_goods:flow_interaction', {
          interaction: event,
          ...detail
        });
      } catch (error) { return; }
    };

    const genderOf = (value) => {
      const text = String(value || '').toLowerCase();
      if (/(^|[\s|,/-])(women|womens|woman|female|ladies|girls?)([\s|,/-]|$)/.test(text)) return 'women';
      if (/(^|[\s|,/-])(men|mens|male|gentlemen|boys?)([\s|,/-]|$)/.test(text)) return 'men';
      return 'neutral';
    };

    const categoryOf = (value) => {
      const text = String(value || '').toLowerCase();
      if (/dress|gown|romper|jumpsuit/.test(text)) return 'one-piece';
      if (/top|shirt|blouse|tee|tank|sweater|hoodie|bra|bustier|corset/.test(text)) return 'top';
      if (/bottom|pant|jean|denim|skirt|short|legging|trouser/.test(text)) return 'bottom';
      if (/jacket|coat|blazer|cardigan|outerwear|layer/.test(text)) return 'layer';
      if (/shoe|boot|heel|sandal|sneaker|loafer/.test(text)) return 'shoe';
      if (/jewel|necklace|earring|bracelet|ring|watch|bag|purse|belt|hat|scarf|accessor/.test(text)) return 'accessory';
      if (/lingerie|sleep|lounge|nightgown|robe/.test(text)) return 'intimate';
      return 'other';
    };

    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const viewport = root.querySelector('[data-flow-viewport]');
      const allSlides = Array.from(root.querySelectorAll('[data-flow-slide]'));
      const productSlides = allSlides.filter((slide) => !slide.hasAttribute('data-flow-story'));
      const storySlides = allSlides.filter((slide) => slide.hasAttribute('data-flow-story'));
      const status = root.querySelector('[data-flow-status]');
      const dialog = root.querySelector('[data-flow-remix-dialog]');
      const remixGrid = root.querySelector('[data-flow-remix-grid]');
      const lookTotal = root.querySelector('[data-flow-look-total]');
      const addLook = root.querySelector('[data-flow-add-look]');
      const poolNode = root.querySelector('[data-flow-remix-pool]');
      let pool = [];
      let activeSlide = null;
      let returnFocus = null;
      let mood = localStorage.getItem('weston-occasion') === 'after-hours' ? 'after-dark' : 'day';
      let remixTurn = 0;
      let remixCandidates = [];
      let personalizationEnabled = readStorage(personalizationKey, true) !== false;
      const viewedThisPage = new Set();

      try { pool = JSON.parse(poolNode?.textContent || '[]'); }
      catch (error) { pool = []; }

      const currency = root.dataset.currency || 'USD';
      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency
          }).format(Number(cents || 0) / 100);
        } catch (error) {
          return `$${(Number(cents || 0) / 100).toFixed(2)}`;
        }
      };

      const rootPath = () => {
        const value = root.dataset.rootUrl || '/';
        return value.endsWith('/') ? value : `${value}/`;
      };

      const announce = (message) => {
        if (!status) return;
        status.textContent = '';
        window.setTimeout(() => { status.textContent = message; }, 20);
      };

      const template = (source, replacements) => Object.entries(replacements).reduce(
        (output, [key, value]) => output.replaceAll(`__${key}__`, String(value)),
        source || ''
      );

      const emptyProfile = () => ({
        more: [],
        less: [],
        hidden: [],
        categoryWeights: {},
        priceTarget: null
      });

      const readProfile = () => ({ ...emptyProfile(), ...readStorage(profileKey, {}) });
      const visibleSlides = () => Array.from(viewport?.querySelectorAll('[data-flow-slide]') || []).filter((slide) => !slide.hidden);
      const savedHandles = () => new Set(readStorage(savedKey, []).map((item) => item.handle));
      const fitPassport = () => readStorage(fitKey, {});
      const normalizeSize = (value) => String(value || '').trim().toUpperCase().replaceAll(' ', '');

      const fitCopyFor = (slide) => {
        const fit = fitPassport();
        const sizes = String(slide.dataset.productSizes || '').split('|').filter(Boolean);
        if (!fit.size) return root.dataset.fitNoPassport;
        if (!sizes.length) return root.dataset.fitNoStandard;
        const available = sizes.some((size) => normalizeSize(size) === normalizeSize(fit.size));
        if (!available) return template(root.dataset.fitUnavailable, { size: fit.size });
        const fitNames = {
          regular: root.dataset.fitRegular,
          fitted: root.dataset.fitFitted,
          relaxed: root.dataset.fitRelaxed
        };
        return template(root.dataset.fitAvailable, {
          size: fit.size,
          fit: fitNames[fit.fit] || fitNames.regular
        });
      };

      const paintFitConfidence = () => {
        productSlides.forEach((slide) => {
          const copy = slide.querySelector('[data-flow-fit-copy]');
          if (copy) copy.textContent = fitCopyFor(slide);
        });
      };

      const scoreProductSlide = (slide) => {
        const profile = readProfile();
        const handle = slide.dataset.handle;
        const category = categoryOf(slide.dataset.productHaystack);
        const fit = fitPassport();
        const sizes = String(slide.dataset.productSizes || '').split('|').filter(Boolean);
        const price = Number(slide.dataset.priceCents || 0);
        let score = 100 - Number(slide.dataset.index || 0);
        score += Number(profile.categoryWeights?.[category] || 0) * 8;
        if (profile.more?.includes(handle)) score += 60;
        if (profile.less?.includes(handle)) score -= 45;
        if (savedHandles().has(handle)) score += 34;
        if (fit.size && sizes.some((size) => normalizeSize(size) === normalizeSize(fit.size))) score += 12;
        if (profile.priceTarget && price) {
          const distance = Math.abs(price - Number(profile.priceTarget)) / Math.max(Number(profile.priceTarget), 1);
          score += Math.max(-12, 10 - (distance * 20));
        }
        readStorage(insightsKey, []).forEach((insight) => {
          if (insight.detail?.handle !== handle) return;
          const weights = { flow_save: 18, flow_add: 30, flow_buy_now: 34, flow_remix_open: 10, flow_photo: 4, flow_view: 1 };
          score += weights[insight.event] || 0;
        });
        return score;
      };

      const reasonFor = (slide) => {
        const profile = readProfile();
        const fit = fitPassport();
        const sizes = String(slide.dataset.productSizes || '').split('|').filter(Boolean);
        if (savedHandles().has(slide.dataset.handle)) return root.dataset.reasonSaved;
        if (profile.more?.includes(slide.dataset.handle)) return root.dataset.reasonMore;
        if (fit.size && sizes.some((size) => normalizeSize(size) === normalizeSize(fit.size))) {
          return template(root.dataset.reasonSize, { size: fit.size });
        }
        if (localStorage.getItem('weston-occasion') === 'after-hours' && isAfterDarkProduct(slide)) return root.dataset.reasonAfterDark;
        return root.dataset.reasonFresh;
      };

      const paintReasons = () => {
        productSlides.forEach((slide) => {
          const reason = slide.querySelector('[data-flow-reason]');
          if (reason) reason.textContent = reasonFor(slide);
        });
      };

      const personalizeSlides = () => {
        if (!viewport || !productSlides.length) return;
        const sorted = [...productSlides].sort((a, b) => {
          if (!personalizationEnabled) return Number(a.dataset.index) - Number(b.dataset.index);
          return scoreProductSlide(b) - scoreProductSlide(a);
        });
        const fragment = document.createDocumentFragment();
        sorted.forEach((slide, index) => {
          fragment.append(slide);
          if ((index + 1) % 3 === 0) {
            const story = storySlides[Math.floor(index / 3)];
            if (story) fragment.append(story);
          }
        });
        storySlides.forEach((story) => { if (!fragment.contains(story)) fragment.append(story); });
        viewport.append(fragment);
        paintReasons();
      };

      const updatePositions = () => {
        const slides = visibleSlides();
        slides.forEach((slide, index) => {
          const position = slide.querySelector('[data-flow-position]');
          if (position) position.textContent = `${index + 1}/${slides.length}`;
        });
      };

      const productStatus = (slide) => {
        const slides = visibleSlides();
        const current = Math.max(0, slides.indexOf(slide)) + 1;
        return template(root.dataset.productStatus, {
          product: slide?.dataset.productTitle || '',
          current,
          total: slides.length
        });
      };

      const isAfterDarkProduct = (slide) => /dress|lingerie|lace|satin|night|party|cocktail|jewel|body|mini|lounge|date|heel/.test(slide.dataset.productHaystack || '');

      const applyFilters = (options = {}) => {
        if (!allSlides.length) return;
        const lens = document.documentElement.dataset.westonLens || localStorage.getItem('weston-lens') || 'all';
        const afterDark = localStorage.getItem('weston-occasion') === 'after-hours';
        const profile = readProfile();
        const genderMatches = (slide) => {
          if (slide.hasAttribute('data-flow-story')) return true;
          const gender = genderOf(slide.dataset.productHaystack);
          if (lens === 'women') return gender !== 'men';
          if (lens === 'men') return gender !== 'women';
          return true;
        };
        const isVisiblePreference = (slide) => slide.hasAttribute('data-flow-story') || !profile.hidden?.includes(slide.dataset.handle);
        let matches = allSlides.filter((slide) => (
          isVisiblePreference(slide)
          && genderMatches(slide)
          && (slide.hasAttribute('data-flow-story') || !afterDark || isAfterDarkProduct(slide))
        ));
        if (matches.filter((slide) => !slide.hasAttribute('data-flow-story')).length < 2) {
          matches = allSlides.filter((slide) => isVisiblePreference(slide) && genderMatches(slide));
        }
        allSlides.forEach((slide) => { slide.hidden = !matches.includes(slide); });

        root.querySelectorAll('[data-flow-lens]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.flowLens === lens || (lens === 'gift' && button.dataset.flowLens === 'all')));
        });
        const darkButton = root.querySelector('[data-flow-after-dark]');
        darkButton?.setAttribute('aria-pressed', String(afterDark));
        root.dataset.afterDark = String(afterDark);
        updatePositions();
        paintReasons();
        paintFitConfidence();

        const first = visibleSlides()[0];
        const keepCurrent = options?.preserve === true && activeSlide && !activeSlide.hidden;
        if (first && viewport && !keepCurrent) {
          viewport.scrollTo({ top: first.offsetTop, behavior: 'auto' });
          activeSlide = first;
          announce(productStatus(first));
        }
      };

      const move = (direction) => {
        const slides = visibleSlides();
        if (!slides.length || !viewport) return;
        const current = Math.max(0, slides.indexOf(activeSlide));
        const targetIndex = Math.max(0, Math.min(slides.length - 1, current + direction));
        const target = slides[targetIndex];
        viewport.scrollTo({
          top: target.offsetTop,
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
        });
        activeSlide = target;
        announce(productStatus(target));
        record('flow_navigate', { handle: target.dataset.handle, direction });
      };

      if (viewport && allSlides.length) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio < .6) return;
            activeSlide = entry.target;
            announce(productStatus(activeSlide));
            if (!viewedThisPage.has(activeSlide.dataset.handle)) {
              viewedThisPage.add(activeSlide.dataset.handle);
              record(activeSlide.hasAttribute('data-flow-story') ? 'flow_story_view' : 'flow_view', {
                handle: activeSlide.dataset.handle
              });
            }
          });
        }, { root: viewport, threshold: [.6, .8] });
        allSlides.forEach((slide) => observer.observe(slide));

        viewport.addEventListener('keydown', (event) => {
          if (event.target.closest('button, a, input, select, textarea')) return;
          if (event.key === 'ArrowDown' || event.key === 'PageDown') {
            event.preventDefault();
            move(1);
          }
          if (event.key === 'ArrowUp' || event.key === 'PageUp') {
            event.preventDefault();
            move(-1);
          }
          if (event.key === 'Home') {
            event.preventDefault();
            activeSlide = visibleSlides()[0];
            viewport.scrollTo({ top: activeSlide?.offsetTop || 0, behavior: 'auto' });
          }
          if (event.key === 'End') {
            event.preventDefault();
            const slides = visibleSlides();
            activeSlide = slides[slides.length - 1];
            viewport.scrollTo({ top: activeSlide?.offsetTop || 0, behavior: 'auto' });
          }
        });
      }

      root.querySelectorAll('[data-flow-photo-next]').forEach((button) => {
        button.addEventListener('click', () => {
          const media = button.closest('[data-flow-media]');
          const photos = Array.from(media.querySelectorAll('[data-flow-photo]'));
          const current = Math.max(0, photos.findIndex((photo) => !photo.hidden));
          const nextIndex = (current + 1) % photos.length;
          photos.forEach((photo, index) => { photo.hidden = index !== nextIndex; });
          button.querySelector('[data-flow-photo-count]').textContent = `${nextIndex + 1}/${photos.length}`;
          announce(template(root.dataset.photoStatus, { current: nextIndex + 1, total: photos.length }));
          record('flow_photo', { handle: button.closest('[data-flow-slide]')?.dataset.handle, photo: nextIndex + 1 });
        });
      });

      const cartUpdate = async () => {
        const response = await fetch(`${rootPath()}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        const cart = await response.json();
        document.querySelectorAll('[data-cart-count], .xo-cart-mini-count').forEach((node) => { node.textContent = cart.item_count; });
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((node) => { node.textContent = cart.item_count; });
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
        return cart;
      };

      const addItems = async (items) => {
        const response = await fetch(`${rootPath()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart request failed');
        const result = await response.json();
        await cartUpdate();
        return result;
      };

      root.querySelectorAll('[data-flow-variant]').forEach((field) => {
        field.addEventListener('change', () => {
          const slide = field.closest('[data-flow-slide]');
          const option = field.selectedOptions?.[0];
          const price = option?.dataset.price;
          if (price) slide.querySelector('[data-flow-price]').textContent = price;
          if (option?.dataset.priceCents) slide.dataset.priceCents = option.dataset.priceCents;
          record('flow_variant', { handle: slide.dataset.handle, variant: field.value, price: Number(slide.dataset.priceCents || 0) });
          if (readRemixDraft()?.baseHandle === slide.dataset.handle) saveRemixDraft();
        });
      });

      root.querySelectorAll('[data-flow-form]').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('[type="submit"]');
          const original = button.textContent;
          const id = Number(new FormData(form).get('id'));
          if (!id) return;
          button.disabled = true;
          try {
            await addItems([{ id, quantity: 1 }]);
            button.textContent = root.dataset.added;
            announce(root.dataset.added);
            const slide = form.closest('[data-flow-slide]');
            record('flow_add', { handle: slide?.dataset.handle, variant: id, price: Number(slide?.dataset.priceCents || 0) });
          } catch (error) {
            announce(root.dataset.error);
          } finally {
            window.setTimeout(() => { button.textContent = original; button.disabled = false; }, 1600);
          }
        });
      });

      root.querySelectorAll('[data-flow-buy-now]').forEach((button) => {
        button.addEventListener('click', async () => {
          const form = button.closest('[data-flow-form]');
          const id = Number(new FormData(form).get('id'));
          if (!id) return;
          button.disabled = true;
          try {
            await addItems([{ id, quantity: 1 }]);
            const slide = form.closest('[data-flow-slide]');
            record('flow_buy_now', { handle: slide?.dataset.handle, variant: id, price: Number(slide?.dataset.priceCents || 0) });
            window.location.assign(root.dataset.checkoutUrl);
          } catch (error) {
            button.disabled = false;
            announce(root.dataset.error);
          }
        });
      });

      const syncSaved = () => {
        const saved = readStorage(savedKey, []);
        root.querySelectorAll('[data-flow-save]').forEach((button) => {
          const slide = button.closest('[data-flow-slide]');
          const isSaved = saved.some((item) => item.handle === slide.dataset.handle);
          button.setAttribute('aria-pressed', String(isSaved));
          button.querySelector('[data-flow-save-text]').textContent = isSaved ? root.dataset.savedLabel : root.dataset.saveLabel;
          button.querySelector('[aria-hidden="true"]').textContent = isSaved ? '♥' : '♡';
        });
      };

      root.querySelectorAll('[data-flow-save]').forEach((button) => {
        button.addEventListener('click', () => {
          const slide = button.closest('[data-flow-slide]');
          const saved = readStorage(savedKey, []);
          const existing = saved.findIndex((item) => item.handle === slide.dataset.handle);
          let message = root.dataset.saved;
          if (existing >= 0) {
            saved.splice(existing, 1);
            message = root.dataset.removed;
          } else {
            const savedProduct = {
              id: slide.dataset.productId,
              handle: slide.dataset.handle,
              title: slide.dataset.productTitle,
              url: button.dataset.productUrl,
              image: button.dataset.productImage,
              price: button.dataset.productPrice,
              savedAt: Date.now()
            };
            saved.unshift(savedProduct);
            const recent = readStorage(recentKey, []).filter((item) => (
              String(item.handle || '') !== String(savedProduct.handle)
              && String(item.id || '') !== String(savedProduct.id)
            ));
            recent.unshift(savedProduct);
            writeStorage(recentKey, recent.slice(0, 12));
          }
          writeStorage(savedKey, saved.slice(0, 40));
          if (existing >= 0) {
            const recent = readStorage(recentKey, []).filter((item) => (
              String(item.handle || '') !== String(slide.dataset.handle)
              && String(item.id || '') !== String(slide.dataset.productId)
            ));
            writeStorage(recentKey, recent);
          }
          syncSaved();
          announce(message);
          window.dispatchEvent(new CustomEvent('weston:flow-saved', { detail: { handle: slide.dataset.handle } }));
          record(existing >= 0 ? 'flow_unsave' : 'flow_save', {
            handle: slide.dataset.handle,
            price: Number(slide.dataset.priceCents || 0)
          });
        });
      });

      root.querySelectorAll('[data-flow-share]').forEach((button) => {
        button.addEventListener('click', async () => {
          const slide = button.closest('[data-flow-slide]');
          const url = new URL(button.dataset.productUrl, window.location.origin).href;
          try {
            if (navigator.share) await navigator.share({ title: slide.dataset.productTitle, url });
            else await navigator.clipboard.writeText(url);
            announce(root.dataset.shared);
            record('flow_share', { handle: slide.dataset.handle });
          } catch (error) { return; }
        });
      });

      const syncForYou = () => {
        const button = root.querySelector('[data-flow-for-you]');
        if (!button) return;
        button.setAttribute('aria-pressed', String(personalizationEnabled));
        const label = button.querySelector('[data-flow-for-you-label]');
        if (label) label.textContent = personalizationEnabled ? root.dataset.forYouOn : root.dataset.forYouOff;
      };

      root.querySelector('[data-flow-for-you]')?.addEventListener('click', () => {
        const activeHandle = activeSlide?.dataset.handle;
        personalizationEnabled = !personalizationEnabled;
        writeStorage(personalizationKey, personalizationEnabled);
        personalizeSlides();
        activeSlide = allSlides.find((slide) => slide.dataset.handle === activeHandle) || visibleSlides()[0];
        applyFilters({ preserve: true });
        if (activeSlide && viewport) viewport.scrollTo({ top: activeSlide.offsetTop, behavior: 'auto' });
        syncForYou();
        announce(personalizationEnabled ? root.dataset.forYouOn : root.dataset.forYouOff);
        record('flow_personalization', { enabled: personalizationEnabled });
      });

      root.querySelectorAll('[data-flow-feedback]').forEach((button) => {
        button.addEventListener('click', () => {
          const slide = button.closest('[data-flow-slide]');
          const action = button.dataset.flowFeedback;
          const handle = slide.dataset.handle;
          const category = categoryOf(slide.dataset.productHaystack);
          const profile = readProfile();
          profile.more = (profile.more || []).filter((item) => item !== handle);
          profile.less = (profile.less || []).filter((item) => item !== handle);
          profile.hidden = profile.hidden || [];
          profile.categoryWeights = profile.categoryWeights || {};
          let message = root.dataset.moreConfirmed;

          if (action === 'more') {
            profile.more.unshift(handle);
            profile.categoryWeights[category] = Number(profile.categoryWeights[category] || 0) + 2;
            const price = Number(slide.dataset.priceCents || 0);
            if (price) profile.priceTarget = profile.priceTarget ? Math.round((Number(profile.priceTarget) * .7) + (price * .3)) : price;
          }
          if (action === 'less') {
            profile.less.unshift(handle);
            profile.categoryWeights[category] = Number(profile.categoryWeights[category] || 0) - 2;
            message = root.dataset.lessConfirmed;
          }
          if (action === 'hide') {
            if (!profile.hidden.includes(handle)) profile.hidden.unshift(handle);
            message = root.dataset.hiddenConfirmed;
          }

          writeStorage(profileKey, profile);
          paintReasons();
          announce(message);
          record(`flow_feedback_${action}`, { handle, category, price: Number(slide.dataset.priceCents || 0) });

          if (action === 'hide') {
            const slides = visibleSlides();
            const index = slides.indexOf(slide);
            activeSlide = slides[index + 1] || slides[index - 1] || null;
            applyFilters({ preserve: true });
            if (activeSlide && viewport) {
              viewport.scrollTo({ top: activeSlide.offsetTop, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
            }
          }
        });
      });

      root.querySelectorAll('[data-flow-fit-open]').forEach((button) => {
        button.addEventListener('click', () => {
          window.dispatchEvent(new CustomEvent('weston:inner-circle-open'));
          window.setTimeout(() => {
            if (document.querySelector('[data-circle-drawer]:not([hidden])')) return;
            document.querySelector('[data-weston-memory-trigger]')?.click();
            window.setTimeout(() => document.querySelector('[data-weston-memory-tab="fit"]')?.click(), 50);
          }, 120);
          record('flow_fit_passport_open', { handle: button.closest('[data-flow-slide]')?.dataset.handle });
        });
      });

      storySlides.forEach((slide) => {
        slide.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
          record('flow_story_click', { handle: slide.dataset.handle, destination: link.href });
        }));
      });

      const audienceAllows = (candidate, lens) => {
        const gender = genderOf(`${candidate.title} ${candidate.type} ${candidate.tags}`);
        if (lens === 'women') return gender !== 'men';
        if (lens === 'men') return gender !== 'women';
        return true;
      };

      const moodWords = {
        day: ['easy', 'everyday', 'casual', 'classic', 'soft', 'day'],
        'after-dark': ['night', 'lace', 'satin', 'dress', 'lingerie', 'party', 'cocktail', 'mini', 'jewel', 'heel'],
        minimal: ['minimal', 'clean', 'classic', 'solid', 'neutral', 'simple'],
        bold: ['bold', 'statement', 'print', 'color', 'metallic', 'oversized', 'graphic']
      };

      const wantedCategories = (category) => {
        if (category === 'one-piece') return ['accessory', 'shoe', 'layer'];
        if (category === 'top') return ['bottom', 'accessory', 'shoe', 'layer'];
        if (category === 'bottom') return ['top', 'accessory', 'shoe', 'layer'];
        if (category === 'intimate') return ['layer', 'accessory', 'shoe'];
        if (category === 'accessory' || category === 'shoe') return ['one-piece', 'top', 'bottom', 'layer'];
        return ['accessory', 'top', 'bottom', 'one-piece', 'layer', 'shoe'];
      };

      const scoreCandidates = () => {
        if (!activeSlide) return [];
        const lens = document.documentElement.dataset.westonLens || localStorage.getItem('weston-lens') || 'all';
        const currentCategory = categoryOf(activeSlide.dataset.productHaystack);
        const wanted = wantedCategories(currentCategory);
        const words = moodWords[mood] || moodWords.day;
        const profile = readProfile();
        const saved = savedHandles();
        return pool
          .filter((candidate) => candidate.available && candidate.image && candidate.handle !== activeSlide.dataset.handle)
          .filter((candidate) => audienceAllows(candidate, lens))
          .filter((candidate) => (candidate.variants || []).some((variant) => variant.available))
          .map((candidate) => {
            const text = `${candidate.title} ${candidate.type} ${candidate.tags}`.toLowerCase();
            const category = categoryOf(text);
            let score = wanted.includes(category) ? 20 - wanted.indexOf(category) : 1;
            score += words.reduce((total, word) => total + (text.includes(word) ? 4 : 0), 0);
            score += category !== currentCategory ? 5 : -8;
            score += Number(profile.categoryWeights?.[category] || 0) * 3;
            if (profile.more?.includes(candidate.handle)) score += 16;
            if (profile.less?.includes(candidate.handle)) score -= 14;
            if (saved.has(candidate.handle)) score += 8;
            score += (candidate.handle.length + remixTurn) % 7;
            return { ...candidate, category, score };
          })
          .sort((a, b) => b.score - a.score || a.title.localeCompare(b.title));
      };

      const currentVariant = () => {
        const field = activeSlide?.querySelector('[data-flow-variant]');
        if (!field) return null;
        const option = field.selectedOptions?.[0];
        return {
          id: Number(field.value),
          price: Number(option?.dataset.priceCents || field.dataset.priceCents || 0)
        };
      };

      const remixVariant = (card) => {
        const select = card.querySelector('[data-remix-variant]');
        if (select) {
          const option = select.selectedOptions[0];
          return { id: Number(select.value), price: Number(option.dataset.price || 0) };
        }
        return { id: Number(card.dataset.variantId), price: Number(card.dataset.variantPrice || 0) };
      };

      const readRemixDraft = () => {
        const draft = readStorage(remixDraftKey, null);
        if (!draft || !draft.savedAt || Date.now() - Number(draft.savedAt) > 604800000) {
          try { localStorage.removeItem(remixDraftKey); } catch (error) { return null; }
          return null;
        }
        return draft;
      };

      const syncDraftButtons = () => {
        const draft = readRemixDraft();
        root.querySelectorAll('[data-flow-remix]').forEach((button) => {
          const slide = button.closest('[data-flow-slide]');
          const label = button.querySelector('[data-flow-remix-label]');
          if (label) label.textContent = draft?.baseHandle === slide.dataset.handle ? root.dataset.remixResume : root.dataset.remixLabel;
        });
      };

      const saveRemixDraft = () => {
        if (!activeSlide || activeSlide.hasAttribute('data-flow-story') || !remixCandidates.length) return;
        const cards = Array.from(remixGrid?.querySelectorAll('[data-remix-card]') || []);
        const variants = {};
        cards.forEach((card, index) => {
          const candidate = remixCandidates[index];
          if (candidate) variants[candidate.handle] = remixVariant(card).id;
        });
        writeStorage(remixDraftKey, {
          baseHandle: activeSlide.dataset.handle,
          baseVariant: currentVariant()?.id || null,
          mood,
          candidateHandles: remixCandidates.map((candidate) => candidate.handle),
          variants,
          savedAt: Date.now()
        });
        syncDraftButtons();
      };

      const recalculateTotal = () => {
        const current = currentVariant();
        const cards = Array.from(remixGrid?.querySelectorAll('[data-remix-card]') || []);
        const total = cards.reduce((sum, card) => sum + remixVariant(card).price, current?.price || 0);
        if (lookTotal) lookTotal.textContent = formatMoney(total);
        if (addLook) addLook.disabled = !current || cards.length === 0;
      };

      const buildRemixCard = (candidate, index) => {
        const card = document.createElement('article');
        card.className = 'weston-flow__remix-card';
        card.dataset.remixCard = '';
        card.dataset.remixIndex = String(index);

        const image = document.createElement('img');
        image.src = candidate.image;
        image.alt = candidate.imageAlt || candidate.title;
        image.loading = 'lazy';
        image.width = 720;
        image.height = 960;

        const info = document.createElement('div');
        const kicker = document.createElement('small');
        kicker.textContent = candidate.category === 'accessory' ? root.dataset.remixFinishLabel : root.dataset.remixPieceLabel;
        const link = document.createElement('a');
        link.href = candidate.url;
        link.textContent = candidate.title;
        const available = candidate.variants.filter((variant) => variant.available);
        const first = available[0];
        const price = document.createElement('strong');
        price.textContent = formatMoney(first?.price || 0);

        info.append(kicker, link, price);
        if (available.length > 1 || (first && first.title !== 'Default Title')) {
          const label = document.createElement('label');
          const selectId = `WestonRemix-${root.id}-${candidate.id}-${index}`;
          label.htmlFor = selectId;
          label.textContent = template(root.dataset.chooseVariant, { product: candidate.title });
          const select = document.createElement('select');
          select.id = selectId;
          select.dataset.remixVariant = '';
          available.forEach((variant) => {
            const option = document.createElement('option');
            option.value = variant.id;
            option.dataset.price = variant.price;
            option.textContent = `${variant.title} — ${formatMoney(variant.price)}`;
            select.append(option);
          });
          select.addEventListener('change', () => {
            price.textContent = formatMoney(select.selectedOptions[0].dataset.price);
            recalculateTotal();
            saveRemixDraft();
          });
          info.append(label, select);
        } else if (first) {
          card.dataset.variantId = first.id;
          card.dataset.variantPrice = first.price;
        }

        const swap = document.createElement('button');
        swap.type = 'button';
        swap.textContent = root.dataset.swapLabel;
        swap.addEventListener('click', () => {
          const ranked = scoreCandidates();
          const used = new Set(remixCandidates.map((item) => item.handle));
          const replacement = ranked.find((item) => !used.has(item.handle) && item.category === candidate.category)
            || ranked.find((item) => !used.has(item.handle));
          if (!replacement) return;
          remixCandidates[index] = replacement;
          renderRemixGrid();
          record('flow_remix_swap', { from: candidate.handle, to: replacement.handle });
        });
        info.append(swap);
        card.append(image, info);
        return card;
      };

      const renderRemixGrid = (options = {}) => {
        if (!remixGrid) return;
        remixGrid.replaceChildren();
        if (!remixCandidates.length) {
          const empty = document.createElement('p');
          empty.className = 'weston-flow__remix-empty';
          empty.textContent = root.dataset.lookEmpty;
          remixGrid.append(empty);
          if (addLook) addLook.disabled = true;
          return;
        }
        remixCandidates.forEach((candidate, index) => remixGrid.append(buildRemixCard(candidate, index)));
        recalculateTotal();
        if (options.save !== false) saveRemixDraft();
      };

      const restoreRemixDraft = () => {
        const draft = readRemixDraft();
        if (!draft || draft.baseHandle !== activeSlide?.dataset.handle) return false;
        const restored = (draft.candidateHandles || []).map((handle) => pool.find((candidate) => candidate.handle === handle)).filter(Boolean);
        if (!restored.length) return false;
        mood = draft.mood || mood;
        remixCandidates = restored;
        root.querySelectorAll('[data-flow-mood]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.flowMood === mood));
        });
        const baseField = activeSlide.querySelector('[data-flow-variant]');
        if (baseField && draft.baseVariant && Array.from(baseField.options || []).some((option) => Number(option.value) === Number(draft.baseVariant))) {
          baseField.value = String(draft.baseVariant);
          baseField.dispatchEvent(new Event('change', { bubbles: true }));
        }
        renderRemixGrid({ save: false });
        Array.from(remixGrid.querySelectorAll('[data-remix-card]')).forEach((card, index) => {
          const candidate = remixCandidates[index];
          const select = card.querySelector('[data-remix-variant]');
          const variantId = draft.variants?.[candidate?.handle];
          if (select && variantId && Array.from(select.options).some((option) => Number(option.value) === Number(variantId))) {
            select.value = String(variantId);
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        const restoredMessage = root.querySelector('[data-flow-remix-restored]');
        if (restoredMessage) restoredMessage.hidden = false;
        saveRemixDraft();
        announce(root.dataset.remixRestored);
        return true;
      };

      const styleLook = () => {
        remixTurn += 1;
        const ranked = scoreCandidates();
        const selected = [];
        const usedCategories = new Set();
        ranked.forEach((candidate) => {
          if (selected.length >= 3) return;
          if (!usedCategories.has(candidate.category)) {
            selected.push(candidate);
            usedCategories.add(candidate.category);
          }
        });
        ranked.forEach((candidate) => {
          if (selected.length >= 3 || selected.includes(candidate)) return;
          selected.push(candidate);
        });
        remixCandidates = selected.slice(0, 3);
        renderRemixGrid();
        const restoredMessage = root.querySelector('[data-flow-remix-restored]');
        if (restoredMessage) restoredMessage.hidden = true;
      };

      root.querySelectorAll('[data-flow-remix]').forEach((button) => {
        button.addEventListener('click', () => {
          activeSlide = button.closest('[data-flow-slide]');
          returnFocus = button;
          if (!restoreRemixDraft()) styleLook();
          if (addLook) addLook.textContent = root.dataset.addLookLabel;
          if (typeof dialog?.showModal === 'function') dialog.showModal();
          else dialog?.setAttribute('open', '');
          dialog?.querySelector('[data-flow-remix-close]')?.focus();
          record('flow_remix_open', { handle: activeSlide.dataset.handle });
        });
      });

      root.querySelector('[data-flow-remix-close]')?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog?.addEventListener('close', () => returnFocus?.focus());

      root.querySelectorAll('[data-flow-mood]').forEach((button) => {
        button.addEventListener('click', () => {
          mood = button.dataset.flowMood;
          root.querySelectorAll('[data-flow-mood]').forEach((choice) => {
            choice.setAttribute('aria-pressed', String(choice === button));
          });
          styleLook();
          record('flow_remix_mood', { mood });
        });
        button.setAttribute('aria-pressed', String(button.dataset.flowMood === mood));
      });

      addLook?.addEventListener('click', async () => {
        const current = currentVariant();
        const cards = Array.from(remixGrid.querySelectorAll('[data-remix-card]'));
        const items = [current, ...cards.map(remixVariant)].filter((item) => item?.id).map((item) => ({ id: item.id, quantity: 1 }));
        if (items.length < 2) return;
        addLook.disabled = true;
        try {
          await addItems(items);
          announce(root.dataset.lookAdded);
          addLook.textContent = root.dataset.lookAdded;
          record('flow_add_look', { handle: activeSlide.dataset.handle, count: items.length, mood });
          try { localStorage.removeItem(remixDraftKey); } catch (error) {}
          syncDraftButtons();
          window.setTimeout(() => dialog.close(), 1200);
        } catch (error) {
          announce(root.dataset.error);
          addLook.disabled = false;
        }
      });

      root.querySelectorAll('[data-flow-lens]').forEach((button) => {
        button.addEventListener('click', () => {
          const lens = button.dataset.flowLens;
          localStorage.setItem('weston-lens', lens);
          document.documentElement.dataset.westonLens = lens;
          window.dispatchEvent(new CustomEvent('weston:lens-change', { detail: { lens } }));
          applyFilters();
          record('flow_filter_lens', { lens });
        });
      });

      root.querySelector('[data-flow-after-dark]')?.addEventListener('click', (event) => {
        const enabled = event.currentTarget.getAttribute('aria-pressed') !== 'true';
        const occasion = enabled ? 'after-hours' : 'everyday';
        localStorage.setItem('weston-occasion', occasion);
        document.documentElement.dataset.westonOccasion = occasion;
        window.dispatchEvent(new CustomEvent('weston:occasion-change', { detail: { occasion } }));
        applyFilters();
        record('flow_filter_after_dark', { enabled });
      });

      window.addEventListener('weston:lens-change', applyFilters);
      window.addEventListener('weston:occasion-change', applyFilters);
      personalizeSlides();
      syncForYou();
      syncDraftButtons();
      syncSaved();
      paintFitConfidence();
      applyFilters();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-gift-blessing-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrapText = (context, text, maxWidth) => {
      const words = text.trim().split(/\s+/).filter(Boolean);
      const lines = [];
      let line = '';
      words.forEach((word) => {
        const next = line ? `${line} ${word}` : word;
        if (line && context.measureText(next).width > maxWidth) {
          lines.push(line);
          line = word;
        } else {
          line = next;
        }
      });
      if (line) lines.push(line);
      return lines;
    };

    const initBlessing = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const productButtons = [...root.querySelectorAll('[data-blessing-product]')];
      const verseButtons = [...root.querySelectorAll('[data-blessing-verse]')];
      const recipient = root.querySelector('[data-blessing-recipient]');
      const message = root.querySelector('[data-blessing-message]');
      const sender = root.querySelector('[data-blessing-sender]');
      const recipientOutput = root.querySelector('[data-blessing-for]');
      const verseOutput = root.querySelector('[data-blessing-verse-output]');
      const referenceOutput = root.querySelector('[data-blessing-reference-output]');
      const messageOutput = root.querySelector('[data-blessing-message-output]');
      const senderOutput = root.querySelector('[data-blessing-from]');
      const productOutput = root.querySelector('[data-blessing-product-output]');
      const productLink = root.querySelector('[data-blessing-product-link]');
      const status = root.querySelector('[data-blessing-status]');
      let selectedProduct = productButtons[0] || null;
      let selectedVerse = verseButtons[0] || null;

      const setActive = (buttons, selected) => {
        buttons.forEach((button) => {
          const active = button === selected;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      };

      const render = () => {
        recipientOutput.textContent = recipient.value.trim() ? `${root.dataset.recipientPrefix || ''} ${recipient.value.trim()}`.trim() : recipientOutput.dataset.defaultLabel;
        messageOutput.textContent = message.value.trim() || messageOutput.dataset.defaultLabel;
        senderOutput.textContent = sender.value.trim() ? `${root.dataset.senderPrefix || ''} ${sender.value.trim()}`.trim() : '';
        if (selectedVerse) {
          verseOutput.textContent = selectedVerse.dataset.verse || '';
          referenceOutput.textContent = selectedVerse.dataset.reference || '';
        }
        if (selectedProduct) {
          productOutput.textContent = selectedProduct.dataset.productTitle || '';
          productLink.href = selectedProduct.dataset.productUrl || '#';
        }
        status.textContent = '';
      };

      productButtons.forEach((button) => button.addEventListener('click', () => {
        selectedProduct = button;
        setActive(productButtons, button);
        render();
      }));
      verseButtons.forEach((button) => button.addEventListener('click', () => {
        selectedVerse = button;
        setActive(verseButtons, button);
        render();
      }));
      [recipient, message, sender].forEach((input) => input?.addEventListener('input', render));

      const makeCanvas = () => {
        const canvas = document.createElement('canvas');
        canvas.width = 1080;
        canvas.height = 1350;
        const context = canvas.getContext('2d');
        const gradient = context.createRadialGradient(540, 480, 20, 540, 480, 720);
        gradient.addColorStop(0, '#3f2931');
        gradient.addColorStop(1, '#171019');
        context.fillStyle = gradient;
        context.fillRect(0, 0, 1080, 1350);
        context.strokeStyle = '#e4c479';
        context.globalAlpha = 0.65;
        context.lineWidth = 2;
        context.strokeRect(42, 42, 996, 1266);
        context.globalAlpha = 1;
        context.textAlign = 'center';
        context.fillStyle = '#e4c479';
        context.font = '700 21px Arial, sans-serif';
        context.fillText((root.dataset.canvasBrand || '').toUpperCase(), 540, 105);
        context.font = '500 58px Georgia, serif';
        const forLines = wrapText(context, recipientOutput.textContent || '', 800);
        forLines.forEach((line, index) => context.fillText(line, 540, 240 + index * 66));

        context.fillStyle = '#fffaf0';
        context.font = '600 50px Georgia, serif';
        const verseLines = wrapText(context, verseOutput.textContent || '', 800);
        const verseStart = 570 - ((verseLines.length - 1) * 62) / 2;
        verseLines.forEach((line, index) => context.fillText(line, 540, verseStart + index * 62));
        context.fillStyle = '#e4c479';
        context.font = '700 22px Arial, sans-serif';
        context.fillText((referenceOutput.textContent || '').toUpperCase(), 540, 820);

        context.fillStyle = '#d9cfd2';
        context.font = '400 30px Arial, sans-serif';
        const messageLines = wrapText(context, messageOutput.textContent || '', 760).slice(0, 4);
        messageLines.forEach((line, index) => context.fillText(line, 540, 910 + index * 42));
        if (senderOutput.textContent) {
          context.fillStyle = '#e4c479';
          context.font = 'italic 26px Georgia, serif';
          context.fillText(senderOutput.textContent, 540, 1100);
        }
        context.fillStyle = '#a99ca0';
        context.font = '700 17px Arial, sans-serif';
        context.fillText((root.dataset.canvasGiftLabel || '').toUpperCase(), 540, 1180);
        context.fillStyle = '#fffaf0';
        context.font = '700 20px Arial, sans-serif';
        const productLines = wrapText(context, productOutput.textContent || '', 760).slice(0, 2);
        productLines.forEach((line, index) => context.fillText(line.toUpperCase(), 540, 1218 + index * 27));
        context.font = '700 17px Arial, sans-serif';
        context.fillText((root.dataset.canvasDomain || '').toUpperCase(), 540, 1280);
        return canvas;
      };

      const makeBlob = () => new Promise((resolve, reject) => makeCanvas().toBlob((blob) => blob ? resolve(blob) : reject(new Error('blessing')), 'image/png', 1));
      const download = (blob) => {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = 'weston-gift-blessing.png';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1200);
      };

      root.querySelector('[data-blessing-save]')?.addEventListener('click', async () => {
        try {
          download(await makeBlob());
          status.textContent = status.dataset.readyLabel || '';
        } catch (error) {
          status.textContent = status.dataset.errorLabel || '';
        }
      });

      root.querySelector('[data-blessing-share]')?.addEventListener('click', async () => {
        try {
          const blob = await makeBlob();
          const file = new File([blob], 'weston-gift-blessing.png', { type: 'image/png' });
          if (navigator.share && navigator.canShare?.({ files: [file] })) {
            await navigator.share({ title: recipientOutput.textContent || '', text: `${verseOutput.textContent || ''} — ${referenceOutput.textContent || ''}`, files: [file] });
          } else {
            download(blob);
            status.textContent = status.dataset.readyLabel || '';
          }
        } catch (error) {
          if (error?.name !== 'AbortError') status.textContent = status.dataset.errorLabel || '';
        }
      });

      root.querySelector('[data-blessing-print]')?.addEventListener('click', async () => {
        try {
          const blob = await makeBlob();
          const url = URL.createObjectURL(blob);
          const printWindow = window.open('', '_blank');
          if (!printWindow) throw new Error('print');
          printWindow.opener = null;
          printWindow.document.write(`<title>Gift Blessing</title><style>html,body{margin:0;background:#fff}body{display:grid;place-items:center;min-height:100vh}img{display:block;max-width:100%;max-height:100vh}@media print{img{width:100%;max-height:none}}</style><img src="${url}" alt="">`);
          printWindow.document.close();
          printWindow.addEventListener('load', () => {
            printWindow.focus();
            printWindow.print();
            window.setTimeout(() => URL.revokeObjectURL(url), 1500);
          }, { once: true });
        } catch (error) {
          status.textContent = status.dataset.errorLabel || '';
        }
      });

      render();
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-gift-blessing]')) initBlessing(scope);
      scope.querySelectorAll('[data-weston-gift-blessing]').forEach(initBlessing);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-gift-ritual-2026"]) return;
  try {
    
  document.querySelectorAll('[data-wg-gift-ritual]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-wg-gift-form]');
    const details = root.querySelector('[data-wg-gift-details]');
    const toggles = [...root.querySelectorAll('[data-wg-gift-toggle]')];
    const detailFields = [...root.querySelectorAll('[data-wg-gift-detail]')];
    const saveButton = root.querySelector('[data-wg-gift-save]');

    const syncGiftState = (clearDetails = false) => {
      const active = toggles.find((toggle) => toggle.checked)?.value === 'Yes';
      details.hidden = !active;
      details.setAttribute('aria-hidden', String(!active));
      if (!active && clearDetails) {
        detailFields.forEach((field) => {
          if (field.type === 'radio') {
            field.checked = field.value === 'No';
          } else if (field.tagName === 'SELECT') {
            field.selectedIndex = 0;
          } else {
            field.value = '';
          }
        });
      }
    };

    toggles.forEach((toggle) => {
      toggle.addEventListener('change', () => syncGiftState(toggle.value === 'No'));
    });
    form.addEventListener('submit', () => {
      const active = toggles.find((toggle) => toggle.checked)?.value === 'Yes';
      if (!active) syncGiftState(true);
      saveButton.setAttribute('aria-busy', 'true');
    });
    syncGiftState();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-glass-atelier-2026"]) return;
  try {
    
  document.documentElement.classList.add('wg-glass-atelier-ready');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-growth-routes-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__westonGrowthRoutes2026) return;
    window.__westonGrowthRoutes2026 = true;
    document.addEventListener('click', (event) => {
      const route = event.target.closest?.('[data-weston-growth-route]');
      if (!route) return;
      const payload = { event: 'weston_growth_route_selected', route: route.dataset.westonGrowthRoute };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('weston:growth-event', { detail: payload }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-inner-circle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-weston-inner-circle]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const drawer = root.querySelector('[data-circle-drawer]');
    const backdrop = root.querySelector('[data-circle-backdrop]');
    const close = root.querySelector('[data-circle-close]');
    const form = root.querySelector('[data-circle-passport]');
    const status = root.querySelector('[data-circle-status]');
    const validLenses = ['women', 'men', 'all', 'gift'];
    const validOccasions = ['everyday', 'date-night', 'escape', 'event', 'after-hours'];
    let lens = validLenses.includes(localStorage.getItem('weston-lens')) ? localStorage.getItem('weston-lens') : 'all';
    let occasion = validOccasions.includes(localStorage.getItem('weston-occasion')) ? localStorage.getItem('weston-occasion') : 'everyday';

    const readFit = () => {
      try { return JSON.parse(localStorage.getItem('weston-fit-passport')) || {}; } catch (error) { return {}; }
    };

    const trackKey = () => {
      if (lens === 'gift') return 'gift';
      if (occasion === 'after-hours') return `${lens}-night`;
      return lens;
    };

    const render = () => {
      root.querySelectorAll('[data-circle-lens]').forEach((button) => button.classList.toggle('is-active', button.dataset.circleLens === lens));
      root.querySelectorAll('[data-circle-occasion]').forEach((button) => button.classList.toggle('is-active', button.dataset.circleOccasion === occasion));
      root.querySelectorAll('[data-circle-track]').forEach((track) => { track.hidden = track.dataset.circleTrack !== trackKey(); });
      const names = { women: root.dataset.labelWomen, men: root.dataset.labelMen, all: root.dataset.labelAll, gift: root.dataset.labelGift };
      const stamp = root.querySelector('[data-circle-stamp-lens]');
      if (stamp) stamp.textContent = `${names[lens]} ${root.dataset.labelLens}`;
      const issueTitle = root.querySelector('[data-circle-issue-title]');
      const issueCopy = root.querySelector('[data-circle-issue-copy]');
      if (occasion === 'after-hours') {
        issueTitle.textContent = root.dataset.nightTitle;
        issueCopy.textContent = root.dataset.nightCopy;
      } else {
        issueTitle.textContent = root.dataset.dayTitle;
        issueCopy.textContent = root.dataset.dayCopy;
      }
      const fit = readFit();
      if (form) {
        form.elements.size.value = fit.size || '';
        form.elements.fit.value = fit.fit || 'regular';
      }
    };

    const open = () => {
      drawer.hidden = false;
      backdrop.hidden = false;
      drawer.scrollTop = 0;
      document.body.style.overflow = 'hidden';
      render();
      close.focus();
    };

    const shut = () => {
      drawer.hidden = true;
      backdrop.hidden = true;
      document.body.style.overflow = '';
    };

    const injectLaunchpad = () => {
      const launchpad = document.querySelector('.weston-mode__launchpad');
      if (!launchpad || launchpad.querySelector('[data-circle-launch]')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.circleLaunch = '';
      const number = document.createElement('span');
      const title = document.createElement('strong');
      const copy = document.createElement('small');
      number.textContent = '07';
      title.textContent = root.dataset.launchTitle;
      copy.textContent = root.dataset.launchCopy;
      button.append(number, title, copy);
      button.addEventListener('click', () => {
        document.querySelector('[data-weston-mode-close]')?.click();
        window.setTimeout(open, 90);
      });
      launchpad.appendChild(button);
    };

    root.querySelectorAll('[data-circle-lens]').forEach((button) => button.addEventListener('click', () => { lens = button.dataset.circleLens; render(); }));
    root.querySelectorAll('[data-circle-occasion]').forEach((button) => button.addEventListener('click', () => { occasion = button.dataset.circleOccasion; render(); }));
    close.addEventListener('click', shut);
    backdrop.addEventListener('click', shut);
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !drawer.hidden) shut(); });

    if (form) form.addEventListener('submit', (event) => {
      event.preventDefault();
      localStorage.setItem('weston-lens', lens);
      localStorage.setItem('weston-occasion', occasion);
      localStorage.setItem('weston-fit-passport', JSON.stringify({ size: form.elements.size.value, fit: form.elements.fit.value }));
      document.documentElement.dataset.westonOccasion = occasion;
      window.dispatchEvent(new CustomEvent('weston:lens-change', { detail: { lens } }));
      window.dispatchEvent(new CustomEvent('weston:occasion-change', { detail: { occasion } }));
      status.textContent = root.dataset.savedMessage;
      render();
    });

    root.querySelector('[data-circle-sexy]')?.addEventListener('click', () => {
      occasion = 'after-hours';
      localStorage.setItem('weston-occasion', occasion);
      window.dispatchEvent(new CustomEvent('weston:occasion-change', { detail: { occasion } }));
      shut();
      window.location.href = lens === 'men' ? '/collections/mens' : '/collections/womens-dresses';
    });

    window.addEventListener('weston:lens-change', (event) => { if (validLenses.includes(event.detail?.lens)) { lens = event.detail.lens; render(); } });
    window.addEventListener('weston:occasion-change', (event) => { if (validOccasions.includes(event.detail?.occasion)) { occasion = event.detail.occasion; render(); } });
    window.addEventListener('weston:inner-circle-open', open);
    injectLaunchpad();
    window.setTimeout(injectLaunchpad, 700);
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-lens"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-weston-lens-root]');
    if (!root || root.dataset.ready === 'true') return;
    const portal = root.querySelector('[data-weston-lens-portal]');
    const trigger = root.querySelector('[data-weston-lens-trigger]');
    const close = root.querySelector('[data-weston-lens-close]');
    const energy = root.querySelector('[data-weston-energy]');
    const transition = root.querySelector('[data-weston-lens-transition]');
    const welcome = root.querySelector('[data-weston-lens-welcome]');
    const gift = root.querySelector('[data-weston-gift-concierge]');
    const sound = root.querySelector('[data-weston-sound]');
    if (!portal || !trigger || !close || !transition || !welcome || !gift) return;
    root.dataset.ready = 'true';
    const lensKey = 'weston-lens';
    const energyKey = 'weston-style-energy';
    const analyticsKey = 'weston-lens-insights-v1';
    const open = () => { portal.hidden = false; document.body.style.overflow = 'hidden'; portal.querySelector('[data-lens-choice]')?.focus(); };
    const shut = () => { portal.hidden = true; document.body.style.overflow = ''; };
    const energyName = (value) => value < 34 ? 'soft' : value > 66 ? 'sharp' : 'balanced';
    const applyEnergy = (value) => {
      document.documentElement.dataset.westonEnergy = energyName(Number(value));
      if (energy) energy.value = value;
    };
    const record = (event, detail = {}) => {
      try {
        const insights = JSON.parse(localStorage.getItem(analyticsKey)) || [];
        insights.push({ event, detail, at: Date.now() });
        localStorage.setItem(analyticsKey, JSON.stringify(insights.slice(-80)));
      } catch (error) { return; }
    };
    const campaignData = (lens) => {
      const button = root.querySelector(`[data-lens-choice="${lens}"]`);
      const title = button?.querySelector('strong')?.textContent || 'Everything';
      const copy = button?.querySelector('span')?.textContent || '';
      const image = root.dataset[`${lens}Image`] || '';
      const url = root.dataset[`${lens === 'all' ? 'all' : lens}Url`] || root.dataset.allUrl;
      return { title, copy, image, url };
    };
    const paintCampaign = (lens) => {
      if (root.dataset.home !== 'true') return;
      document.querySelector('[data-weston-lens-campaign]')?.remove();
      const data = campaignData(lens);
      const campaign = document.createElement('section');
      campaign.className = `weston-lens__campaign${data.image ? ' has-image' : ''}`;
      campaign.dataset.westonLensCampaign = '';
      if (data.image) campaign.style.backgroundImage = `linear-gradient(90deg, rgba(7,6,7,.78), rgba(7,6,7,.12)), url("${data.image}")`;
      const content = document.createElement('div'); content.className = 'weston-lens__campaign-content';
      const eyebrow = document.createElement('p'); eyebrow.textContent = root.dataset.campaignEyebrow;
      const heading = document.createElement('h1'); heading.textContent = data.title;
      const copy = document.createElement('span'); copy.textContent = data.copy;
      const link = document.createElement('a'); link.href = data.url; link.textContent = `${root.dataset.campaignCta} →`;
      content.append(eyebrow, heading, copy, link); campaign.appendChild(content);
      document.querySelector('#MainContent')?.prepend(campaign);
    };
    const applyLens = (lens, persist = true) => {
      document.documentElement.dataset.westonLens = lens;
      if (persist) localStorage.setItem(lensKey, lens);
      document.querySelectorAll('nav a').forEach((link) => {
        const label = link.textContent.trim().toLowerCase();
        const hideWomen = lens === 'men' && label === 'women';
        const hideMen = lens === 'women' && label === 'men';
        link.classList.toggle('weston-lens-hidden', hideWomen || hideMen);
      });
      document.querySelectorAll('a').forEach((link) => {
        const label = link.textContent.trim().toLowerCase();
        if (!link.dataset.westonOriginalHref) link.dataset.westonOriginalHref = link.getAttribute('href') || '';
        if (label === 'shop all' || label === 'shop now') {
          if (lens === 'women') link.href = root.dataset.womenUrl;
          else if (lens === 'men') link.href = root.dataset.menUrl;
          else if (lens === 'gift') link.href = root.dataset.giftUrl;
          else link.href = root.dataset.allUrl;
        }
      });
      window.dispatchEvent(new CustomEvent('weston:lens-change', { detail: { lens } }));
      paintCampaign(lens);
      record('lens_selected', { lens, energy: document.documentElement.dataset.westonEnergy });
    };
    const savedLens = localStorage.getItem(lensKey);
    const savedEnergy = localStorage.getItem(energyKey) || '50';
    applyEnergy(savedEnergy);
    if (savedLens) {
      applyLens(savedLens, false);
      if (sessionStorage.getItem('weston-welcomed') !== 'true') {
        welcome.textContent = `${root.dataset.welcome} ${campaignData(savedLens).title}.`;
        welcome.hidden = false;
        sessionStorage.setItem('weston-welcomed', 'true');
        window.setTimeout(() => { welcome.hidden = true; }, 4200);
      }
    }
    else applyLens('all', false);
    trigger.addEventListener('click', open);
    close.addEventListener('click', shut);
    portal.addEventListener('keydown', (event) => { if (event.key === 'Escape') shut(); });
    energy?.addEventListener('input', () => { applyEnergy(energy.value); localStorage.setItem(energyKey, energy.value); record('energy_changed', { value: energy.value }); });
    root.querySelectorAll('[data-lens-choice]').forEach((button) => button.addEventListener('click', () => {
      const lens = button.dataset.lensChoice;
      if (lens === 'gift') { gift.hidden = false; gift.querySelector('button')?.focus(); return; }
      transition.classList.add('is-active');
      window.setTimeout(() => { applyLens(lens); shut(); transition.classList.remove('is-active'); }, 380);
    }));
    root.querySelector('[data-weston-gift-back]')?.addEventListener('click', () => { gift.hidden = true; root.querySelector('[data-lens-choice="gift"]')?.focus(); });
    const giftAnswers = {};
    root.querySelectorAll('[data-gift-answer]').forEach((button) => button.addEventListener('click', () => {
      const group = button.dataset.giftAnswer; giftAnswers[group] = button.dataset.value;
      root.querySelectorAll(`[data-gift-answer="${group}"]`).forEach((option) => option.classList.toggle('is-active', option === button));
      localStorage.setItem('weston-gift-profile', JSON.stringify(giftAnswers));
      record('gift_answer', { group, value: button.dataset.value });
    }));
    root.querySelector('[data-weston-gift-enter]')?.addEventListener('click', () => { applyLens('gift'); record('gift_concierge_complete', giftAnswers); });
    let audioContext;
    let oscillator;
    let gain;
    sound?.addEventListener('click', () => {
      const active = sound.getAttribute('aria-pressed') === 'true';
      if (active) {
        gain?.gain.exponentialRampToValueAtTime(.0001, audioContext.currentTime + .3);
        window.setTimeout(() => oscillator?.stop(), 350);
        sound.setAttribute('aria-pressed', 'false'); sound.textContent = `♪ ${root.dataset.soundOff}`;
      } else {
        audioContext = new (window.AudioContext || window.webkitAudioContext)(); oscillator = audioContext.createOscillator(); gain = audioContext.createGain();
        oscillator.type = 'sine'; oscillator.frequency.value = 174; gain.gain.value = .018; oscillator.connect(gain).connect(audioContext.destination); oscillator.start();
        sound.setAttribute('aria-pressed', 'true'); sound.textContent = `♪ ${root.dataset.soundOn}`;
      }
      record('sound_toggled', { active: !active });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-living-bible-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const POSITION_KEY = 'weston-sanctuary-bible-position';
    const BOOKMARKS_KEY = 'weston-sanctuary-bible-bookmarks';
    const FONT_KEY = 'weston-sanctuary-bible-font';

    const readStorage = (key, fallback) => {
      try {
        const value = window.localStorage.getItem(key);
        return value ? JSON.parse(value) : fallback;
      } catch (error) {
        return fallback;
      }
    };

    const writeStorage = (key, value) => {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
      }
    };

    const initReader = (root) => {
      if (!root || root.dataset.readerReady === 'true') return;
      root.dataset.readerReady = 'true';

      const shell = root.querySelector('[data-reader-shell]');
      const booksNode = root.querySelector('[data-bible-books]');
      const bookSelect = root.querySelector('[data-bible-book]');
      const chapterSelect = root.querySelector('[data-bible-chapter]');
      const previousButton = root.querySelector('[data-bible-previous]');
      const nextButton = root.querySelector('[data-bible-next]');
      const searchInput = root.querySelector('[data-bible-search]');
      const referenceNode = root.querySelector('[data-bible-reference]');
      const statusNode = root.querySelector('[data-bible-status]');
      const textNode = root.querySelector('[data-bible-text]');
      const readerNode = root.querySelector('[data-bible-reader]');
      const saveButton = root.querySelector('[data-save-chapter]');
      const saveText = root.querySelector('[data-save-text]');
      const bookmarkList = root.querySelector('[data-bookmark-list]');
      const bookmarkCount = root.querySelector('[data-bookmark-count]');
      const listenButton = root.querySelector('[data-listen-chapter]');
      const listenText = root.querySelector('[data-listen-text]');
      const stopButton = root.querySelector('[data-stop-reading]');
      const continueButton = root.querySelector('[data-continue-reading]');
      const continueReference = root.querySelector('[data-continue-reference]');
      const decreaseButton = root.querySelector('[data-font-decrease]');
      const increaseButton = root.querySelector('[data-font-increase]');
      const cache = new Map();
      let books = [];
      let currentVerses = [];
      let currentBook = Number(root.dataset.defaultBook) || 43;
      let currentChapter = Number(root.dataset.defaultChapter) || 1;
      let pendingPosition = null;
      let speechState = 'idle';
      let speechIndex = 0;
      let activeUtterance = null;
      let loadSequence = 0;
      let readerStarted = false;
      let visibilityObserver = null;

      if (!shell || !booksNode || !bookSelect || !chapterSelect || !textNode) return;

      try {
        books = JSON.parse(booksNode.textContent);
      } catch (error) {
        books = [];
      }
      if (!books.length) return;

      const storedPosition = readStorage(POSITION_KEY, null);
      if (storedPosition && books.some((book) => book.number === Number(storedPosition.book))) {
        pendingPosition = {
          book: Number(storedPosition.book),
          chapter: Number(storedPosition.chapter)
        };
        const storedBook = books.find((book) => book.number === pendingPosition.book);
        if (storedBook && pendingPosition.chapter >= 1 && pendingPosition.chapter <= storedBook.chapters) {
          continueButton.hidden = false;
          continueReference.textContent = `${storedBook.name} ${pendingPosition.chapter}`;
        }
      }

      const currentBookData = () => books.find((book) => book.number === currentBook) || books[0];

      const populateBooks = () => {
        bookSelect.replaceChildren();
        books.forEach((book) => {
          const option = new Option(book.name, String(book.number));
          option.selected = book.number === currentBook;
          bookSelect.add(option);
        });
      };

      const populateChapters = () => {
        const book = currentBookData();
        chapterSelect.replaceChildren();
        for (let chapter = 1; chapter <= book.chapters; chapter += 1) {
          const option = new Option(String(chapter), String(chapter));
          option.selected = chapter === currentChapter;
          chapterSelect.add(option);
        }
      };

      const setStatus = (message) => {
        if (statusNode) statusNode.textContent = message || '';
      };

      const appendHighlightedText = (container, text, term) => {
        if (!term) {
          container.append(document.createTextNode(text));
          return;
        }
        const lowerText = text.toLocaleLowerCase();
        const lowerTerm = term.toLocaleLowerCase();
        let cursor = 0;
        let matchIndex = lowerText.indexOf(lowerTerm, cursor);
        while (matchIndex !== -1) {
          container.append(document.createTextNode(text.slice(cursor, matchIndex)));
          const mark = document.createElement('mark');
          mark.textContent = text.slice(matchIndex, matchIndex + term.length);
          container.append(mark);
          cursor = matchIndex + term.length;
          matchIndex = lowerText.indexOf(lowerTerm, cursor);
        }
        container.append(document.createTextNode(text.slice(cursor)));
      };

      const renderVerses = () => {
        const term = searchInput?.value.trim() || '';
        const visibleVerses = currentVerses.filter((verse) => !term || verse.text.toLocaleLowerCase().includes(term.toLocaleLowerCase()));
        textNode.replaceChildren();
        if (!visibleVerses.length) {
          const empty = document.createElement('p');
          empty.className = 'wg-living-bible__reader-empty';
          empty.textContent = shell.dataset.emptySearchLabel || '';
          textNode.append(empty);
          return;
        }
        visibleVerses.forEach((verse) => {
          const paragraph = document.createElement('p');
          paragraph.className = 'wg-living-bible__verse';
          paragraph.dataset.verseNumber = String(verse.verse);
          const number = document.createElement('button');
          number.type = 'button';
          number.className = 'wg-living-bible__verse-number';
          number.textContent = String(verse.verse);
          number.dataset.copyVerse = String(verse.verse);
          number.setAttribute('aria-label', `${shell.dataset.copyVerseLabel || ''} ${verse.name}`);
          const content = document.createElement('span');
          appendHighlightedText(content, verse.text.trim(), term);
          paragraph.append(number, content);
          textNode.append(paragraph);
        });
      };

      const updateNavigation = () => {
        if (previousButton) previousButton.disabled = currentBook === 1 && currentChapter === 1;
        if (nextButton) nextButton.disabled = currentBook === 66 && currentChapter === 22;
      };

      const getBookmarks = () => {
        const stored = readStorage(BOOKMARKS_KEY, []);
        return Array.isArray(stored) ? stored : [];
      };

      const isCurrentBookmarked = () => getBookmarks().some((item) => item.book === currentBook && item.chapter === currentChapter);

      const updateSaveButton = () => {
        const saved = isCurrentBookmarked();
        saveButton?.setAttribute('aria-pressed', saved ? 'true' : 'false');
        if (saveText) saveText.textContent = saved ? shell.dataset.savedLabel || '' : shell.dataset.saveLabel || '';
      };

      const renderBookmarks = () => {
        const bookmarks = getBookmarks();
        if (bookmarkCount) bookmarkCount.textContent = String(bookmarks.length);
        if (!bookmarkList) return;
        bookmarkList.replaceChildren();
        if (!bookmarks.length) {
          const empty = document.createElement('p');
          empty.className = 'wg-living-bible__bookmark-empty';
          empty.textContent = shell.dataset.bookmarksEmptyLabel || '';
          bookmarkList.append(empty);
          return;
        }
        bookmarks.forEach((bookmark) => {
          const row = document.createElement('div');
          row.className = 'wg-living-bible__bookmark-row';
          const open = document.createElement('button');
          open.type = 'button';
          open.textContent = `${bookmark.name} ${bookmark.chapter}`;
          open.addEventListener('click', () => setPosition(bookmark.book, bookmark.chapter, true));
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = shell.dataset.removeLabel || '';
          remove.addEventListener('click', () => {
            const next = getBookmarks().filter((item) => !(item.book === bookmark.book && item.chapter === bookmark.chapter));
            writeStorage(BOOKMARKS_KEY, next);
            renderBookmarks();
            updateSaveButton();
          });
          row.append(open, remove);
          bookmarkList.append(row);
        });
      };

      const stopSpeech = () => {
        if ('speechSynthesis' in window) window.speechSynthesis.cancel();
        speechState = 'idle';
        speechIndex = 0;
        activeUtterance = null;
        textNode.querySelectorAll('.is-speaking').forEach((node) => node.classList.remove('is-speaking'));
        listenButton?.setAttribute('aria-pressed', 'false');
        if (listenText) listenText.textContent = shell.dataset.listenLabel || '';
        if (stopButton) stopButton.disabled = true;
      };

      const speakVerse = () => {
        if (speechIndex >= currentVerses.length) {
          stopSpeech();
          setStatus(shell.dataset.readingCompleteLabel || '');
          return;
        }
        const verse = currentVerses[speechIndex];
        const utterance = new SpeechSynthesisUtterance(`${verse.name}. ${verse.text.trim()}`);
        utterance.lang = 'en-US';
        utterance.rate = 0.92;
        utterance.onstart = () => {
          textNode.querySelectorAll('.is-speaking').forEach((node) => node.classList.remove('is-speaking'));
          textNode.querySelector(`[data-verse-number="${verse.verse}"]`)?.classList.add('is-speaking');
        };
        utterance.onend = () => {
          speechIndex += 1;
          if (speechState === 'speaking') speakVerse();
        };
        utterance.onerror = () => stopSpeech();
        activeUtterance = utterance;
        window.speechSynthesis.speak(utterance);
      };

      const loadChapter = async () => {
        readerStarted = true;
        visibilityObserver?.disconnect();
        const requestSequence = ++loadSequence;
        stopSpeech();
        const book = currentBookData();
        currentChapter = Math.max(1, Math.min(currentChapter, book.chapters));
        const requestedBook = currentBook;
        const requestedChapter = currentChapter;
        bookSelect.value = String(currentBook);
        populateChapters();
        chapterSelect.value = String(currentChapter);
        if (referenceNode) referenceNode.textContent = `${book.name} ${currentChapter}`;
        if (searchInput) searchInput.value = '';
        setStatus(shell.dataset.loadingLabel || '');
        textNode.setAttribute('aria-busy', 'true');
        textNode.replaceChildren();
        const cacheKey = `${requestedBook}:${requestedChapter}`;
        try {
          let data = cache.get(cacheKey);
          if (!data) {
            const response = await fetch(`${root.dataset.apiBase}/${requestedBook}/${requestedChapter}.json`, {
              method: 'GET',
              mode: 'cors',
              credentials: 'omit'
            });
            if (!response.ok) throw new Error(`Reader request failed: ${response.status}`);
            data = await response.json();
            cache.set(cacheKey, data);
          }
          if (requestSequence !== loadSequence || requestedBook !== currentBook || requestedChapter !== currentChapter) return;
          currentVerses = Array.isArray(data.verses) ? data.verses : [];
          renderVerses();
          setStatus('');
          writeStorage(POSITION_KEY, { book: requestedBook, chapter: requestedChapter });
          updateNavigation();
          updateSaveButton();
        } catch (error) {
          if (requestSequence !== loadSequence) return;
          currentVerses = [];
          const message = document.createElement('p');
          message.className = 'wg-living-bible__reader-error';
          message.textContent = shell.dataset.errorLabel || '';
          textNode.replaceChildren(message);
          setStatus(shell.dataset.errorLabel || '');
        } finally {
          if (requestSequence === loadSequence) textNode.setAttribute('aria-busy', 'false');
        }
      };

      const setPosition = (bookNumber, chapterNumber, shouldScroll = false) => {
        const book = books.find((item) => item.number === Number(bookNumber));
        if (!book) return;
        currentBook = book.number;
        currentChapter = Math.max(1, Math.min(Number(chapterNumber) || 1, book.chapters));
        populateBooks();
        loadChapter();
        if (shouldScroll) {
          root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      };

      bookSelect.addEventListener('change', () => setPosition(Number(bookSelect.value), 1));
      chapterSelect.addEventListener('change', () => setPosition(currentBook, Number(chapterSelect.value)));
      previousButton?.addEventListener('click', () => {
        if (currentChapter > 1) {
          setPosition(currentBook, currentChapter - 1);
          return;
        }
        const previousBook = books.find((book) => book.number === currentBook - 1);
        if (previousBook) setPosition(previousBook.number, previousBook.chapters);
      });
      nextButton?.addEventListener('click', () => {
        const book = currentBookData();
        if (currentChapter < book.chapters) {
          setPosition(currentBook, currentChapter + 1);
          return;
        }
        const nextBook = books.find((item) => item.number === currentBook + 1);
        if (nextBook) setPosition(nextBook.number, 1);
      });
      searchInput?.addEventListener('input', renderVerses);

      textNode.addEventListener('click', async (event) => {
        const trigger = event.target.closest('[data-copy-verse]');
        if (!trigger) return;
        const verse = currentVerses.find((item) => item.verse === Number(trigger.dataset.copyVerse));
        if (!verse) return;
        try {
          await navigator.clipboard.writeText(`“${verse.text.trim()}” — ${verse.name} (WEB)`);
          setStatus(shell.dataset.copiedLabel || '');
        } catch (error) {
          setStatus('');
        }
      });

      saveButton?.addEventListener('click', () => {
        const bookmarks = getBookmarks();
        const exists = bookmarks.some((item) => item.book === currentBook && item.chapter === currentChapter);
        const next = exists
          ? bookmarks.filter((item) => !(item.book === currentBook && item.chapter === currentChapter))
          : [...bookmarks, { book: currentBook, chapter: currentChapter, name: currentBookData().name }].slice(-30);
        writeStorage(BOOKMARKS_KEY, next);
        renderBookmarks();
        updateSaveButton();
      });

      listenButton?.addEventListener('click', () => {
        if (!('speechSynthesis' in window) || !('SpeechSynthesisUtterance' in window)) {
          setStatus(shell.dataset.audioUnavailableLabel || '');
          return;
        }
        if (speechState === 'speaking') {
          window.speechSynthesis.pause();
          speechState = 'paused';
          if (listenText) listenText.textContent = shell.dataset.resumeLabel || '';
          return;
        }
        if (speechState === 'paused') {
          window.speechSynthesis.resume();
          speechState = 'speaking';
          if (listenText) listenText.textContent = shell.dataset.pauseLabel || '';
          return;
        }
        if (!currentVerses.length) return;
        speechState = 'speaking';
        speechIndex = 0;
        listenButton.setAttribute('aria-pressed', 'true');
        if (listenText) listenText.textContent = shell.dataset.pauseLabel || '';
        if (stopButton) stopButton.disabled = false;
        speakVerse();
      });
      stopButton?.addEventListener('click', stopSpeech);

      continueButton?.addEventListener('click', () => {
        if (!pendingPosition) return;
        setPosition(pendingPosition.book, pendingPosition.chapter, true);
        continueButton.hidden = true;
      });

      let fontScale = Number(readStorage(FONT_KEY, 1)) || 1;
      const renderFontScale = () => {
        fontScale = Math.max(0.9, Math.min(1.4, fontScale));
        readerNode?.style.setProperty('--bible-font-scale', String(fontScale));
        writeStorage(FONT_KEY, fontScale);
      };
      decreaseButton?.addEventListener('click', () => {
        fontScale = Number((fontScale - 0.1).toFixed(1));
        renderFontScale();
      });
      increaseButton?.addEventListener('click', () => {
        fontScale = Number((fontScale + 0.1).toFixed(1));
        renderFontScale();
      });

      const openFromJourney = (event) => {
        if (!event.detail) return;
        setPosition(Number(event.detail.book), Number(event.detail.chapter), true);
      };
      document.addEventListener('weston:bible:open', openFromJourney);

      populateBooks();
      populateChapters();
      renderBookmarks();
      renderFontScale();
      const startReader = () => {
        if (readerStarted) return;
        loadChapter();
      };
      if ('IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) startReader();
        }, { rootMargin: '320px 0px' });
        visibilityObserver.observe(root);
      } else {
        startReader();
      }

      root._livingBibleCleanup = () => {
        loadSequence += 1;
        visibilityObserver?.disconnect();
        stopSpeech();
        document.removeEventListener('weston:bible:open', openFromJourney);
      };
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-living-bible]')) initReader(scope);
      scope.querySelectorAll('[data-living-bible]').forEach(initReader);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.('[data-living-bible]') ? event.target : event.target.querySelector('[data-living-bible]');
      root?._livingBibleCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-living-system"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-weston-living-system]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const pageType = root.dataset.pageType || 'page';
    document.documentElement.dataset.westonPage = pageType;
    const progressNodes = Array.from(root.querySelectorAll('[data-weston-page-progress]'));
    const percentNode = root.querySelector('[data-weston-page-percent]');
    let frame = 0;

    const updateProgress = () => {
      frame = 0;
      const total = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      const ratio = Math.min(1, Math.max(0, window.scrollY / total));
      progressNodes.forEach((node) => {
        node.style.transform = node.classList.contains('weston-living-system__top-progress')
          ? `scaleX(${ratio})`
          : `scaleY(${ratio})`;
      });
      if (percentNode) percentNode.textContent = String(Math.round(ratio * 100)).padStart(2, '0');
    };

    const requestProgress = () => {
      if (!frame) frame = window.requestAnimationFrame(updateProgress);
    };

    const applyLens = (value) => {
      const lens = ['women', 'men', 'all', 'gift'].includes(value) ? value : 'all';
      root.dataset.lens = lens;
      document.documentElement.dataset.westonLensAudience = lens;
      document.querySelectorAll('[data-weston-audience]').forEach((item) => {
        const audience = item.dataset.westonAudience || 'all';
        const conflicts = (lens === 'women' && audience === 'men') || (lens === 'men' && audience === 'women');
        item.hidden = conflicts;
      });
      document.querySelectorAll('[data-weston-lens-campaign]').forEach((item) => item.remove());
    };

    applyLens(localStorage.getItem('weston-lens') || 'all');
    window.addEventListener('weston:lens-change', (event) => applyLens(event.detail?.lens || event.detail?.value || 'all'));
    window.addEventListener('weston:lenschange', (event) => applyLens(event.detail?.lens || event.detail?.value || 'all'));
    window.addEventListener('scroll', requestProgress, { passive: true });
    window.addEventListener('resize', requestProgress);

    const content = document.querySelector('#MainContent');
    if (content) {
      const observer = new MutationObserver(() => {
        document.querySelectorAll('[data-weston-lens-campaign]').forEach((item) => item.remove());
      });
      observer.observe(content, { childList: true });
    }

    updateProgress();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-mode"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-weston-mode]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const trigger = root.querySelector('[data-weston-mode-trigger]');
    const drawer = root.querySelector('[data-weston-mode-drawer]');
    const backdrop = root.querySelector('[data-weston-mode-backdrop]');
    const close = root.querySelector('[data-weston-mode-close]');
    const read = (key, fallback) => { try { return JSON.parse(localStorage.getItem(key)) || fallback; } catch (error) { return fallback; } };
    const open = () => { drawer.hidden = false; backdrop.hidden = false; trigger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; close.focus(); render(); };
    const shut = () => { drawer.hidden = true; backdrop.hidden = true; trigger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; };
    trigger.addEventListener('click', open); close.addEventListener('click', shut); backdrop.addEventListener('click', shut);
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !drawer.hidden) shut(); });

    const openEngine = (name) => {
      shut();
      if (name === 'lens') document.querySelector('[data-weston-lens-trigger]')?.click();
      if (name === 'world') document.querySelector('[data-weston-world-trigger]')?.click();
      if (name === 'trail') document.querySelector('[data-weston-trail-trigger]')?.click();
      if (['closet', 'fit', 'cart'].includes(name)) {
        document.querySelector('[data-weston-memory-trigger]')?.click();
        window.setTimeout(() => document.querySelector(`[data-weston-memory-tab="${name}"]`)?.click(), 30);
      }
      if (name === 'stories') {
        document.querySelector('[data-weston-trail-trigger]')?.click();
      }
    };
    root.querySelectorAll('[data-mode-open]').forEach((button) => button.addEventListener('click', () => openEngine(button.dataset.modeOpen)));

    const occasionCopy = {
      'everyday': 'Your edit will lean effortless, versatile, and easy to repeat.',
      'date-night': 'Your edit will lean confident, magnetic, and ready after dark.',
      'escape': 'Your edit will lean light, packable, and destination ready.',
      'event': 'Your edit will lean polished, memorable, and made for an entrance.',
      'after-hours': 'Your edit turns darker, sharper, and magnetic—made for wherever the night leads.'
    };
    let occasion = localStorage.getItem('weston-occasion') || 'everyday';
    const occasions = Object.keys(occasionCopy);
    const paintOccasion = () => {
      root.querySelectorAll('[data-occasion]').forEach((button) => button.classList.toggle('is-active', button.dataset.occasion === occasion));
      root.querySelector('[data-weston-occasion-copy]').textContent = occasionCopy[occasion];
      document.documentElement.dataset.westonOccasion = occasion;
    };
    const chooseOccasion = (next, announce = true) => {
      if (!occasions.includes(next)) return;
      occasion = next;
      localStorage.setItem('weston-occasion', occasion);
      paintOccasion();
      if (announce) window.dispatchEvent(new CustomEvent('weston:occasion-change', { detail: { occasion } }));
    };
    root.querySelectorAll('[data-occasion]').forEach((button) => button.addEventListener('click', () => chooseOccasion(button.dataset.occasion)));
    window.addEventListener('weston:occasion-change', (event) => chooseOccasion(event.detail?.occasion, false));

    const render = () => {
      const trail = read('weston-trail-v1', []);
      const saved = read('weston-saved-stories-v1', []);
      const recent = read('weston-recent-products', []);
      const counts = { piece: 0, story: 0, edit: 0 };
      trail.forEach((item) => { if (item.kind in counts) counts[item.kind] += 1; });
      const total = Math.max(1, counts.piece + counts.story + counts.edit);
      Object.entries(counts).forEach(([kind, value]) => { root.querySelector(`[data-dna-bar="${kind}"]`).style.width = `${Math.max(value ? 18 : 0, (value / total) * 100)}%`; });
      const world = localStorage.getItem('weston-world') || 'main-character';
      const lens = localStorage.getItem('weston-lens') || 'all';
      const worldNames = { 'main-character': 'Main Character', 'off-duty': 'Off-Duty Cool', 'escape': 'Escape Mode', 'after-dark': 'After Dark' };
      const lensNames = { women: 'Women', men: 'Men', all: 'Everything', gift: 'For Someone' };
      root.querySelector('[data-mode-lens]').textContent = lensNames[lens] || lensNames.all;
      root.querySelector('[data-mode-world]').textContent = worldNames[world] || worldNames['main-character'];
      root.querySelector('[data-mode-story-count]').textContent = `${saved.length} saved`;
      const dnaNames = { 'main-character': 'Confident Curator', 'off-duty': 'Effortless Editor', 'escape': 'Escape Artist', 'after-dark': 'After-Dark Icon' };
      root.querySelector('[data-weston-dna-title]').textContent = trail.length > 2 ? dnaNames[world] : root.dataset.dnaStart;
      const chemistryScore = Math.min(96, 38 + (Number(root.dataset.cartCount) * 16) + (occasion === 'after-hours' ? 8 : 0));
      const chemistryScoreRoot = root.querySelector('[data-weston-chemistry-score]');
      const chemistryBar = root.querySelector('[data-weston-chemistry-bar]');
      if (chemistryScoreRoot && chemistryBar) { chemistryScoreRoot.textContent = String(chemistryScore); chemistryBar.style.width = `${chemistryScore}%`; }

      const dropRoot = root.querySelector('[data-weston-daily-drop]');
      dropRoot.textContent = '';
      if (!recent.length) { const empty = document.createElement('p'); empty.className = 'weston-mode__drop-empty'; empty.textContent = root.dataset.emptyDrop; dropRoot.appendChild(empty); }
      else {
        const day = Math.floor(Date.now() / 86400000); const item = recent[day % recent.length];
        const card = document.createElement('a'); card.className = 'weston-mode__daily-card'; card.href = item.url;
        if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = item.title; image.loading = 'lazy'; card.appendChild(image); }
        const text = document.createElement('span'); const title = document.createElement('strong'); const price = document.createElement('small'); title.textContent = item.title; price.textContent = item.price; text.append(title, price); card.appendChild(text); dropRoot.appendChild(card);
      }
      paintOccasion();
    };
    const renderStoryShop = (items) => {
      const container = root.querySelector('[data-weston-story-shop]');
      if (!container) return;
      container.textContent = '';
      items.slice(0, 4).forEach((item) => {
        const card = document.createElement('a'); card.href = item.url;
        if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = item.title; image.loading = 'lazy'; card.appendChild(image); }
        const title = document.createElement('strong'); title.textContent = item.title;
        const price = document.createElement('small'); price.textContent = item.price;
        card.append(title, price); container.appendChild(card);
      });
    };
    const loadRecommendations = async () => {
      const container = root.querySelector('[data-weston-related-products]');
      if (!container || !root.dataset.productId) return;
      try {
        const url = `${window.Shopify?.routes?.root || '/'}recommendations/products?section_id=${encodeURIComponent(root.dataset.sectionId)}&product_id=${encodeURIComponent(root.dataset.productId)}&limit=4&intent=related`;
        const response = await fetch(url);
        if (!response.ok) return;
        const html = document.createElement('div'); html.innerHTML = await response.text();
        const returned = html.querySelector('[data-weston-related-products]');
        if (returned && returned.children.length) {
          container.replaceChildren(...Array.from(returned.children));
          filterRecommendationLens(container);
        }
      } catch (error) { return; }
    };
    const filterRecommendationLens = (container) => {
      const lens = localStorage.getItem('weston-lens') || 'all';
      container.querySelectorAll('[data-lens-tags]').forEach((card) => {
        const tags = card.dataset.lensTags.toLowerCase().split('|');
        const conflicts = (lens === 'women' && tags.includes('lens:men')) || (lens === 'men' && tags.includes('lens:women'));
        card.hidden = conflicts;
        card.querySelector('[data-weston-bundle-item]')?.toggleAttribute('disabled', conflicts);
      });
    };
    const addLook = root.querySelector('[data-weston-add-look]');
    if (addLook) addLook.addEventListener('click', async () => {
      const items = Array.from(root.querySelectorAll('[data-weston-bundle-item]:checked')).map((input) => ({ id: Number(input.value), quantity: 1 }));
      const currentVariant = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (currentVariant?.value && !items.some((item) => String(item.id) === String(currentVariant.value))) items.unshift({ id: Number(currentVariant.value), quantity: 1 });
      const status = root.querySelector('[data-weston-bundle-status]');
      if (!items.length) { status.textContent = root.dataset.bundleError; return; }
      addLook.disabled = true; addLook.textContent = root.dataset.bundleAdding;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Bundle unavailable');
        status.textContent = root.dataset.bundleAdded; addLook.textContent = root.dataset.bundleAdded;
        window.setTimeout(() => { window.location.href = `${window.Shopify?.routes?.root || '/'}cart`; }, 700);
      } catch (error) { status.textContent = root.dataset.bundleError; addLook.textContent = root.dataset.bundleCta; addLook.disabled = false; }
    });
    render();
    renderStoryShop(read('weston-recent-products', []));
    const initialRecommendations = root.querySelector('[data-weston-related-products]');
    if (initialRecommendations) filterRecommendationLens(initialRecommendations);
    loadRecommendations();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-not-found-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const WORLD_LABELS = {
      weston_woman: 'The Weston Woman',
      denim_atelier: 'The Denim Atelier',
      off_duty: 'Off-Duty Weston',
      weston_man: 'The Weston Man',
      little_weston: 'Little Weston',
      gift_jewelry: 'The Finishing Move',
      holiday_preview: 'Holiday Preview',
      new_now: 'New, Now'
    };
    const clean = (value, max = 180) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, max);
    const safePath = (value) => {
      try {
        const url = new URL(value || '', location.origin);
        return url.origin === location.origin ? `${url.pathname}${url.search}${url.hash}` : '';
      } catch (_) { return ''; }
    };
    const parse = (key) => {
      try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; }
    };
    const makeCard = ({ label, title, note, url, action }) => {
      const card = url ? document.createElement('a') : document.createElement('button');
      if (url) card.href = url;
      else card.type = 'button';
      card.className = 'wgnf-resume-card';
      const kicker = document.createElement('span');
      kicker.textContent = label;
      const strong = document.createElement('strong');
      strong.textContent = title;
      const small = document.createElement('small');
      small.textContent = note;
      const em = document.createElement('em');
      em.textContent = 'Continue →';
      card.append(kicker, strong, small, em);
      if (action) card.addEventListener('click', action);
      return card;
    };
    const openConstellation = (trigger) => document.dispatchEvent(new CustomEvent('weston:surface-request', { detail: { surface: 'constellation', returnFocusTarget: trigger } }));
    const initialize = (scope = document) => {
      scope.querySelectorAll?.('[data-wgnf-root]').forEach((root) => {
        if (root.dataset.wgnfReady === 'true') return;
        root.dataset.wgnfReady = 'true';
        root.querySelector('[data-wgnf-open-command]')?.addEventListener('click', () => {
          if (window.__westonExperienceCommandCenter2026?.open) window.__westonExperienceCommandCenter2026.open();
          else document.querySelector('[data-wxc-open]')?.click();
        });
        root.querySelector('[data-wgnf-open-constellation]')?.addEventListener('click', (event) => openConstellation(event.currentTarget));

        const profile = parse(root.dataset.profileKey);
        const gift = parse(root.dataset.giftKey);
        const hub = parse(root.dataset.hubKey);
        const cards = [];
        if (profile && typeof profile === 'object') {
          cards.push(makeCard({
            label: 'Your personal edit',
            title: WORLD_LABELS[clean(profile.worldKey, 100)] || 'Your Weston',
            note: [clean(profile.audience, 30), clean(profile.mood, 30), clean(profile.moment, 30)].filter(Boolean).join(' · ') || 'Your choices are saved privately.',
            action: (event) => openConstellation(event.currentTarget)
          }));
        }
        if (gift && typeof gift === 'object' && Number(gift.expiresAt || 0) > Date.now()) {
          const recommendation = gift.recommendation || {};
          const productUrl = safePath(recommendation.productUrl);
          const giftUrl = gift.stage === 'cart' ? safePath(root.dataset.cartUrl) : gift.stage === 'blessing' ? `${safePath(root.dataset.sanctuaryUrl)}#sanctuary-gift-blessing` : productUrl;
          if (giftUrl) cards.push(makeCard({
            label: gift.blessing ? 'Gift blessing ready' : 'Gift journey',
            title: clean(recommendation.productTitle, 180) || 'Your selected gift',
            note: 'The missing page did not erase the gift journey stored in this browser.',
            url: giftUrl
          }));
        }
        const saved = Array.isArray(hub?.saved) ? hub.saved : [];
        const recent = Array.isArray(hub?.recent) ? hub.recent : [];
        const item = saved[0] || recent[0];
        if (item && safePath(item.url)) cards.push(makeCard({
          label: saved[0] ? 'Private tray' : 'Recently viewed',
          title: clean(item.title, 180),
          note: saved[0] ? `${saved.length} item${saved.length === 1 ? '' : 's'} saved on this browser.` : 'Return to the last product viewed in this browser.',
          url: safePath(item.url)
        }));

        const resume = root.querySelector('[data-wgnf-resume]');
        const grid = root.querySelector('[data-wgnf-resume-grid]');
        if (resume && grid && cards.length) {
          grid.replaceChildren(...cards.slice(0, 3));
          resume.hidden = false;
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-responsive-fixes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-weston-responsive-fixes]');

    const connectToolbar = () => {
      const toolbarTrigger = document.querySelector('[data-weston-toolbar-trigger]');
      const modeTrigger = document.querySelector('[data-weston-mode-trigger]');
      if (!toolbarTrigger || !modeTrigger || toolbarTrigger.dataset.connected === 'true') return;
      toolbarTrigger.dataset.connected = 'true';
      const controls = modeTrigger.getAttribute('aria-controls');
      if (controls) toolbarTrigger.setAttribute('aria-controls', controls);
      const sync = () => toolbarTrigger.setAttribute('aria-expanded', modeTrigger.getAttribute('aria-expanded') || 'false');
      new MutationObserver(sync).observe(modeTrigger, { attributes: true, attributeFilter: ['aria-expanded'] });
      sync();
    };

    const connectSexyCarousels = () => {
      if (!root) return;
      document.querySelectorAll('.weston-sexy-edit__products').forEach((slider) => {
        if (slider.dataset.carouselReady === 'true') return;
        slider.dataset.carouselReady = 'true';
        const collection = slider.closest('.weston-sexy-edit__collection');
        const heading = collection?.querySelector('h3')?.textContent?.trim();
        slider.setAttribute('role', 'region');
        if (heading) slider.setAttribute('aria-label', heading);

        const nav = document.createElement('div');
        nav.className = 'weston-sexy-edit__mobile-nav';
        const previous = document.createElement('button');
        const next = document.createElement('button');
        previous.type = 'button';
        next.type = 'button';
        previous.setAttribute('aria-label', root.dataset.carouselPrevious);
        next.setAttribute('aria-label', root.dataset.carouselNext);
        previous.textContent = '←';
        next.textContent = '→';
        nav.append(previous, next);
        collection?.insertBefore(nav, slider);

        const move = (direction) => {
          slider.scrollBy({ left: direction * Math.max(240, slider.clientWidth * 0.78), behavior: 'smooth' });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));

        const update = () => {
          previous.disabled = slider.scrollLeft <= 4;
          next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
        };
        slider.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();

        let dragging = false;
        let startX = 0;
        let startScroll = 0;
        slider.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') return;
          dragging = true;
          startX = event.clientX;
          startScroll = slider.scrollLeft;
          slider.classList.add('is-dragging');
          slider.setPointerCapture(event.pointerId);
        });
        slider.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          slider.scrollLeft = startScroll - (event.clientX - startX);
        });
        const stopDragging = (event) => {
          if (!dragging) return;
          dragging = false;
          slider.classList.remove('is-dragging');
          if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
        };
        slider.addEventListener('pointerup', stopDragging);
        slider.addEventListener('pointercancel', stopDragging);
      });
    };

    document.addEventListener('click', (event) => {
      const toolbarTrigger = event.target.closest('[data-weston-toolbar-trigger]');
      if (!toolbarTrigger) return;
      event.preventDefault();
      document.querySelector('[data-weston-mode-trigger]')?.click();
    });

    connectToolbar();
    connectSexyCarousels();
    window.setTimeout(connectToolbar, 500);
    window.setTimeout(connectSexyCarousels, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-return-sanctuary-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const readStorage = (key, fallback) => {
      try {
        const value = window.localStorage.getItem(key);
        return value ? JSON.parse(value) : fallback;
      } catch (error) {
        return fallback;
      }
    };

    const readTextStorage = (key) => {
      try {
        return window.localStorage.getItem(key) || '';
      } catch (error) {
        return '';
      }
    };

    const scrollTo = (target) => target?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });

    const initReturn = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const readingTitle = root.querySelector('[data-return-reading]');
      const readingNote = root.querySelector('[data-return-reading-note]');
      const readingButton = root.querySelector('[data-return-reading-button]');
      const readingButtonText = root.querySelector('[data-return-reading-button-text]');
      const pathTitle = root.querySelector('[data-return-path]');
      const pathNote = root.querySelector('[data-return-path-note]');
      const pathButton = root.querySelector('[data-return-path-button]');
      const pathButtonText = root.querySelector('[data-return-path-button-text]');
      const pathMeter = root.querySelector('[data-return-path-meter]');
      const pathFill = root.querySelector('[data-return-path-fill]');
      const reflectionCount = root.querySelector('[data-return-reflections]');
      const reflectionCountLabel = root.querySelector('[data-return-reflection-count-label]');
      const reflectionNote = root.querySelector('[data-return-reflection-note]');
      let readingPosition = null;
      let activePath = null;

      const bookName = (number) => {
        const node = document.querySelector('[data-bible-books]');
        if (!node) return '';
        try {
          const books = JSON.parse(node.textContent || '[]');
          return books.find((book) => Number(book.number) === Number(number))?.name || '';
        } catch (error) {
          return '';
        }
      };

      const render = () => {
        readingPosition = readStorage('weston-sanctuary-bible-position', null);
        const bookmarks = readStorage('weston-sanctuary-bible-bookmarks', []);
        const name = readingPosition ? bookName(readingPosition.book) : '';
        if (readingPosition && name) {
          readingTitle.textContent = `${name} ${readingPosition.chapter}`;
          const count = Array.isArray(bookmarks) ? bookmarks.length : 0;
          readingNote.textContent = `${count} ${count === 1 ? root.dataset.savedOneLabel : root.dataset.savedManyLabel}`;
          readingButtonText.textContent = readingButton.dataset.continueLabel || '';
        } else {
          readingTitle.textContent = readingTitle.dataset.emptyLabel || readingTitle.textContent;
          readingNote.textContent = readingNote.dataset.emptyLabel || readingNote.textContent;
          readingButtonText.textContent = readingButton.dataset.startLabel || '';
        }

        const paths = [...document.querySelectorAll('[data-faith-path]')];
        const pathStates = paths.map((path) => {
          const days = [...path.querySelectorAll('[data-path-day]')];
          const completed = readStorage(`weston-sanctuary-path-${path.dataset.pathId}`, []);
          const count = Array.isArray(completed) ? completed.filter(Number.isInteger).length : 0;
          const title = path.querySelector('h3, h2, strong')?.textContent?.trim() || '';
          return { path, days, count, title };
        });
        activePath = pathStates.filter((item) => item.count > 0 && item.count < item.days.length).sort((a, b) => b.count - a.count)[0]
          || pathStates.filter((item) => item.count > 0).sort((a, b) => b.count - a.count)[0]
          || null;
        if (activePath) {
          pathTitle.textContent = activePath.title;
          pathNote.textContent = `${activePath.count} / ${activePath.days.length} ${root.dataset.daysLabel || ''}`;
          pathMeter.setAttribute('aria-valuemax', String(activePath.days.length));
          pathMeter.setAttribute('aria-valuenow', String(activePath.count));
          pathFill.style.transform = `scaleX(${activePath.days.length ? activePath.count / activePath.days.length : 0})`;
          pathButtonText.textContent = pathButton.dataset.continueLabel || '';
        } else {
          pathTitle.textContent = pathTitle.dataset.emptyLabel || '';
          pathNote.textContent = pathNote.dataset.emptyLabel || '';
          pathFill.style.transform = 'scaleX(0)';
          pathMeter.setAttribute('aria-valuenow', '0');
          pathButtonText.textContent = pathButton.dataset.startLabel || '';
        }

        let reflections = 0;
        try {
          for (let index = 0; index < window.localStorage.length; index += 1) {
            const key = window.localStorage.key(index) || '';
            if (key.startsWith('weston-sanctuary-reflection-') && readTextStorage(key).trim()) reflections += 1;
          }
        } catch (error) {
          reflections = 0;
        }
        reflectionCount.textContent = String(reflections);
        reflectionCountLabel.textContent = reflections === 1 ? reflectionCountLabel.dataset.oneLabel : reflectionCountLabel.dataset.manyLabel;
        reflectionNote.textContent = reflections > 0
          ? `${reflections} ${reflections === 1 ? root.dataset.reflectionOneLabel : root.dataset.reflectionManyLabel}`
          : reflectionNote.dataset.emptyLabel;
      };

      readingTitle.dataset.emptyLabel = readingTitle.textContent;
      readingNote.dataset.emptyLabel = readingNote.textContent;
      pathTitle.dataset.emptyLabel = pathTitle.textContent;
      pathNote.dataset.emptyLabel = pathNote.textContent;
      reflectionNote.dataset.emptyLabel = reflectionNote.textContent;

      readingButton?.addEventListener('click', () => {
        const reader = document.querySelector('[data-living-bible]');
        scrollTo(reader);
        if (readingPosition) {
          document.dispatchEvent(new CustomEvent('weston:bible:open', { detail: { book: Number(readingPosition.book), chapter: Number(readingPosition.chapter) } }));
        }
      });

      pathButton?.addEventListener('click', () => {
        if (activePath?.path) activePath.path.open = true;
        scrollTo(activePath?.path || document.querySelector('[data-faith-paths]'));
      });
      root.querySelector('[data-return-reflection-button]')?.addEventListener('click', () => scrollTo(document.querySelector('[data-sanctuary-journey]')));
      root.querySelector('[data-return-refresh]')?.addEventListener('click', render);

      const interactionHandler = (event) => {
        if (event.target.closest('[data-save-chapter], [data-path-complete], [data-save-note], [data-clear-note]')) window.setTimeout(render, 80);
      };
      document.addEventListener('click', interactionHandler);
      window.addEventListener('storage', render);
      window.addEventListener('focus', render);
      window.requestAnimationFrame(render);
      root._returnCleanup = () => {
        document.removeEventListener('click', interactionHandler);
        window.removeEventListener('storage', render);
        window.removeEventListener('focus', render);
      };
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-return]')) initReturn(scope);
      scope.querySelectorAll('[data-weston-return]').forEach(initReturn);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('[data-weston-return]')?._returnCleanup?.());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-sanctuary-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSanctuary = (root) => {
      if (!root || root.dataset.sanctuaryReady === 'true') return;
      root.dataset.sanctuaryReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-sanctuary-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-sanctuary-panel]'));
      const journey = root.querySelector('[data-sanctuary-journey]');
      const portalLabel = root.querySelector('[data-sanctuary-portal-label]');
      const stage = root.querySelector('[data-sanctuary-stage]');
      const enterButton = root.querySelector('[data-sanctuary-enter]');
      const dailyButton = root.querySelector('[data-sanctuary-daily]');
      const timers = [];

      const setActiveRoom = (tab, shouldFocus = false) => {
        if (!tab) return;
        tabs.forEach((candidate) => {
          const selected = candidate === tab;
          candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
          candidate.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
        root.style.setProperty('--active-accent', tab.dataset.roomAccent || '#d2b47b');
        if (portalLabel) portalLabel.textContent = tab.dataset.roomName || '';
        if (shouldFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => setActiveRoom(tab));
        tab.addEventListener('keydown', (event) => {
          const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          setActiveRoom(tabs[nextIndex], true);
        });
      });

      const showJourney = () => {
        if (!journey) return;
        journey.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      };

      enterButton?.addEventListener('click', showJourney);
      dailyButton?.addEventListener('click', () => {
        if (!tabs.length) return;
        const today = new Date();
        const dayNumber = Math.floor(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) / 86400000);
        const dailyTab = tabs[dayNumber % tabs.length];
        setActiveRoom(dailyTab);
        showJourney();
      });

      if (stage && window.matchMedia('(pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        stage.addEventListener('pointermove', (event) => {
          const bounds = stage.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width - 0.5;
          const y = (event.clientY - bounds.top) / bounds.height - 0.5;
          stage.style.setProperty('--portal-ry', `${x * 6}deg`);
          stage.style.setProperty('--portal-rx', `${y * -5}deg`);
        });
        stage.addEventListener('pointerleave', () => {
          stage.style.setProperty('--portal-ry', '0deg');
          stage.style.setProperty('--portal-rx', '0deg');
        });
      }

      panels.forEach((panel) => {
        const note = panel.querySelector('[data-sanctuary-note]');
        const save = panel.querySelector('[data-save-note]');
        const clear = panel.querySelector('[data-clear-note]');
        const journalStatus = panel.querySelector('[data-journal-status]');
        const storageKey = panel.dataset.storageKey;
        let clearTimeoutId;

        const setJournalStatus = (message) => {
          if (journalStatus) journalStatus.textContent = message;
        };

        if (note && storageKey) {
          try {
            note.value = window.localStorage.getItem(storageKey) || '';
          } catch (error) {
            setJournalStatus(journalStatus?.dataset.unavailableLabel || '');
          }
        }

        save?.addEventListener('click', () => {
          try {
            window.localStorage.setItem(storageKey, note?.value || '');
            setJournalStatus(journalStatus?.dataset.savedLabel || '');
          } catch (error) {
            setJournalStatus(journalStatus?.dataset.unavailableLabel || '');
          }
        });

        clear?.addEventListener('click', () => {
          if (clear.dataset.armed !== 'true') {
            clear.dataset.armed = 'true';
            clear.textContent = clear.dataset.confirmLabel || clear.textContent;
            setJournalStatus(journalStatus?.dataset.clearWarning || '');
            window.clearTimeout(clearTimeoutId);
            clearTimeoutId = window.setTimeout(() => {
              clear.dataset.armed = 'false';
              clear.textContent = clear.dataset.label || '';
              setJournalStatus('');
            }, 5000);
            return;
          }
          try {
            window.localStorage.removeItem(storageKey);
            if (note) note.value = '';
            setJournalStatus(journalStatus?.dataset.clearedLabel || '');
          } catch (error) {
            setJournalStatus(journalStatus?.dataset.unavailableLabel || '');
          }
          clear.dataset.armed = 'false';
          clear.textContent = clear.dataset.label || '';
          window.clearTimeout(clearTimeoutId);
        });

        const stillness = panel.querySelector('[data-stillness]');
        if (stillness) {
          const clock = stillness.querySelector('[data-stillness-clock]');
          const label = stillness.querySelector('[data-stillness-label]');
          const ring = stillness.querySelector('[data-stillness-ring]');
          const status = panel.querySelector('[data-stillness-status]');
          let remaining = 60;
          let intervalId = null;

          const renderTimer = () => {
            if (clock) clock.textContent = `00:${String(remaining).padStart(2, '0')}`;
            if (remaining === 60 && clock) clock.textContent = '01:00';
            if (ring) ring.style.setProperty('--stillness-progress', `${((60 - remaining) / 60) * 360}deg`);
          };

          const stopTimer = () => {
            window.clearInterval(intervalId);
            intervalId = null;
          };

          stillness.addEventListener('click', () => {
            if (intervalId) {
              stopTimer();
              if (label) label.textContent = stillness.dataset.resumeLabel || '';
              return;
            }
            if (remaining <= 0) remaining = 60;
            if (status) status.textContent = '';
            if (label) label.textContent = stillness.dataset.pauseLabel || '';
            renderTimer();
            intervalId = window.setInterval(() => {
              remaining -= 1;
              renderTimer();
              if (remaining <= 0) {
                stopTimer();
                if (label) label.textContent = stillness.dataset.startLabel || '';
                if (status) status.textContent = stillness.dataset.completeLabel || '';
              }
            }, 1000);
          });
          renderTimer();
          timers.push(stopTimer);
        }

        const copyButton = panel.querySelector('[data-copy-verse]');
        copyButton?.addEventListener('click', async () => {
          const copyText = copyButton.querySelector('[data-copy-text]');
          const text = `“${copyButton.dataset.verse || ''}” — ${copyButton.dataset.reference || ''}`;
          try {
            await navigator.clipboard.writeText(text);
            if (copyText) copyText.textContent = copyButton.dataset.copiedLabel || '';
            window.setTimeout(() => {
              if (copyText) copyText.textContent = copyButton.dataset.copyLabel || '';
            }, 2200);
          } catch (error) {
            if (copyText) copyText.textContent = copyButton.dataset.copyLabel || '';
          }
        });
      });

      root._sanctuaryCleanup = () => timers.forEach((stop) => stop());
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-sanctuary]')) initSanctuary(scope);
      scope.querySelectorAll('[data-weston-sanctuary]').forEach(initSanctuary);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelector('[data-weston-sanctuary]')?._sanctuaryCleanup?.();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-sanctuary-compass-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCompass = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const buttons = [...root.querySelectorAll('button[data-compass-target]')];
      const brand = root.querySelector('.wscp__brand[data-compass-target]');
      const progress = root.querySelector('[data-compass-progress]');
      const links = root.querySelector('[data-compass-links]');

      const resolveTarget = (control) => document.querySelector(control.dataset.compassTarget || '');
      const controls = [brand, ...buttons].filter(Boolean);

      controls.forEach((control) => {
        control.addEventListener('click', (event) => {
          const target = resolveTarget(control);
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      });

      const sections = buttons.map((button) => ({ button, target: resolveTarget(button) })).filter((item) => item.target);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (!visible) return;
          const active = sections.find((item) => item.target === visible.target);
          if (!active) return;
          buttons.forEach((button) => button.removeAttribute('aria-current'));
          active.button.setAttribute('aria-current', 'location');
          active.button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }, { rootMargin: '-18% 0px -58% 0px', threshold: [0, 0.08, 0.25] });
        sections.forEach((item) => observer.observe(item.target));
        root._compassObserver = observer;
      }

      const updateProgress = () => {
        const page = document.documentElement;
        const distance = Math.max(1, page.scrollHeight - window.innerHeight);
        const fraction = Math.min(1, Math.max(0, window.scrollY / distance));
        if (progress) progress.style.transform = `scaleX(${fraction})`;
      };

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateProgress();
          ticking = false;
        });
      };
      updateProgress();
      window.addEventListener('scroll', onScroll, { passive: true });
      root._compassCleanup = () => {
        root._compassObserver?.disconnect();
        window.removeEventListener('scroll', onScroll);
      };
      if (links) links.scrollLeft = 0;
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-compass]')) initCompass(scope);
      scope.querySelectorAll('[data-weston-compass]').forEach(initCompass);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('[data-weston-compass]')?._compassCleanup?.());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-sanctuary-house-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTORS = {
      reflect: '[data-weston-sanctuary]',
      read: '[data-living-bible]',
      journey: '[data-faith-paths]',
      create: '[data-weston-verse-card]',
      give: '[data-weston-gift-blessing]',
      shop: '[data-faith-shop]'
    };
    const COMMERCE_SELECTORS = ['[data-weston-carry]', '[data-weston-gift-finder]', '[data-weston-gift-blessing]', '[data-faith-shop]'];
    const SABBATH_KEY = 'weston-sanctuary-sabbath-mode';
    const DISCERNMENT_KEY = 'weston-sanctuary-discernment-mode';
    const SHELF_KEY = 'weston-sanctuary-quiet-shelf';

    const safeRead = (key, fallback) => {
      try {
        const value = localStorage.getItem(key);
        return value === null ? fallback : JSON.parse(value);
      } catch (error) { return fallback; }
    };
    const safeWrite = (key, value) => {
      try { localStorage.setItem(key, JSON.stringify(value)); return true; }
      catch (error) { return false; }
    };
    const getText = (node) => (node?.textContent || '').replace(/\s+/g, ' ').trim();

    const initHouse = (root) => {
      if (!root || root.dataset.houseReady === 'true') return;
      root.dataset.houseReady = 'true';
      const sectionWrapper = root.closest('.shopify-section') || root;
      const sabbathToggle = root.querySelector('[data-sabbath-toggle]');
      const sabbathState = root.querySelector('[data-sabbath-state]');
      const discernmentToggle = root.querySelector('[data-discernment-toggle]');
      const discernmentState = root.querySelector('[data-discernment-state]');
      const returnButton = root.querySelector('[data-return-house]');
      const dialog = root.querySelector('[data-discernment-dialog]');
      const dialogProduct = root.querySelector('[data-dialog-product]');
      const shelfList = root.querySelector('[data-shelf-list]');
      const toast = root.querySelector('[data-house-toast]');
      const onLabel = discernmentState?.textContent || 'On';
      const offLabel = sabbathState?.textContent || 'Off';
      let sabbath = safeRead(SABBATH_KEY, false) === true;
      let discernment = safeRead(DISCERNMENT_KEY, true) !== false;
      let pendingProduct = null;
      let toastTimer = null;

      const announce = (message) => {
        if (!toast || !message) return;
        toast.textContent = message;
        toast.hidden = false;
        window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(() => { toast.hidden = true; }, 3200);
      };

      const readProgress = () => {
        let hasReflection = false;
        try {
          for (let index = 0; index < localStorage.length; index += 1) {
            const key = localStorage.key(index) || '';
            if (key.startsWith('weston-sanctuary-reflection-') && (localStorage.getItem(key) || '').trim()) hasReflection = true;
          }
        } catch (error) { hasReflection = false; }
        const position = safeRead('weston-sanctuary-bible-position', null);
        const hasPathProgress = ['peace', 'courage', 'purpose'].some((path) => {
          const completed = safeRead(`weston-sanctuary-path-${path}`, []);
          return Array.isArray(completed) && completed.length > 0;
        });
        const reflectionStatus = root.querySelector('[data-door-status="reflect"]');
        const readStatus = root.querySelector('[data-door-status="read"]');
        const journeyStatus = root.querySelector('[data-door-status="journey"]');
        if (reflectionStatus && hasReflection) reflectionStatus.textContent = 'A private reflection is waiting here';
        if (readStatus && position) readStatus.textContent = `Continue book ${position.book}, chapter ${position.chapter}`;
        if (journeyStatus && hasPathProgress) journeyStatus.textContent = 'Return whenever you are ready';
      };

      const getShelf = () => {
        const stored = safeRead(SHELF_KEY, []);
        return Array.isArray(stored) ? stored.filter((item) => item && item.url && item.title).slice(0, 12) : [];
      };

      const renderShelf = () => {
        if (!shelfList) return;
        const shelf = getShelf();
        shelfList.replaceChildren();
        if (!shelf.length) {
          const empty = document.createElement('div');
          empty.className = 'wsh__shelf-empty';
          empty.innerHTML = '<span aria-hidden="true">○</span><p>Your quiet shelf is empty.</p><small>When something feels meaningful, remember it here and decide another day.</small>';
          shelfList.append(empty);
          readProgress();
          return;
        }
        shelf.forEach((item) => {
          const row = document.createElement('div');
          row.className = 'wsh__shelf-item';
          const link = document.createElement('a');
          link.href = item.url;
          link.dataset.shelfDirect = 'true';
          link.textContent = item.title;
          const note = document.createElement('small');
          note.textContent = 'Remembered without adding to cart';
          link.append(note);
          const visit = document.createElement('a');
          visit.href = item.url;
          visit.dataset.shelfDirect = 'true';
          visit.textContent = 'View ↗';
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = 'Release';
          remove.addEventListener('click', () => {
            safeWrite(SHELF_KEY, getShelf().filter((saved) => saved.url !== item.url));
            renderShelf();
          });
          row.append(link, visit, remove);
          shelfList.append(row);
        });
        readProgress();
      };

      const applySabbath = () => {
        root.dataset.sabbath = String(sabbath);
        sabbathToggle?.setAttribute('aria-checked', String(sabbath));
        if (sabbathState) sabbathState.textContent = sabbath ? onLabel : offLabel;
        root.querySelectorAll('[data-commerce-door]').forEach((door) => { door.disabled = sabbath; });
        COMMERCE_SELECTORS.forEach((selector) => {
          document.querySelectorAll(selector).forEach((feature) => {
            const wrapper = feature.closest('.shopify-section') || feature;
            if (sabbath) {
              if (!wrapper.hidden) wrapper.dataset.sabbathHidden = 'true';
              wrapper.hidden = true;
            } else if (wrapper.dataset.sabbathHidden === 'true') {
              wrapper.hidden = false;
              delete wrapper.dataset.sabbathHidden;
            }
          });
        });
      };

      const applyDiscernment = () => {
        discernmentToggle?.setAttribute('aria-checked', String(discernment));
        if (discernmentState) discernmentState.textContent = discernment ? onLabel : offLabel;
      };

      const restoreHouse = (shouldScroll = true) => {
        document.querySelectorAll('[data-house-hidden="true"]').forEach((node) => {
          node.hidden = node.dataset.houseWasHidden === 'true';
          delete node.dataset.houseHidden;
          delete node.dataset.houseWasHidden;
        });
        applySabbath();
        if (returnButton) returnButton.hidden = true;
        readProgress();
        if (shouldScroll) root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      };

      const openRoom = (room, shouldScroll = true) => {
        const target = document.querySelector(SELECTORS[room]);
        if (!target || (sabbath && ['give', 'shop'].includes(room))) return;
        restoreHouse(false);
        const targetWrapper = target.closest('.shopify-section') || target;
        document.querySelectorAll('main .shopify-section').forEach((node) => {
          if (node === sectionWrapper || node === targetWrapper) return;
          node.dataset.houseHidden = 'true';
          node.dataset.houseWasHidden = String(node.hidden);
          node.hidden = true;
        });
        targetWrapper.hidden = false;
        if (returnButton) returnButton.hidden = false;
        if (shouldScroll) target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      };

      root.querySelectorAll('[data-house-room]').forEach((door) => door.addEventListener('click', () => openRoom(door.dataset.houseRoom)));
      root.querySelector('[data-show-whole-house]')?.addEventListener('click', () => {
        restoreHouse(false);
        document.querySelector(SELECTORS.reflect)?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });

      sabbathToggle?.addEventListener('click', () => {
        sabbath = !sabbath;
        safeWrite(SABBATH_KEY, sabbath);
        restoreHouse(false);
        applySabbath();
        announce(sabbath ? 'Sabbath mode is on. Shopping spaces are resting.' : 'Sabbath mode is off. Shopping spaces are available again.');
      });
      discernmentToggle?.addEventListener('click', () => {
        discernment = !discernment;
        safeWrite(DISCERNMENT_KEY, discernment);
        applyDiscernment();
        announce(discernment ? 'Discernment pause is on.' : 'Discernment pause is off.');
      });

      const threadTabs = [...root.querySelectorAll('[data-thread-tab]')];
      const activateThread = (tab, shouldFocus = false) => {
        threadTabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        root.querySelectorAll('[data-thread-panel]').forEach((panel) => { panel.hidden = panel.dataset.threadPanel !== tab.dataset.threadTab; });
        if (shouldFocus) tab.focus();
      };

      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-return-house]')) {
          event.preventDefault();
          restoreHouse();
          return;
        }
        const tab = event.target.closest('[data-thread-tab]');
        if (tab && root.contains(tab)) {
          event.preventDefault();
          activateThread(tab);
        }
      });

      threadTabs.forEach((tab, index, tabs) => {
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activateThread(tabs[next], true);
        });
      });

      root.querySelectorAll('[data-thread-node]').forEach((node) => node.addEventListener('click', () => {
        openRoom('read', false);
        const reader = document.querySelector('[data-living-bible]');
        const bookSelect = reader?.querySelector('[data-bible-book]');
        const chapterSelect = reader?.querySelector('[data-bible-chapter]');
        if (bookSelect) {
          bookSelect.value = node.dataset.book || '';
          bookSelect.dispatchEvent(new Event('change', { bubbles: true }));
          window.setTimeout(() => {
            if (chapterSelect) {
              chapterSelect.value = node.dataset.chapter || '1';
              chapterSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
            reader?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          }, 120);
        }
      }));

      const closeDialog = () => {
        if (dialog?.open) dialog.close();
        pendingProduct = null;
      };
      root.querySelector('[data-dialog-close]')?.addEventListener('click', closeDialog);
      root.querySelector('[data-dialog-stay]')?.addEventListener('click', closeDialog);
      dialog?.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
        if (outside) closeDialog();
      });
      root.querySelector('[data-product-continue]')?.addEventListener('click', () => {
        const url = pendingProduct?.url;
        closeDialog();
        if (url) window.location.href = url;
      });
      root.querySelector('[data-shelf-save]')?.addEventListener('click', () => {
        if (!pendingProduct) return;
        const shelf = getShelf();
        if (!shelf.some((item) => item.url === pendingProduct.url)) shelf.unshift({ ...pendingProduct, savedAt: new Date().toISOString() });
        if (!safeWrite(SHELF_KEY, shelf.slice(0, 12))) announce(root.dataset.storageUnavailable || 'Private saving is unavailable.');
        else announce('Remembered on your quiet shelf. No item was added to cart.');
        closeDialog();
        renderShelf();
      });

      document.addEventListener('click', (event) => {
        if (!discernment || sabbath) return;
        const link = event.target.closest?.('a[href*="/products/"]');
        if (!link || link.dataset.shelfDirect === 'true' || !document.body.contains(link)) return;
        event.preventDefault();
        const title = link.getAttribute('aria-label') || getText(link.closest('article')?.querySelector('h3')) || getText(link).slice(0, 100) || 'This meaningful piece';
        pendingProduct = { title, url: link.href };
        if (dialogProduct) dialogProduct.textContent = title;
        if (typeof dialog?.showModal === 'function') dialog.showModal();
        else if (window.confirm('Would you like to visit this product now?')) window.location.href = link.href;
      });

      window.addEventListener('storage', () => { readProgress(); renderShelf(); });
      applyDiscernment();
      applySabbath();
      renderShelf();
      readProgress();
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-sanctuary-house]')) initHouse(scope);
      scope.querySelectorAll('[data-weston-sanctuary-house]').forEach(initHouse);
    };
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-sanctuary-lament-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initLament = (root) => {
      if (!root || root.dataset.lamentReady === 'true') return;
      root.dataset.lamentReady = 'true';
      const tabs = [...root.querySelectorAll('[data-lament-tab]')];
      const panels = [...root.querySelectorAll('[data-lament-panel]')];

      const activate = (tab, focus = false) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % tabs.length;
          if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next], true);
        });
      });

      root.querySelectorAll('[data-release-letter]').forEach((button) => button.addEventListener('click', () => {
        const panel = button.closest('[data-lament-panel]');
        const letter = panel?.querySelector('[data-lament-letter]');
        const status = panel?.querySelector('[data-lament-status]');
        if (!letter || !letter.value.trim()) return;
        const finish = () => {
          letter.value = '';
          letter.classList.remove('is-releasing');
          if (status) status.textContent = root.dataset.releaseMessage || '';
          letter.focus();
        };
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else {
          letter.classList.add('is-releasing');
          window.setTimeout(finish, 720);
        }
      }));

      root.querySelectorAll('[data-download-letter]').forEach((button) => button.addEventListener('click', () => {
        const panel = button.closest('[data-lament-panel]');
        const letter = panel?.querySelector('[data-lament-letter]');
        const status = panel?.querySelector('[data-lament-status]');
        if (!letter || !letter.value.trim()) return;
        const blob = new Blob([letter.value], { type: 'text/plain;charset=utf-8' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${root.dataset.downloadName || 'private-lament'}.txt`;
        document.body.append(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(link.href), 1200);
        if (status) status.textContent = 'Downloaded. This feature does not submit your writing to Weston Goods; your device, browser, downloads, backups, extensions, or shared-device users may still retain or expose it.';
      }));

      root.querySelector('[data-lament-return]')?.addEventListener('click', () => {
        document.querySelector('[data-weston-sanctuary-house]')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-lament]')) initLament(scope);
      scope.querySelectorAll('[data-weston-lament]').forEach(initLament);
    };
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-sanctuary-network-launcher-2026"] && !Shopify.designMode) return;
  try {
    
  const initializeWestonExploreFallbacks = (scope = document) => {
    scope.querySelectorAll('[data-wsnl-fallback]').forEach((root) => {
      if (root.dataset.wsnlFallbackReady === 'true') return;
      root.dataset.wsnlFallbackReady = 'true';

      const trigger = root.querySelector('[data-wsnl-fallback-open]');
      const panel = root.querySelector('[data-wsnl-fallback-panel]');
      const closeButton = root.querySelector('[data-wsnl-fallback-close]');
      const findButton = root.querySelector('[data-wsnl-fallback-find]');

      if (!trigger || !panel || !closeButton || !findButton) return;

      document.documentElement.classList.remove('wsnl-worlds-ready', 'wsnl-menu-open', 'wsnl-panel-open');
      document.body?.classList.remove('wsnl-panel-open');
      document.documentElement.classList.add('wsnl-fallback-ready');

      const openPanel = () => {
        document.dispatchEvent(new CustomEvent('weston:surface-open', {
          detail: { surface: 'explore-weston-fallback' }
        }));
        panel.hidden = false;
        root.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        closeButton.focus({ preventScroll: true });
      };

      const closePanel = (restoreFocus = true) => {
        panel.hidden = true;
        root.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus && trigger.isConnected) trigger.focus({ preventScroll: true });
      };

      trigger.addEventListener('click', () => {
        if (panel.hidden) openPanel();
        else closePanel();
      });

      closeButton.addEventListener('click', () => closePanel());

      findButton.addEventListener('click', () => {
        closePanel(false);
        const constellation = document.querySelector('[data-wg-constellation]');
        if (constellation) {
          document.dispatchEvent(new CustomEvent('weston:surface-request', {
            detail: {
              surface: 'constellation',
              returnFocusTarget: trigger
            }
          }));
        } else {
          window.location.assign('/collections/new-arrivals');
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) closePanel();
      });

      document.addEventListener('pointerdown', (event) => {
        if (!panel.hidden && !root.contains(event.target)) closePanel(false);
      });

      document.addEventListener('weston:surface-open', (event) => {
        if (event.detail?.surface !== 'explore-weston-fallback' && !panel.hidden) closePanel(false);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWestonExploreFallbacks());
  } else {
    initializeWestonExploreFallbacks();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWestonExploreFallbacks(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-sanctuary-today-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const destinationSelectors = {
      reflect: '[data-weston-sanctuary]',
      read: '[data-living-bible]',
      journey: '[data-faith-paths]',
      lament: '[data-weston-lament]'
    };

    const initToday = (root) => {
      if (!root || root.dataset.todayReady === 'true') return;
      root.dataset.todayReady = 'true';
      const tabs = [...root.querySelectorAll('[data-today-tab]')];
      const panels = [...root.querySelectorAll('[data-today-panel]')];
      const dateNode = root.querySelector('[data-today-date]');

      if (dateNode) dateNode.textContent = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' }).format(new Date());

      const activate = (tab, focus = false) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.moment !== tab.dataset.moment; });
        if (focus) tab.focus();
      };

      const hour = new Date().getHours();
      const morningEnd = Number(root.dataset.morningEnd) || 11;
      const middayEnd = Number(root.dataset.middayEnd) || 17;
      const currentMoment = hour < morningEnd ? 'morning' : hour < middayEnd ? 'midday' : 'night';
      const suggested = tabs.find((tab) => tab.dataset.moment === currentMoment) || tabs[0];
      if (suggested) activate(suggested);

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % tabs.length;
          if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next], true);
        });
      });

      root.querySelectorAll('[data-enter-today]').forEach((button) => button.addEventListener('click', () => {
        const panel = button.closest('[data-today-panel]');
        const target = document.querySelector(destinationSelectors[panel?.dataset.destination]);
        target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }));

      root.querySelector('[data-open-house]')?.addEventListener('click', () => {
        document.querySelector('[data-weston-sanctuary-house]')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-sanctuary-today]')) initToday(scope);
      scope.querySelectorAll('[data-weston-sanctuary-today]').forEach(initToday);
    };
    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-sexy-edit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-weston-sexy-edit]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const toggle = root.querySelector('[data-weston-sexy-toggle]');
    const label = root.querySelector('[data-weston-sexy-label]');
    const storageKey = 'weston-occasion';
    const previousKey = 'weston-occasion-before-sexy';

    const connectTracks = () => {
      root.querySelectorAll('.weston-sexy-edit__collection').forEach((collection) => {
        const track = collection.querySelector('[data-sexy-track]');
        const previous = collection.querySelector('[data-sexy-previous]');
        const next = collection.querySelector('[data-sexy-next]');
        if (!track || !previous || !next || track.dataset.touchReady === 'true') return;
        track.dataset.touchReady = 'true';

        const updateButtons = () => {
          previous.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        };

        const move = (direction) => {
          track.scrollBy({ left: direction * Math.max(240, track.clientWidth * .76), behavior: 'smooth' });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);

        let startX = 0;
        let startY = 0;
        let startScroll = 0;
        let axis = '';
        let dragged = false;

        track.addEventListener('touchstart', (event) => {
          const touch = event.touches[0];
          if (!touch) return;
          startX = touch.clientX;
          startY = touch.clientY;
          startScroll = track.scrollLeft;
          axis = '';
          dragged = false;
        }, { passive: true, capture: true });

        track.addEventListener('touchmove', (event) => {
          const touch = event.touches[0];
          if (!touch) return;
          const deltaX = touch.clientX - startX;
          const deltaY = touch.clientY - startY;
          if (!axis && Math.max(Math.abs(deltaX), Math.abs(deltaY)) > 6) {
            axis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
          }
          if (axis !== 'x') return;
          event.preventDefault();
          dragged = true;
          track.scrollLeft = startScroll - deltaX;
        }, { passive: false, capture: true });

        track.addEventListener('click', (event) => {
          if (!dragged) return;
          event.preventDefault();
          event.stopPropagation();
          dragged = false;
        }, true);

        updateButtons();
      });
    };

    const apply = (occasion) => {
      const active = occasion === 'after-hours';
      root.classList.toggle('is-active', active);
      toggle.setAttribute('aria-pressed', String(active));
      label.textContent = active ? root.dataset.labelOn : root.dataset.labelOff;
    };

    const choose = (occasion) => {
      localStorage.setItem(storageKey, occasion);
      document.documentElement.dataset.westonOccasion = occasion;
      apply(occasion);
      window.dispatchEvent(new CustomEvent('weston:occasion-change', { detail: { occasion } }));
    };

    toggle.addEventListener('click', () => {
      const current = localStorage.getItem(storageKey) || 'everyday';
      if (current === 'after-hours') {
        choose(localStorage.getItem(previousKey) || 'everyday');
      } else {
        localStorage.setItem(previousKey, current);
        choose('after-hours');
      }
    });

    window.addEventListener('weston:occasion-change', (event) => apply(event.detail?.occasion || 'everyday'));
    connectTracks();
    apply(localStorage.getItem(storageKey) || 'everyday');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-shopping-memory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const memory = document.querySelector('[data-weston-memory]');
    if (!memory || memory.dataset.ready === 'true') return;
    memory.dataset.ready = 'true';

    const recentKey = 'weston-recent-products';
    const fitKey = 'weston-fit-passport';
    const trigger = memory.querySelector('[data-weston-memory-trigger]');
    const drawer = memory.querySelector('[data-weston-memory-drawer]');
    const backdrop = memory.querySelector('[data-weston-memory-backdrop]');
    const close = memory.querySelector('[data-weston-memory-close]');
    const count = memory.querySelector('[data-weston-memory-count]');
    const recentRoot = memory.querySelector('[data-weston-memory-recent]');
    const tabs = Array.from(memory.querySelectorAll('[data-weston-memory-tab]'));
    const panels = Array.from(memory.querySelectorAll('[data-weston-memory-panel]'));
    const clear = memory.querySelector('[data-weston-memory-clear]');
    const fitForm = memory.querySelector('[data-weston-fit-form]');
    const fitStatus = memory.querySelector('[data-weston-fit-status]');
    const productScript = memory.querySelector('[data-weston-current-product]');
    let currentProduct = null;

    const readJson = (key, fallback) => {
      try { return JSON.parse(localStorage.getItem(key)) || fallback; } catch (error) { return fallback; }
    };

    const writeJson = (key, value) => {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (error) { return; }
    };

    if (productScript) {
      try { currentProduct = JSON.parse(productScript.textContent); } catch (error) { currentProduct = null; }
    }

    const updateFitStatus = (fit) => {
      if (!fitStatus || !fit || !fit.size) return;
      if (!currentProduct) {
        fitStatus.textContent = memory.dataset.fitSaved.replace('[size]', fit.size);
        return;
      }
      if (!currentProduct.sizes.length) {
        fitStatus.textContent = memory.dataset.noSize.replace('[size]', fit.size);
        return;
      }
      const available = currentProduct.sizes.some((size) => size.toLowerCase() === fit.size.toLowerCase());
      fitStatus.textContent = (available ? memory.dataset.sizeAvailable : memory.dataset.sizeUnavailable).replace('[size]', fit.size);
    };

    const renderRecent = () => {
      const items = readJson(recentKey, []);
      count.textContent = String(items.length);
      recentRoot.textContent = '';
      if (!items.length) {
        const empty = document.createElement('p');
        empty.className = 'weston-memory__empty-message';
        empty.textContent = memory.dataset.recentEmpty;
        recentRoot.appendChild(empty);
        return;
      }

      items.forEach((item) => {
        const card = document.createElement('a');
        card.className = 'weston-memory__recent-card';
        card.href = item.url;
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          image.loading = 'lazy';
          card.appendChild(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'weston-memory__recent-image-empty';
          card.appendChild(placeholder);
        }
        const title = document.createElement('strong');
        title.textContent = item.title;
        const price = document.createElement('small');
        price.textContent = item.price;
        card.append(title, price);
        recentRoot.appendChild(card);
      });
    };

    if (currentProduct) {
      const items = readJson(recentKey, []).filter((item) => String(item.id) !== String(currentProduct.id));
      items.unshift(currentProduct);
      writeJson(recentKey, items.slice(0, 12));
    }

    const openDrawer = () => {
      drawer.hidden = false;
      backdrop.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      close.focus();
    };

    const closeDrawer = () => {
      drawer.hidden = true;
      backdrop.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    const activateTab = (name) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.westonMemoryTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel) => {
        const active = panel.dataset.westonMemoryPanel === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    const fit = readJson(fitKey, {});
    if (fitForm) {
      fitForm.elements.size.value = fit.size || '';
      fitForm.elements.fit.value = fit.fit || 'regular';
      updateFitStatus(fit);
      fitForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const nextFit = { size: fitForm.elements.size.value, fit: fitForm.elements.fit.value };
        writeJson(fitKey, nextFit);
        updateFitStatus(nextFit);
      });
    }

    trigger.addEventListener('click', openDrawer);
    close.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    tabs.forEach((tab) => tab.addEventListener('click', () => activateTab(tab.dataset.westonMemoryTab)));
    clear.addEventListener('click', () => {
      writeJson(recentKey, []);
      renderRecent();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
    });

    renderRecent();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-shopping-pulse-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.pulseReady === 'true') return;
      root.dataset.pulseReady = 'true';
      const waiting = root.querySelector('[data-pulse-waiting]');
      const choices = Array.from(root.querySelectorAll('[data-pulse-choice]'));
      const panels = Array.from(root.querySelectorAll('[data-pulse-panel]'));
      const storageKey = root.dataset.storageKey;

      const select = (signal) => {
        const button = choices.find((choice) => choice.dataset.pulseChoice === signal);
        const panel = panels.find((item) => item.dataset.pulsePanel === signal);
        if (!button || !panel) return;
        choices.forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
        panels.forEach((item) => { item.hidden = item !== panel; });
        waiting.hidden = true;
        try { window.localStorage.setItem(storageKey, signal); } catch (error) {}
      };

      root.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-pulse-choice]');
        if (choice) {
          select(choice.dataset.pulseChoice);
          return;
        }

        const scrollButton = event.target.closest('[data-pulse-scroll]');
        if (scrollButton) {
          const target = document.querySelector(scrollButton.dataset.pulseScroll);
          if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          return;
        }

        const saveButton = event.target.closest('[data-pulse-save]');
        if (saveButton) {
          const decisionButton = document.querySelector('[data-decision-current-product-button], [data-decision-edit-add][data-decision-current="true"]');
          if (decisionButton) decisionButton.click();
        }
      });

      try {
        const saved = window.localStorage.getItem(storageKey);
        if (saved) select(saved);
      } catch (error) {}
    };

    document.querySelectorAll('[data-weston-pulse]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-weston-pulse]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-style-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.atlasReady === 'true') return;
      root.dataset.atlasReady = 'true';

      const storageKey = root.dataset.storageKey;
      const launch = root.querySelector('[data-atlas-launch]');
      const quiz = root.querySelector('[data-atlas-quiz]');
      const result = root.querySelector('[data-atlas-result]');
      const steps = Array.from(root.querySelectorAll('[data-atlas-step]'));
      const progressCurrent = root.querySelector('[data-atlas-progress-current]');
      const progressLine = root.querySelector('[data-atlas-progress-line]');
      const progressName = root.querySelector('[data-atlas-progress-name]');
      const code = root.querySelector('[data-atlas-code]');
      const profile = root.querySelector('[data-atlas-profile]');
      const startButton = root.querySelector('[data-atlas-start]');
      const worlds = Array.from(root.querySelectorAll('[data-atlas-world]'));
      const choiceButtons = Array.from(root.querySelectorAll('[data-atlas-choice]'));
      const state = { audience: '', world: '', occasion: '', budget: '', minPrice: 0, maxPrice: 999999999, occasionWorld: '' };
      const worldCodes = { 'main-character': 'MC', 'off-duty': 'OD', escape: 'ES', 'after-dark': 'AD' };
      const audienceCodes = { women: 'W', men: 'M', both: 'B' };
      const budgetCodes = { 'under-50': 'U50', '50-75': '75', '75-100': '100', '100-plus': 'P' };
      let activeStep = 0;

      choiceButtons.forEach((choice) => choice.setAttribute('aria-pressed', 'false'));

      const publish = (name, payload) => {
        const eventPayload = Object.assign({ source: 'theme', version: '2' }, payload || {});
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            const request = window.Shopify.analytics.publish(`weston_goods:${name}`, eventPayload);
            if (request && typeof request.catch === 'function') request.catch(() => {});
          }
        } catch (error) {}
        try {
          if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: `weston_goods:${name}` }, eventPayload));
        } catch (error) {}
      };

      const readProfile = () => {
        try {
          const saved = JSON.parse(window.localStorage.getItem(storageKey));
          if (!saved || !audienceCodes[saved.audience] || !worldCodes[saved.world] || !budgetCodes[saved.budget]) return null;
          return saved;
        } catch (error) {
          return null;
        }
      };

      const saveProfile = () => {
        try {
          window.localStorage.setItem(storageKey, JSON.stringify({
            audience: state.audience,
            world: state.world,
            occasion: state.occasion,
            budget: state.budget,
            minPrice: state.minPrice,
            maxPrice: state.maxPrice,
            occasionWorld: state.occasionWorld
          }));
        } catch (error) {}
      };

      const labelFor = (key, value) => {
        const button = root.querySelector(`[data-atlas-choice="${key}"][data-value="${value}"]`);
        const label = button ? button.querySelector('strong') : null;
        return label ? label.textContent.trim() : value;
      };

      const showStep = (index) => {
        activeStep = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== activeStep; });
        progressCurrent.textContent = String(activeStep + 1).padStart(2, '0');
        progressLine.style.transform = `scaleX(${(activeStep + 1) / steps.length})`;
        const legendKicker = steps[activeStep].querySelector('legend span');
        progressName.textContent = legendKicker ? legendKicker.textContent : '';
      };

      const start = (trackStart = true) => {
        launch.hidden = true;
        result.hidden = true;
        quiz.hidden = false;
        showStep(0);
        if (trackStart) publish('style_finder_started', {});
        window.requestAnimationFrame(() => {
          const firstChoice = steps[0].querySelector('button');
          if (firstChoice) firstChoice.focus({ preventScroll: true });
        });
      };

      const selectedWorld = () => {
        const scores = { 'main-character': 0, 'off-duty': 0, escape: 0, 'after-dark': 0 };
        if (state.world && Object.prototype.hasOwnProperty.call(scores, state.world)) scores[state.world] += 2;
        if (state.occasionWorld && Object.prototype.hasOwnProperty.call(scores, state.occasionWorld)) scores[state.occasionWorld] += 1;
        return Object.keys(scores).sort((a, b) => scores[b] - scores[a])[0];
      };

      const showProducts = (world) => {
        const cards = Array.from(world.querySelectorAll('[data-atlas-product]'));
        const audienceMatches = cards.filter((card) => state.audience === 'both' || card.dataset.audience === state.audience);
        const exactMatches = audienceMatches.filter((card) => {
          const price = Number(card.dataset.price || 0);
          return price >= state.minPrice && price <= state.maxPrice;
        });
        let matches = exactMatches;
        if (!matches.length) matches = audienceMatches;
        if (state.audience === 'both') {
          const women = matches.filter((card) => card.dataset.audience === 'women');
          const men = matches.filter((card) => card.dataset.audience === 'men');
          const mixed = [];
          for (let index = 0; index < Math.max(women.length, men.length); index += 1) {
            if (women[index]) mixed.push(women[index]);
            if (men[index]) mixed.push(men[index]);
          }
          matches = mixed;
        }
        const visible = matches.slice(0, 4);
        cards.forEach((card) => { card.hidden = !visible.includes(card); });
        const countLabel = world.querySelector('[data-atlas-result-count]');
        const empty = world.querySelector('[data-atlas-empty]');
        countLabel.textContent = root.dataset.resultsLabel.replace('[count]', String(visible.length));
        empty.hidden = exactMatches.length !== 0;
      };

      const renderResult = (restored = false) => {
        state.world = selectedWorld();
        saveProfile();
        const activeWorld = worlds.find((world) => world.dataset.atlasWorld === state.world) || worlds[0];
        worlds.forEach((world) => { world.hidden = world !== activeWorld; });
        activeWorld.querySelectorAll('[data-atlas-result-link]').forEach((link) => {
          link.hidden = state.audience !== 'both' && link.dataset.atlasResultLink !== state.audience;
        });
        showProducts(activeWorld);
        code.textContent = `WG-${worldCodes[state.world]}-${audienceCodes[state.audience]}-${budgetCodes[state.budget]}`;
        profile.replaceChildren();
        ['audience', 'world', 'occasion', 'budget'].forEach((key) => {
          const chip = document.createElement('span');
          chip.textContent = labelFor(key, state[key]);
          profile.append(chip);
        });
        launch.hidden = true;
        quiz.hidden = true;
        result.hidden = false;
        document.dispatchEvent(new CustomEvent('weston:worldrequest', { detail: { world: state.world, audience: state.audience } }));
        if (!restored) {
          publish('style_finder_completed', { audience: state.audience, world: state.world, occasion: state.occasion, budget: state.budget, style_code: code.textContent });
          result.focus({ preventScroll: true });
          result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      };

      const applyChoice = (button) => {
        const key = button.dataset.atlasChoice;
        state[key] = button.dataset.value;
        if (key === 'occasion') state.occasionWorld = button.dataset.world || '';
        if (key === 'budget') {
          state.minPrice = Number(button.dataset.min || 0);
          state.maxPrice = Number(button.dataset.max || 999999999);
        }
        root.querySelectorAll(`[data-atlas-choice="${key}"]`).forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
        if (activeStep < steps.length - 1) {
          showStep(activeStep + 1);
          window.requestAnimationFrame(() => {
            const next = steps[activeStep].querySelector('button');
            if (next) next.focus({ preventScroll: true });
          });
        } else {
          renderResult(false);
        }
      };

      root.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-atlas-choice]');
        if (choice) {
          applyChoice(choice);
          return;
        }
        if (event.target.closest('[data-atlas-start]')) {
          start(true);
          return;
        }
        if (event.target.closest('[data-atlas-back]')) {
          if (activeStep === 0) {
            quiz.hidden = true;
            launch.hidden = false;
          } else {
            showStep(activeStep - 1);
          }
          return;
        }
        if (event.target.closest('[data-atlas-edit]')) {
          start(false);
          return;
        }
        if (event.target.closest('[data-atlas-surprise]')) {
          const values = {
            audience: ['women', 'men', 'both'],
            world: ['main-character', 'off-duty', 'escape', 'after-dark'],
            occasion: ['everyday', 'event', 'getaway', 'evening'],
            budget: ['under-50', '50-75', '75-100', '100-plus']
          };
          Object.keys(values).forEach((key) => {
            const value = values[key][Math.floor(Math.random() * values[key].length)];
            const button = root.querySelector(`[data-atlas-choice="${key}"][data-value="${value}"]`);
            state[key] = value;
            if (key === 'occasion') state.occasionWorld = button.dataset.world || '';
            if (key === 'budget') {
              state.minPrice = Number(button.dataset.min || 0);
              state.maxPrice = Number(button.dataset.max || 999999999);
            }
          });
          renderResult(false);
        }
      });

      root.querySelectorAll('[data-atlas-result-link], [data-atlas-product] a').forEach((link) => {
        link.addEventListener('click', () => publish('style_result_shopped', { audience: state.audience, world: state.world, budget: state.budget }));
      });

      const saved = readProfile();
      if (saved) {
        Object.assign(state, saved);
        choiceButtons.forEach((choice) => {
          const key = choice.dataset.atlasChoice;
          choice.setAttribute('aria-pressed', String(state[key] === choice.dataset.value));
        });
        startButton.textContent = root.dataset.resumeLabel;
        renderResult(true);
      } else {
        showStep(0);
      }
    };

    document.querySelectorAll('[data-weston-atlas]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-weston-atlas]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-trail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-weston-trail]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const key = 'weston-trail-v1';
    const savedKey = 'weston-saved-stories-v1';
    const trigger = root.querySelector('[data-weston-trail-trigger]');
    const drawer = root.querySelector('[data-weston-trail-drawer]');
    const backdrop = root.querySelector('[data-weston-trail-backdrop]');
    const close = root.querySelector('[data-weston-trail-close]');
    const current = JSON.parse(root.querySelector('[data-weston-trail-page]').textContent);
    const read = (storageKey, fallback) => { try { return JSON.parse(localStorage.getItem(storageKey)) || fallback; } catch (error) { return fallback; } };
    const write = (storageKey, value) => { try { localStorage.setItem(storageKey, JSON.stringify(value)); } catch (error) { return; } };
    let trail = read(key, []);
    trail = trail.filter((item) => item.key !== current.key);
    trail.unshift({...current, visitedAt: Date.now()});
    trail = trail.slice(0, 24);
    write(key, trail);

    const render = () => {
      const kinds = { piece: 0, edit: 0, story: 0, discover: 0 };
      trail.forEach((item) => { kinds[item.kind in kinds ? item.kind : 'discover'] += 1; });
      const count = trail.length;
      const level = Math.min(9, Math.floor(count / 3) + 1);
      root.querySelector('[data-weston-trail-level]').textContent = String(level).padStart(2, '0');
      root.querySelector('[data-weston-trail-count]').textContent = String(count);
      root.querySelector('[data-weston-trail-meter]').style.width = `${Math.min(100, (count / 12) * 100)}%`;
      root.querySelector('[data-weston-trail-status]').textContent = count >= 12 ? root.dataset.completeText : root.dataset.milestoneText.replace('[count]', String(Math.max(0, 12 - count)));
      Object.entries(kinds).forEach(([kind, value]) => {
        const node = root.querySelector(`[data-trail-node="${kind}"]`);
        node.classList.toggle('is-found', value > 0);
        root.querySelector(`[data-trail-node-count="${kind}"]`).textContent = String(value);
      });
      const recent = root.querySelector('[data-weston-trail-recent]');
      recent.textContent = '';
      if (!trail.length) {
        const empty = document.createElement('p'); empty.className = 'weston-trail__empty'; empty.textContent = root.dataset.emptyText; recent.appendChild(empty); return;
      }
      trail.slice(0, 6).forEach((item) => {
        const card = document.createElement('a'); card.className = 'weston-trail__card'; card.href = item.url;
        if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = item.title; image.loading = 'lazy'; card.appendChild(image); }
        else { const image = document.createElement('span'); image.className = 'weston-trail__card-placeholder'; card.appendChild(image); }
        const title = document.createElement('strong'); title.textContent = item.title;
        const tag = document.createElement('small'); tag.textContent = item.tag;
        card.append(title, tag); recent.appendChild(card);
      });
    };

    const open = () => { drawer.hidden = false; backdrop.hidden = false; trigger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; close.focus(); };
    const shut = () => { drawer.hidden = true; backdrop.hidden = true; trigger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; };
    trigger.addEventListener('click', open); close.addEventListener('click', shut); backdrop.addEventListener('click', shut);
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !drawer.hidden) shut(); });
    root.querySelector('[data-weston-trail-clear]').addEventListener('click', () => { trail = []; write(key, trail); render(); });

    const save = root.querySelector('[data-weston-save-story]');
    if (save) {
      let saved = read(savedKey, []);
      const updateSave = () => { const isSaved = saved.some((item) => item.key === current.key); save.classList.toggle('is-saved', isSaved); if (isSaved) save.lastChild.textContent = ` ${root.dataset.savedText}`; };
      save.addEventListener('click', () => { const exists = saved.some((item) => item.key === current.key); saved = exists ? saved.filter((item) => item.key !== current.key) : [current, ...saved].slice(0, 20); write(savedKey, saved); updateSave(); });
      updateSave();
    }

    const progress = root.querySelector('[data-weston-reading-progress]');
    if (progress) {
      const updateProgress = () => { const total = document.documentElement.scrollHeight - window.innerHeight; const value = total > 0 ? window.scrollY / total : 0; progress.style.transform = `scaleX(${Math.min(1, Math.max(0, value))})`; };
      updateProgress(); window.addEventListener('scroll', updateProgress, { passive: true }); window.addEventListener('resize', updateProgress);
    }
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-verse-card-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrapCanvasText = (context, text, maxWidth) => {
      const words = text.trim().split(/\s+/);
      const lines = [];
      let line = '';
      words.forEach((word) => {
        const candidate = line ? `${line} ${word}` : word;
        if (context.measureText(candidate).width > maxWidth && line) {
          lines.push(line);
          line = word;
        } else {
          line = candidate;
        }
      });
      if (line) lines.push(line);
      return lines;
    };

    const initVerseCard = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const preview = root.querySelector('[data-card-preview]');
      const verseOutput = root.querySelector('[data-card-verse]');
      const referenceOutput = root.querySelector('[data-card-reference]');
      const status = root.querySelector('[data-card-status]');
      const contextReference = root.querySelector('[data-context-reference]');
      const contextText = root.querySelector('[data-context-text]');
      const contextSpeaker = root.querySelector('[data-context-speaker]');
      const contextAudience = root.querySelector('[data-context-audience]');
      const contextNotPromise = root.querySelector('[data-context-not-promise]');
      let colors = { background: '#171019', foreground: '#fffaf0', accent: '#e4c479' };

      root.querySelectorAll('[data-verse-option]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-verse-option]').forEach((option) => {
            option.classList.remove('is-active');
            option.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          verseOutput.textContent = button.dataset.verse || '';
          referenceOutput.textContent = button.dataset.reference || '';
          if (contextReference) contextReference.textContent = button.dataset.reference || '';
          if (contextText) contextText.textContent = button.dataset.context || '';
          if (contextSpeaker) contextSpeaker.textContent = button.dataset.speaker || '';
          if (contextAudience) contextAudience.textContent = button.dataset.audience || '';
          if (contextNotPromise) contextNotPromise.textContent = button.dataset.notPromise || '';
          status.textContent = '';
        });
      });

      root.querySelectorAll('[data-card-palette]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-card-palette]').forEach((palette) => {
            palette.classList.remove('is-active');
            palette.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          colors = {
            background: button.dataset.background,
            foreground: button.dataset.foreground,
            accent: button.dataset.accent
          };
          preview.style.setProperty('--card-background', colors.background);
          preview.style.setProperty('--card-foreground', colors.foreground);
          preview.style.setProperty('--card-accent', colors.accent);
          status.textContent = '';
        });
      });

      const createCard = () => {
        const canvas = document.createElement('canvas');
        canvas.width = 1080;
        canvas.height = 1350;
        const context = canvas.getContext('2d');
        const gradient = context.createRadialGradient(540, 520, 20, 540, 520, 720);
        gradient.addColorStop(0, colors.accent + '38');
        gradient.addColorStop(1, colors.background);
        context.fillStyle = gradient;
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.strokeStyle = colors.accent;
        context.globalAlpha = 0.65;
        context.lineWidth = 2;
        context.strokeRect(42, 42, 996, 1266);
        context.globalAlpha = 1;

        context.fillStyle = colors.accent;
        context.textAlign = 'center';
        context.font = '700 22px Arial, sans-serif';
        context.fillText('WESTON GOODS  •  THE SANCTUARY', 540, 116);

        context.lineWidth = 3;
        context.strokeStyle = colors.accent;
        context.beginPath();
        context.moveTo(540, 176);
        context.lineTo(540, 290);
        context.moveTo(500, 216);
        context.lineTo(580, 216);
        context.stroke();

        context.fillStyle = colors.foreground;
        context.font = '600 58px Georgia, serif';
        const lines = wrapCanvasText(context, verseOutput.textContent || '', 820);
        const lineHeight = 74;
        const startY = 650 - ((lines.length - 1) * lineHeight) / 2;
        lines.forEach((line, index) => context.fillText(line, 540, startY + index * lineHeight));

        context.fillStyle = colors.accent;
        context.font = '700 24px Arial, sans-serif';
        context.fillText((referenceOutput.textContent || '').toUpperCase(), 540, 1070);
        context.fillStyle = colors.foreground;
        context.font = '700 19px Arial, sans-serif';
        context.fillText('WESTONGOODS.COM', 540, 1238);
        return canvas;
      };

      const cardBlob = () => new Promise((resolve, reject) => {
        createCard().toBlob((blob) => blob ? resolve(blob) : reject(new Error('card')), 'image/png', 1);
      });

      const downloadBlob = (blob) => {
        const link = document.createElement('a');
        const name = (referenceOutput.textContent || 'verse').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        link.href = URL.createObjectURL(blob);
        link.download = `weston-sanctuary-${name || 'verse'}.png`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(link.href), 1200);
      };

      root.querySelector('[data-download-card]')?.addEventListener('click', async () => {
        try {
          const blob = await cardBlob();
          downloadBlob(blob);
          status.textContent = status.dataset.readyLabel || '';
        } catch (error) {
          status.textContent = status.dataset.errorLabel || '';
        }
      });

      root.querySelector('[data-share-card]')?.addEventListener('click', async () => {
        try {
          const blob = await cardBlob();
          const file = new File([blob], 'weston-sanctuary-verse.png', { type: 'image/png' });
          if (navigator.share && navigator.canShare?.({ files: [file] })) {
            await navigator.share({
              title: referenceOutput.textContent || '',
              text: `${verseOutput.textContent || ''} — ${referenceOutput.textContent || ''}`,
              files: [file]
            });
          } else {
            downloadBlob(blob);
            status.textContent = status.dataset.readyLabel || '';
          }
        } catch (error) {
          if (error?.name !== 'AbortError') status.textContent = status.dataset.errorLabel || '';
        }
      });
    };

    const initAll = (scope = document) => {
      if (scope.matches?.('[data-weston-verse-card]')) initVerseCard(scope);
      scope.querySelectorAll('[data-weston-verse-card]').forEach(initVerseCard);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weston-world-engine"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.documentElement;
    const switcher = document.querySelector('[data-weston-world-switcher]');
    if (!switcher || switcher.dataset.ready === 'true') return;
    switcher.dataset.ready = 'true';

    const storageKey = 'weston-world';
    const trigger = switcher.querySelector('[data-weston-world-trigger]');
    const menu = switcher.querySelector('[data-weston-world-menu]');
    const close = switcher.querySelector('[data-weston-world-close]');
    const current = switcher.querySelector('[data-weston-world-current]');
    const options = Array.from(switcher.querySelectorAll('[data-weston-world-option]'));
    const allowed = options.map((option) => option.dataset.westonWorldOption);

    const labelFor = (world) => {
      const option = options.find((item) => item.dataset.westonWorldOption === world);
      return option ? option.dataset.worldLabel : '';
    };

    const applyWorld = (world, persist = false, announce = true) => {
      if (!allowed.includes(world)) return;
      root.dataset.westonWorld = world;
      if (current) current.textContent = labelFor(world);
      options.forEach((option) => option.classList.toggle('is-active', option.dataset.westonWorldOption === world));
      if (persist) localStorage.setItem(storageKey, world);
      if (announce) window.dispatchEvent(new CustomEvent('weston:worldchange', { detail: { world, persist } }));
    };

    const openMenu = () => {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      const active = menu.querySelector('.is-active') || options[0];
      if (active) active.focus();
    };

    const closeMenu = () => {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    const saved = localStorage.getItem(storageKey);
    applyWorld(allowed.includes(saved) ? saved : allowed[0], false, false);

    trigger.addEventListener('click', () => menu.hidden ? openMenu() : closeMenu());
    close.addEventListener('click', closeMenu);
    options.forEach((option) => option.addEventListener('click', () => {
      applyWorld(option.dataset.westonWorldOption, true);
      closeMenu();
    }));

    window.addEventListener('weston:worldrequest', (event) => {
      applyWorld(event.detail.world, Boolean(event.detail.persist));
    });

    document.addEventListener('click', (event) => {
      if (!menu.hidden && !switcher.contains(event.target)) closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) {
        closeMenu();
        trigger.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
